/* eslint-disable */
import { languageTag } from "./runtime.js"
import * as de_DE from "./messages/de-DE.js"
import * as en_AU from "./messages/en-AU.js"
import * as en_GB from "./messages/en-GB.js"
import * as en_US from "./messages/en-US.js"
import * as es_ES from "./messages/es-ES.js"
import * as fr_FR from "./messages/fr-FR.js"
import * as it_IT from "./messages/it-IT.js"
import * as ko_KR from "./messages/ko-KR.js"
import * as pt_BR from "./messages/pt-BR.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.langCodes_locale,
		"en-AU": en_AU.langCodes_locale,
		"en-GB": en_GB.langCodes_locale,
		"en-US": en_US.langCodes_locale,
		"es-ES": es_ES.langCodes_locale,
		"fr-FR": fr_FR.langCodes_locale,
		"it-IT": it_IT.langCodes_locale,
		"ko-KR": ko_KR.langCodes_locale,
		"pt-BR": pt_BR.langCodes_locale
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.langCodes_pathPrefix,
		"en-AU": en_AU.langCodes_pathPrefix,
		"en-GB": en_GB.langCodes_pathPrefix,
		"en-US": en_US.langCodes_pathPrefix,
		"es-ES": es_ES.langCodes_pathPrefix,
		"fr-FR": fr_FR.langCodes_pathPrefix,
		"it-IT": it_IT.langCodes_pathPrefix,
		"ko-KR": ko_KR.langCodes_pathPrefix,
		"pt-BR": pt_BR.langCodes_pathPrefix
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.langCodes_localeLowerCase,
		"en-AU": en_AU.langCodes_localeLowerCase,
		"en-GB": en_GB.langCodes_localeLowerCase,
		"en-US": en_US.langCodes_localeLowerCase,
		"es-ES": es_ES.langCodes_localeLowerCase,
		"fr-FR": fr_FR.langCodes_localeLowerCase,
		"it-IT": it_IT.langCodes_localeLowerCase,
		"ko-KR": ko_KR.langCodes_localeLowerCase,
		"pt-BR": pt_BR.langCodes_localeLowerCase
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.langCodes_recaptchaLanguage,
		"en-AU": en_AU.langCodes_recaptchaLanguage,
		"en-GB": en_GB.langCodes_recaptchaLanguage,
		"en-US": en_US.langCodes_recaptchaLanguage,
		"es-ES": es_ES.langCodes_recaptchaLanguage,
		"fr-FR": fr_FR.langCodes_recaptchaLanguage,
		"it-IT": it_IT.langCodes_recaptchaLanguage,
		"ko-KR": ko_KR.langCodes_recaptchaLanguage,
		"pt-BR": pt_BR.langCodes_recaptchaLanguage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.langCodes_timezone,
		"en-AU": en_AU.langCodes_timezone,
		"en-GB": en_GB.langCodes_timezone,
		"en-US": en_US.langCodes_timezone,
		"es-ES": es_ES.langCodes_timezone,
		"fr-FR": fr_FR.langCodes_timezone,
		"it-IT": it_IT.langCodes_timezone,
		"ko-KR": ko_KR.langCodes_timezone,
		"pt-BR": pt_BR.langCodes_timezone
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.alertBar_dismiss,
		"en-AU": en_AU.alertBar_dismiss,
		"en-GB": en_GB.alertBar_dismiss,
		"en-US": en_US.alertBar_dismiss,
		"es-ES": es_ES.alertBar_dismiss,
		"fr-FR": fr_FR.alertBar_dismiss,
		"it-IT": it_IT.alertBar_dismiss,
		"ko-KR": ko_KR.alertBar_dismiss,
		"pt-BR": pt_BR.alertBar_dismiss
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_skipButton_skipContent,
		"en-AU": en_AU.atoms_skipButton_skipContent,
		"en-GB": en_GB.atoms_skipButton_skipContent,
		"en-US": en_US.atoms_skipButton_skipContent,
		"es-ES": es_ES.atoms_skipButton_skipContent,
		"fr-FR": fr_FR.atoms_skipButton_skipContent,
		"it-IT": it_IT.atoms_skipButton_skipContent,
		"ko-KR": ko_KR.atoms_skipButton_skipContent,
		"pt-BR": pt_BR.atoms_skipButton_skipContent
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_slideIndicator_currentSlide,
		"en-AU": en_AU.atoms_slideIndicator_currentSlide,
		"en-GB": en_GB.atoms_slideIndicator_currentSlide,
		"en-US": en_US.atoms_slideIndicator_currentSlide,
		"es-ES": es_ES.atoms_slideIndicator_currentSlide,
		"fr-FR": fr_FR.atoms_slideIndicator_currentSlide,
		"it-IT": it_IT.atoms_slideIndicator_currentSlide,
		"ko-KR": ko_KR.atoms_slideIndicator_currentSlide,
		"pt-BR": pt_BR.atoms_slideIndicator_currentSlide
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_slideIndicator_goToSlide,
		"en-AU": en_AU.atoms_slideIndicator_goToSlide,
		"en-GB": en_GB.atoms_slideIndicator_goToSlide,
		"en-US": en_US.atoms_slideIndicator_goToSlide,
		"es-ES": es_ES.atoms_slideIndicator_goToSlide,
		"fr-FR": fr_FR.atoms_slideIndicator_goToSlide,
		"it-IT": it_IT.atoms_slideIndicator_goToSlide,
		"ko-KR": ko_KR.atoms_slideIndicator_goToSlide,
		"pt-BR": pt_BR.atoms_slideIndicator_goToSlide
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleMeta_estimated,
		"en-AU": en_AU.molecules_articleMeta_estimated,
		"en-GB": en_GB.molecules_articleMeta_estimated,
		"en-US": en_US.molecules_articleMeta_estimated,
		"es-ES": es_ES.molecules_articleMeta_estimated,
		"fr-FR": fr_FR.molecules_articleMeta_estimated,
		"it-IT": it_IT.molecules_articleMeta_estimated,
		"ko-KR": ko_KR.molecules_articleMeta_estimated,
		"pt-BR": pt_BR.molecules_articleMeta_estimated
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleMeta_minuteRead,
		"en-AU": en_AU.molecules_articleMeta_minuteRead,
		"en-GB": en_GB.molecules_articleMeta_minuteRead,
		"en-US": en_US.molecules_articleMeta_minuteRead,
		"es-ES": es_ES.molecules_articleMeta_minuteRead,
		"fr-FR": fr_FR.molecules_articleMeta_minuteRead,
		"it-IT": it_IT.molecules_articleMeta_minuteRead,
		"ko-KR": ko_KR.molecules_articleMeta_minuteRead,
		"pt-BR": pt_BR.molecules_articleMeta_minuteRead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleMeta_updated,
		"en-AU": en_AU.molecules_articleMeta_updated,
		"en-GB": en_GB.molecules_articleMeta_updated,
		"en-US": en_US.molecules_articleMeta_updated,
		"es-ES": es_ES.molecules_articleMeta_updated,
		"fr-FR": fr_FR.molecules_articleMeta_updated,
		"it-IT": it_IT.molecules_articleMeta_updated,
		"ko-KR": ko_KR.molecules_articleMeta_updated,
		"pt-BR": pt_BR.molecules_articleMeta_updated
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_headline,
		"en-AU": en_AU.molecules_articleVoteForm_headline,
		"en-GB": en_GB.molecules_articleVoteForm_headline,
		"en-US": en_US.molecules_articleVoteForm_headline,
		"es-ES": es_ES.molecules_articleVoteForm_headline,
		"fr-FR": fr_FR.molecules_articleVoteForm_headline,
		"it-IT": it_IT.molecules_articleVoteForm_headline,
		"ko-KR": ko_KR.molecules_articleVoteForm_headline,
		"pt-BR": pt_BR.molecules_articleVoteForm_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_yes,
		"en-AU": en_AU.molecules_articleVoteForm_yes,
		"en-GB": en_GB.molecules_articleVoteForm_yes,
		"en-US": en_US.molecules_articleVoteForm_yes,
		"es-ES": es_ES.molecules_articleVoteForm_yes,
		"fr-FR": fr_FR.molecules_articleVoteForm_yes,
		"it-IT": it_IT.molecules_articleVoteForm_yes,
		"ko-KR": ko_KR.molecules_articleVoteForm_yes,
		"pt-BR": pt_BR.molecules_articleVoteForm_yes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_no,
		"en-AU": en_AU.molecules_articleVoteForm_no,
		"en-GB": en_GB.molecules_articleVoteForm_no,
		"en-US": en_US.molecules_articleVoteForm_no,
		"es-ES": es_ES.molecules_articleVoteForm_no,
		"fr-FR": fr_FR.molecules_articleVoteForm_no,
		"it-IT": it_IT.molecules_articleVoteForm_no,
		"ko-KR": ko_KR.molecules_articleVoteForm_no,
		"pt-BR": pt_BR.molecules_articleVoteForm_no
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_success,
		"en-AU": en_AU.molecules_articleVoteForm_success,
		"en-GB": en_GB.molecules_articleVoteForm_success,
		"en-US": en_US.molecules_articleVoteForm_success,
		"es-ES": es_ES.molecules_articleVoteForm_success,
		"fr-FR": fr_FR.molecules_articleVoteForm_success,
		"it-IT": it_IT.molecules_articleVoteForm_success,
		"ko-KR": ko_KR.molecules_articleVoteForm_success,
		"pt-BR": pt_BR.molecules_articleVoteForm_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_thanks,
		"en-AU": en_AU.molecules_articleVoteForm_thanks,
		"en-GB": en_GB.molecules_articleVoteForm_thanks,
		"en-US": en_US.molecules_articleVoteForm_thanks,
		"es-ES": es_ES.molecules_articleVoteForm_thanks,
		"fr-FR": fr_FR.molecules_articleVoteForm_thanks,
		"it-IT": it_IT.molecules_articleVoteForm_thanks,
		"ko-KR": ko_KR.molecules_articleVoteForm_thanks,
		"pt-BR": pt_BR.molecules_articleVoteForm_thanks
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_furtherAssistance,
		"en-AU": en_AU.molecules_articleVoteForm_furtherAssistance,
		"en-GB": en_GB.molecules_articleVoteForm_furtherAssistance,
		"en-US": en_US.molecules_articleVoteForm_furtherAssistance,
		"es-ES": es_ES.molecules_articleVoteForm_furtherAssistance,
		"fr-FR": fr_FR.molecules_articleVoteForm_furtherAssistance,
		"it-IT": it_IT.molecules_articleVoteForm_furtherAssistance,
		"ko-KR": ko_KR.molecules_articleVoteForm_furtherAssistance,
		"pt-BR": pt_BR.molecules_articleVoteForm_furtherAssistance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_contactSupport,
		"en-AU": en_AU.molecules_articleVoteForm_contactSupport,
		"en-GB": en_GB.molecules_articleVoteForm_contactSupport,
		"en-US": en_US.molecules_articleVoteForm_contactSupport,
		"es-ES": es_ES.molecules_articleVoteForm_contactSupport,
		"fr-FR": fr_FR.molecules_articleVoteForm_contactSupport,
		"it-IT": it_IT.molecules_articleVoteForm_contactSupport,
		"ko-KR": ko_KR.molecules_articleVoteForm_contactSupport,
		"pt-BR": pt_BR.molecules_articleVoteForm_contactSupport
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_checkBoxLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_checkBoxLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_checkBoxLabel,
		"en-US": en_US.molecules_articleVoteForm_form_checkBoxLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_checkBoxLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_checkBoxLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_checkBoxLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_checkBoxLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_checkBoxLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_describe,
		"en-AU": en_AU.molecules_articleVoteForm_form_describe,
		"en-GB": en_GB.molecules_articleVoteForm_form_describe,
		"en-US": en_US.molecules_articleVoteForm_form_describe,
		"es-ES": es_ES.molecules_articleVoteForm_form_describe,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_describe,
		"it-IT": it_IT.molecules_articleVoteForm_form_describe,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_describe,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_describe
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_errorLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_errorLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_errorLabel,
		"en-US": en_US.molecules_articleVoteForm_form_errorLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_errorLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_errorLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_errorLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_errorLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_errorLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_legend,
		"en-AU": en_AU.molecules_articleVoteForm_form_legend,
		"en-GB": en_GB.molecules_articleVoteForm_form_legend,
		"en-US": en_US.molecules_articleVoteForm_form_legend,
		"es-ES": es_ES.molecules_articleVoteForm_form_legend,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_legend,
		"it-IT": it_IT.molecules_articleVoteForm_form_legend,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_legend,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_legend
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_incompleteLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_incompleteLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_incompleteLabel,
		"en-US": en_US.molecules_articleVoteForm_form_incompleteLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_incompleteLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_incompleteLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_incompleteLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_incompleteLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_incompleteLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_irrelevantLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_irrelevantLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_irrelevantLabel,
		"en-US": en_US.molecules_articleVoteForm_form_irrelevantLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_irrelevantLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_irrelevantLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_irrelevantLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_irrelevantLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_irrelevantLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_improveArticle,
		"en-AU": en_AU.molecules_articleVoteForm_form_improveArticle,
		"en-GB": en_GB.molecules_articleVoteForm_form_improveArticle,
		"en-US": en_US.molecules_articleVoteForm_form_improveArticle,
		"es-ES": es_ES.molecules_articleVoteForm_form_improveArticle,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_improveArticle,
		"it-IT": it_IT.molecules_articleVoteForm_form_improveArticle,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_improveArticle,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_improveArticle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_improveArticleSuggestion,
		"en-AU": en_AU.molecules_articleVoteForm_form_improveArticleSuggestion,
		"en-GB": en_GB.molecules_articleVoteForm_form_improveArticleSuggestion,
		"en-US": en_US.molecules_articleVoteForm_form_improveArticleSuggestion,
		"es-ES": es_ES.molecules_articleVoteForm_form_improveArticleSuggestion,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_improveArticleSuggestion,
		"it-IT": it_IT.molecules_articleVoteForm_form_improveArticleSuggestion,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_improveArticleSuggestion,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_improveArticleSuggestion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_moreDetail,
		"en-AU": en_AU.molecules_articleVoteForm_form_moreDetail,
		"en-GB": en_GB.molecules_articleVoteForm_form_moreDetail,
		"en-US": en_US.molecules_articleVoteForm_form_moreDetail,
		"es-ES": es_ES.molecules_articleVoteForm_form_moreDetail,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_moreDetail,
		"it-IT": it_IT.molecules_articleVoteForm_form_moreDetail,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_moreDetail,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_moreDetail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_submit,
		"en-AU": en_AU.molecules_articleVoteForm_form_submit,
		"en-GB": en_GB.molecules_articleVoteForm_form_submit,
		"en-US": en_US.molecules_articleVoteForm_form_submit,
		"es-ES": es_ES.molecules_articleVoteForm_form_submit,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_submit,
		"it-IT": it_IT.molecules_articleVoteForm_form_submit,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_submit,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_submit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_textInput_label,
		"en-AU": en_AU.molecules_articleVoteForm_form_textInput_label,
		"en-GB": en_GB.molecules_articleVoteForm_form_textInput_label,
		"en-US": en_US.molecules_articleVoteForm_form_textInput_label,
		"es-ES": es_ES.molecules_articleVoteForm_form_textInput_label,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_textInput_label,
		"it-IT": it_IT.molecules_articleVoteForm_form_textInput_label,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_textInput_label,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_textInput_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_textInput_description,
		"en-AU": en_AU.molecules_articleVoteForm_form_textInput_description,
		"en-GB": en_GB.molecules_articleVoteForm_form_textInput_description,
		"en-US": en_US.molecules_articleVoteForm_form_textInput_description,
		"es-ES": es_ES.molecules_articleVoteForm_form_textInput_description,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_textInput_description,
		"it-IT": it_IT.molecules_articleVoteForm_form_textInput_description,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_textInput_description,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_textInput_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_textInput_placeholder,
		"en-AU": en_AU.molecules_articleVoteForm_form_textInput_placeholder,
		"en-GB": en_GB.molecules_articleVoteForm_form_textInput_placeholder,
		"en-US": en_US.molecules_articleVoteForm_form_textInput_placeholder,
		"es-ES": es_ES.molecules_articleVoteForm_form_textInput_placeholder,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_textInput_placeholder,
		"it-IT": it_IT.molecules_articleVoteForm_form_textInput_placeholder,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_textInput_placeholder,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_textInput_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_unclearLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_unclearLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_unclearLabel,
		"en-US": en_US.molecules_articleVoteForm_form_unclearLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_unclearLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_unclearLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_unclearLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_unclearLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_unclearLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_articleVoteForm_form_wrongLabel,
		"en-AU": en_AU.molecules_articleVoteForm_form_wrongLabel,
		"en-GB": en_GB.molecules_articleVoteForm_form_wrongLabel,
		"en-US": en_US.molecules_articleVoteForm_form_wrongLabel,
		"es-ES": es_ES.molecules_articleVoteForm_form_wrongLabel,
		"fr-FR": fr_FR.molecules_articleVoteForm_form_wrongLabel,
		"it-IT": it_IT.molecules_articleVoteForm_form_wrongLabel,
		"ko-KR": ko_KR.molecules_articleVoteForm_form_wrongLabel,
		"pt-BR": pt_BR.molecules_articleVoteForm_form_wrongLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_blogAuthor_authorAltText,
		"en-AU": en_AU.molecules_blogAuthor_authorAltText,
		"en-GB": en_GB.molecules_blogAuthor_authorAltText,
		"en-US": en_US.molecules_blogAuthor_authorAltText,
		"es-ES": es_ES.molecules_blogAuthor_authorAltText,
		"fr-FR": fr_FR.molecules_blogAuthor_authorAltText,
		"it-IT": it_IT.molecules_blogAuthor_authorAltText,
		"ko-KR": ko_KR.molecules_blogAuthor_authorAltText,
		"pt-BR": pt_BR.molecules_blogAuthor_authorAltText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_blogAuthor_defaultAuthorAltText,
		"en-AU": en_AU.molecules_blogAuthor_defaultAuthorAltText,
		"en-GB": en_GB.molecules_blogAuthor_defaultAuthorAltText,
		"en-US": en_US.molecules_blogAuthor_defaultAuthorAltText,
		"es-ES": es_ES.molecules_blogAuthor_defaultAuthorAltText,
		"fr-FR": fr_FR.molecules_blogAuthor_defaultAuthorAltText,
		"it-IT": it_IT.molecules_blogAuthor_defaultAuthorAltText,
		"ko-KR": ko_KR.molecules_blogAuthor_defaultAuthorAltText,
		"pt-BR": pt_BR.molecules_blogAuthor_defaultAuthorAltText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_blogAuthor_minRead,
		"en-AU": en_AU.molecules_blogAuthor_minRead,
		"en-GB": en_GB.molecules_blogAuthor_minRead,
		"en-US": en_US.molecules_blogAuthor_minRead,
		"es-ES": es_ES.molecules_blogAuthor_minRead,
		"fr-FR": fr_FR.molecules_blogAuthor_minRead,
		"it-IT": it_IT.molecules_blogAuthor_minRead,
		"ko-KR": ko_KR.molecules_blogAuthor_minRead,
		"pt-BR": pt_BR.molecules_blogAuthor_minRead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_blogCard_read,
		"en-AU": en_AU.molecules_blogCard_read,
		"en-GB": en_GB.molecules_blogCard_read,
		"en-US": en_US.molecules_blogCard_read,
		"es-ES": es_ES.molecules_blogCard_read,
		"fr-FR": fr_FR.molecules_blogCard_read,
		"it-IT": it_IT.molecules_blogCard_read,
		"ko-KR": ko_KR.molecules_blogCard_read,
		"pt-BR": pt_BR.molecules_blogCard_read
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_countdownTimer_days,
		"en-AU": en_AU.molecules_countdownTimer_days,
		"en-GB": en_GB.molecules_countdownTimer_days,
		"en-US": en_US.molecules_countdownTimer_days,
		"es-ES": es_ES.molecules_countdownTimer_days,
		"fr-FR": fr_FR.molecules_countdownTimer_days,
		"it-IT": it_IT.molecules_countdownTimer_days,
		"ko-KR": ko_KR.molecules_countdownTimer_days,
		"pt-BR": pt_BR.molecules_countdownTimer_days
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_countdownTimer_hours,
		"en-AU": en_AU.molecules_countdownTimer_hours,
		"en-GB": en_GB.molecules_countdownTimer_hours,
		"en-US": en_US.molecules_countdownTimer_hours,
		"es-ES": es_ES.molecules_countdownTimer_hours,
		"fr-FR": fr_FR.molecules_countdownTimer_hours,
		"it-IT": it_IT.molecules_countdownTimer_hours,
		"ko-KR": ko_KR.molecules_countdownTimer_hours,
		"pt-BR": pt_BR.molecules_countdownTimer_hours
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_countdownTimer_minutes,
		"en-AU": en_AU.molecules_countdownTimer_minutes,
		"en-GB": en_GB.molecules_countdownTimer_minutes,
		"en-US": en_US.molecules_countdownTimer_minutes,
		"es-ES": es_ES.molecules_countdownTimer_minutes,
		"fr-FR": fr_FR.molecules_countdownTimer_minutes,
		"it-IT": it_IT.molecules_countdownTimer_minutes,
		"ko-KR": ko_KR.molecules_countdownTimer_minutes,
		"pt-BR": pt_BR.molecules_countdownTimer_minutes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_countdownTimer_seconds,
		"en-AU": en_AU.molecules_countdownTimer_seconds,
		"en-GB": en_GB.molecules_countdownTimer_seconds,
		"en-US": en_US.molecules_countdownTimer_seconds,
		"es-ES": es_ES.molecules_countdownTimer_seconds,
		"fr-FR": fr_FR.molecules_countdownTimer_seconds,
		"it-IT": it_IT.molecules_countdownTimer_seconds,
		"ko-KR": ko_KR.molecules_countdownTimer_seconds,
		"pt-BR": pt_BR.molecules_countdownTimer_seconds
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_filterBlock_topic,
		"en-AU": en_AU.molecules_filterBlock_topic,
		"en-GB": en_GB.molecules_filterBlock_topic,
		"en-US": en_US.molecules_filterBlock_topic,
		"es-ES": es_ES.molecules_filterBlock_topic,
		"fr-FR": fr_FR.molecules_filterBlock_topic,
		"it-IT": it_IT.molecules_filterBlock_topic,
		"ko-KR": ko_KR.molecules_filterBlock_topic,
		"pt-BR": pt_BR.molecules_filterBlock_topic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_greenhouseJob_save,
		"en-AU": en_AU.molecules_greenhouseJob_save,
		"en-GB": en_GB.molecules_greenhouseJob_save,
		"en-US": en_US.molecules_greenhouseJob_save,
		"es-ES": es_ES.molecules_greenhouseJob_save,
		"fr-FR": fr_FR.molecules_greenhouseJob_save,
		"it-IT": it_IT.molecules_greenhouseJob_save,
		"ko-KR": ko_KR.molecules_greenhouseJob_save,
		"pt-BR": pt_BR.molecules_greenhouseJob_save
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_greenhouseJob_saved,
		"en-AU": en_AU.molecules_greenhouseJob_saved,
		"en-GB": en_GB.molecules_greenhouseJob_saved,
		"en-US": en_US.molecules_greenhouseJob_saved,
		"es-ES": es_ES.molecules_greenhouseJob_saved,
		"fr-FR": fr_FR.molecules_greenhouseJob_saved,
		"it-IT": it_IT.molecules_greenhouseJob_saved,
		"ko-KR": ko_KR.molecules_greenhouseJob_saved,
		"pt-BR": pt_BR.molecules_greenhouseJob_saved
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_greenhouseDepartment_openRoles,
		"en-AU": en_AU.molecules_greenhouseDepartment_openRoles,
		"en-GB": en_GB.molecules_greenhouseDepartment_openRoles,
		"en-US": en_US.molecules_greenhouseDepartment_openRoles,
		"es-ES": es_ES.molecules_greenhouseDepartment_openRoles,
		"fr-FR": fr_FR.molecules_greenhouseDepartment_openRoles,
		"it-IT": it_IT.molecules_greenhouseDepartment_openRoles,
		"ko-KR": ko_KR.molecules_greenhouseDepartment_openRoles,
		"pt-BR": pt_BR.molecules_greenhouseDepartment_openRoles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_pagination_previous,
		"en-AU": en_AU.molecules_pagination_previous,
		"en-GB": en_GB.molecules_pagination_previous,
		"en-US": en_US.molecules_pagination_previous,
		"es-ES": es_ES.molecules_pagination_previous,
		"fr-FR": fr_FR.molecules_pagination_previous,
		"it-IT": it_IT.molecules_pagination_previous,
		"ko-KR": ko_KR.molecules_pagination_previous,
		"pt-BR": pt_BR.molecules_pagination_previous
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_pagination_next,
		"en-AU": en_AU.molecules_pagination_next,
		"en-GB": en_GB.molecules_pagination_next,
		"en-US": en_US.molecules_pagination_next,
		"es-ES": es_ES.molecules_pagination_next,
		"fr-FR": fr_FR.molecules_pagination_next,
		"it-IT": it_IT.molecules_pagination_next,
		"ko-KR": ko_KR.molecules_pagination_next,
		"pt-BR": pt_BR.molecules_pagination_next
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_relatedCard_openInANewTab,
		"en-AU": en_AU.molecules_relatedCard_openInANewTab,
		"en-GB": en_GB.molecules_relatedCard_openInANewTab,
		"en-US": en_US.molecules_relatedCard_openInANewTab,
		"es-ES": es_ES.molecules_relatedCard_openInANewTab,
		"fr-FR": fr_FR.molecules_relatedCard_openInANewTab,
		"it-IT": it_IT.molecules_relatedCard_openInANewTab,
		"ko-KR": ko_KR.molecules_relatedCard_openInANewTab,
		"pt-BR": pt_BR.molecules_relatedCard_openInANewTab
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_searchBox_placeholder,
		"en-AU": en_AU.molecules_searchBox_placeholder,
		"en-GB": en_GB.molecules_searchBox_placeholder,
		"en-US": en_US.molecules_searchBox_placeholder,
		"es-ES": es_ES.molecules_searchBox_placeholder,
		"fr-FR": fr_FR.molecules_searchBox_placeholder,
		"it-IT": it_IT.molecules_searchBox_placeholder,
		"ko-KR": ko_KR.molecules_searchBox_placeholder,
		"pt-BR": pt_BR.molecules_searchBox_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_subcategoryCard_articlesPlural,
		"en-AU": en_AU.molecules_subcategoryCard_articlesPlural,
		"en-GB": en_GB.molecules_subcategoryCard_articlesPlural,
		"en-US": en_US.molecules_subcategoryCard_articlesPlural,
		"es-ES": es_ES.molecules_subcategoryCard_articlesPlural,
		"fr-FR": fr_FR.molecules_subcategoryCard_articlesPlural,
		"it-IT": it_IT.molecules_subcategoryCard_articlesPlural,
		"ko-KR": ko_KR.molecules_subcategoryCard_articlesPlural,
		"pt-BR": pt_BR.molecules_subcategoryCard_articlesPlural
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.molecules_subcategoryCard_articleSingular,
		"en-AU": en_AU.molecules_subcategoryCard_articleSingular,
		"en-GB": en_GB.molecules_subcategoryCard_articleSingular,
		"en-US": en_US.molecules_subcategoryCard_articleSingular,
		"es-ES": es_ES.molecules_subcategoryCard_articleSingular,
		"fr-FR": fr_FR.molecules_subcategoryCard_articleSingular,
		"it-IT": it_IT.molecules_subcategoryCard_articleSingular,
		"ko-KR": ko_KR.molecules_subcategoryCard_articleSingular,
		"pt-BR": pt_BR.molecules_subcategoryCard_articleSingular
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_logOut_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_logOut_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_logOut_label,
		"en-US": en_US.navigation_ecosystem_ctas_academy_logOut_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_logOut_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_logOut_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_logOut_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_logOut_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_logOut_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_profile_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_profile_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_profile_label,
		"en-US": en_US.navigation_ecosystem_ctas_academy_profile_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_profile_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_profile_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_profile_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_profile_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_profile_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_profile_href,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_profile_href,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_profile_href,
		"en-US": en_US.navigation_ecosystem_ctas_academy_profile_href,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_profile_href,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_profile_href,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_profile_href,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_profile_href,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_profile_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_signIn_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_signIn_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_signIn_label,
		"en-US": en_US.navigation_ecosystem_ctas_academy_signIn_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_signIn_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_signIn_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_signIn_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_signIn_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_signIn_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_contactUs_href,
		"en-AU": en_AU.navigation_ecosystem_ctas_contactUs_href,
		"en-GB": en_GB.navigation_ecosystem_ctas_contactUs_href,
		"en-US": en_US.navigation_ecosystem_ctas_contactUs_href,
		"es-ES": es_ES.navigation_ecosystem_ctas_contactUs_href,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_contactUs_href,
		"it-IT": it_IT.navigation_ecosystem_ctas_contactUs_href,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_contactUs_href,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_contactUs_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_contactUs_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_contactUs_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_contactUs_label,
		"en-US": en_US.navigation_ecosystem_ctas_contactUs_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_contactUs_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_contactUs_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_contactUs_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_contactUs_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_contactUs_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_account_href,
		"en-AU": en_AU.navigation_platformActions_account_href,
		"en-GB": en_GB.navigation_platformActions_account_href,
		"en-US": en_US.navigation_platformActions_account_href,
		"es-ES": es_ES.navigation_platformActions_account_href,
		"fr-FR": fr_FR.navigation_platformActions_account_href,
		"it-IT": it_IT.navigation_platformActions_account_href,
		"ko-KR": ko_KR.navigation_platformActions_account_href,
		"pt-BR": pt_BR.navigation_platformActions_account_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_account_label,
		"en-AU": en_AU.navigation_platformActions_account_label,
		"en-GB": en_GB.navigation_platformActions_account_label,
		"en-US": en_US.navigation_platformActions_account_label,
		"es-ES": es_ES.navigation_platformActions_account_label,
		"fr-FR": fr_FR.navigation_platformActions_account_label,
		"it-IT": it_IT.navigation_platformActions_account_label,
		"ko-KR": ko_KR.navigation_platformActions_account_label,
		"pt-BR": pt_BR.navigation_platformActions_account_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_logIn_href,
		"en-AU": en_AU.navigation_platformActions_logIn_href,
		"en-GB": en_GB.navigation_platformActions_logIn_href,
		"en-US": en_US.navigation_platformActions_logIn_href,
		"es-ES": es_ES.navigation_platformActions_logIn_href,
		"fr-FR": fr_FR.navigation_platformActions_logIn_href,
		"it-IT": it_IT.navigation_platformActions_logIn_href,
		"ko-KR": ko_KR.navigation_platformActions_logIn_href,
		"pt-BR": pt_BR.navigation_platformActions_logIn_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_logIn_label,
		"en-AU": en_AU.navigation_platformActions_logIn_label,
		"en-GB": en_GB.navigation_platformActions_logIn_label,
		"en-US": en_US.navigation_platformActions_logIn_label,
		"es-ES": es_ES.navigation_platformActions_logIn_label,
		"fr-FR": fr_FR.navigation_platformActions_logIn_label,
		"it-IT": it_IT.navigation_platformActions_logIn_label,
		"ko-KR": ko_KR.navigation_platformActions_logIn_label,
		"pt-BR": pt_BR.navigation_platformActions_logIn_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_siteActions_search_href,
		"en-AU": en_AU.navigation_siteActions_search_href,
		"en-GB": en_GB.navigation_siteActions_search_href,
		"en-US": en_US.navigation_siteActions_search_href,
		"es-ES": es_ES.navigation_siteActions_search_href,
		"fr-FR": fr_FR.navigation_siteActions_search_href,
		"it-IT": it_IT.navigation_siteActions_search_href,
		"ko-KR": ko_KR.navigation_siteActions_search_href,
		"pt-BR": pt_BR.navigation_siteActions_search_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_siteActions_search_label,
		"en-AU": en_AU.navigation_siteActions_search_label,
		"en-GB": en_GB.navigation_siteActions_search_label,
		"en-US": en_US.navigation_siteActions_search_label,
		"es-ES": es_ES.navigation_siteActions_search_label,
		"fr-FR": fr_FR.navigation_siteActions_search_label,
		"it-IT": it_IT.navigation_siteActions_search_label,
		"ko-KR": ko_KR.navigation_siteActions_search_label,
		"pt-BR": pt_BR.navigation_siteActions_search_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_anchorLinks_backToTop,
		"en-AU": en_AU.organisms_anchorLinks_backToTop,
		"en-GB": en_GB.organisms_anchorLinks_backToTop,
		"en-US": en_US.organisms_anchorLinks_backToTop,
		"es-ES": es_ES.organisms_anchorLinks_backToTop,
		"fr-FR": fr_FR.organisms_anchorLinks_backToTop,
		"it-IT": it_IT.organisms_anchorLinks_backToTop,
		"ko-KR": ko_KR.organisms_anchorLinks_backToTop,
		"pt-BR": pt_BR.organisms_anchorLinks_backToTop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_articleTableContents_tableContents,
		"en-AU": en_AU.organisms_articleTableContents_tableContents,
		"en-GB": en_GB.organisms_articleTableContents_tableContents,
		"en-US": en_US.organisms_articleTableContents_tableContents,
		"es-ES": es_ES.organisms_articleTableContents_tableContents,
		"fr-FR": fr_FR.organisms_articleTableContents_tableContents,
		"it-IT": it_IT.organisms_articleTableContents_tableContents,
		"ko-KR": ko_KR.organisms_articleTableContents_tableContents,
		"pt-BR": pt_BR.organisms_articleTableContents_tableContents
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogArticleHero_featureImageAltText,
		"en-AU": en_AU.organisms_blogArticleHero_featureImageAltText,
		"en-GB": en_GB.organisms_blogArticleHero_featureImageAltText,
		"en-US": en_US.organisms_blogArticleHero_featureImageAltText,
		"es-ES": es_ES.organisms_blogArticleHero_featureImageAltText,
		"fr-FR": fr_FR.organisms_blogArticleHero_featureImageAltText,
		"it-IT": it_IT.organisms_blogArticleHero_featureImageAltText,
		"ko-KR": ko_KR.organisms_blogArticleHero_featureImageAltText,
		"pt-BR": pt_BR.organisms_blogArticleHero_featureImageAltText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogCards_viewCategory,
		"en-AU": en_AU.organisms_blogCards_viewCategory,
		"en-GB": en_GB.organisms_blogCards_viewCategory,
		"en-US": en_US.organisms_blogCards_viewCategory,
		"es-ES": es_ES.organisms_blogCards_viewCategory,
		"fr-FR": fr_FR.organisms_blogCards_viewCategory,
		"it-IT": it_IT.organisms_blogCards_viewCategory,
		"ko-KR": ko_KR.organisms_blogCards_viewCategory,
		"pt-BR": pt_BR.organisms_blogCards_viewCategory
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogLogoTag_title,
		"en-AU": en_AU.organisms_blogLogoTag_title,
		"en-GB": en_GB.organisms_blogLogoTag_title,
		"en-US": en_US.organisms_blogLogoTag_title,
		"es-ES": es_ES.organisms_blogLogoTag_title,
		"fr-FR": fr_FR.organisms_blogLogoTag_title,
		"it-IT": it_IT.organisms_blogLogoTag_title,
		"ko-KR": ko_KR.organisms_blogLogoTag_title,
		"pt-BR": pt_BR.organisms_blogLogoTag_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogLogoTag_tagline,
		"en-AU": en_AU.organisms_blogLogoTag_tagline,
		"en-GB": en_GB.organisms_blogLogoTag_tagline,
		"en-US": en_US.organisms_blogLogoTag_tagline,
		"es-ES": es_ES.organisms_blogLogoTag_tagline,
		"fr-FR": fr_FR.organisms_blogLogoTag_tagline,
		"it-IT": it_IT.organisms_blogLogoTag_tagline,
		"ko-KR": ko_KR.organisms_blogLogoTag_tagline,
		"pt-BR": pt_BR.organisms_blogLogoTag_tagline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_countdownHero_days,
		"en-AU": en_AU.organisms_countdownHero_days,
		"en-GB": en_GB.organisms_countdownHero_days,
		"en-US": en_US.organisms_countdownHero_days,
		"es-ES": es_ES.organisms_countdownHero_days,
		"fr-FR": fr_FR.organisms_countdownHero_days,
		"it-IT": it_IT.organisms_countdownHero_days,
		"ko-KR": ko_KR.organisms_countdownHero_days,
		"pt-BR": pt_BR.organisms_countdownHero_days
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_countdownHero_hours,
		"en-AU": en_AU.organisms_countdownHero_hours,
		"en-GB": en_GB.organisms_countdownHero_hours,
		"en-US": en_US.organisms_countdownHero_hours,
		"es-ES": es_ES.organisms_countdownHero_hours,
		"fr-FR": fr_FR.organisms_countdownHero_hours,
		"it-IT": it_IT.organisms_countdownHero_hours,
		"ko-KR": ko_KR.organisms_countdownHero_hours,
		"pt-BR": pt_BR.organisms_countdownHero_hours
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_countdownHero_minutes,
		"en-AU": en_AU.organisms_countdownHero_minutes,
		"en-GB": en_GB.organisms_countdownHero_minutes,
		"en-US": en_US.organisms_countdownHero_minutes,
		"es-ES": es_ES.organisms_countdownHero_minutes,
		"fr-FR": fr_FR.organisms_countdownHero_minutes,
		"it-IT": it_IT.organisms_countdownHero_minutes,
		"ko-KR": ko_KR.organisms_countdownHero_minutes,
		"pt-BR": pt_BR.organisms_countdownHero_minutes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_countdownHero_seconds,
		"en-AU": en_AU.organisms_countdownHero_seconds,
		"en-GB": en_GB.organisms_countdownHero_seconds,
		"en-US": en_US.organisms_countdownHero_seconds,
		"es-ES": es_ES.organisms_countdownHero_seconds,
		"fr-FR": fr_FR.organisms_countdownHero_seconds,
		"it-IT": it_IT.organisms_countdownHero_seconds,
		"ko-KR": ko_KR.organisms_countdownHero_seconds,
		"pt-BR": pt_BR.organisms_countdownHero_seconds
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card1_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card1_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card1_postTitle,
		"en-US": en_US.organisms_featuredResources_card1_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card1_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card1_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card1_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card1_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card1_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card1_resource,
		"en-AU": en_AU.organisms_featuredResources_card1_resource,
		"en-GB": en_GB.organisms_featuredResources_card1_resource,
		"en-US": en_US.organisms_featuredResources_card1_resource,
		"es-ES": es_ES.organisms_featuredResources_card1_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card1_resource,
		"it-IT": it_IT.organisms_featuredResources_card1_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card1_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card1_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card1_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card1_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card1_excerpt,
		"en-US": en_US.organisms_featuredResources_card1_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card1_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card1_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card1_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card1_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card1_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card1_href,
		"en-AU": en_AU.organisms_featuredResources_card1_href,
		"en-GB": en_GB.organisms_featuredResources_card1_href,
		"en-US": en_US.organisms_featuredResources_card1_href,
		"es-ES": es_ES.organisms_featuredResources_card1_href,
		"fr-FR": fr_FR.organisms_featuredResources_card1_href,
		"it-IT": it_IT.organisms_featuredResources_card1_href,
		"ko-KR": ko_KR.organisms_featuredResources_card1_href,
		"pt-BR": pt_BR.organisms_featuredResources_card1_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card2_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card2_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card2_postTitle,
		"en-US": en_US.organisms_featuredResources_card2_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card2_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card2_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card2_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card2_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card2_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card2_resource,
		"en-AU": en_AU.organisms_featuredResources_card2_resource,
		"en-GB": en_GB.organisms_featuredResources_card2_resource,
		"en-US": en_US.organisms_featuredResources_card2_resource,
		"es-ES": es_ES.organisms_featuredResources_card2_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card2_resource,
		"it-IT": it_IT.organisms_featuredResources_card2_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card2_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card2_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card2_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card2_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card2_excerpt,
		"en-US": en_US.organisms_featuredResources_card2_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card2_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card2_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card2_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card2_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card2_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card2_href,
		"en-AU": en_AU.organisms_featuredResources_card2_href,
		"en-GB": en_GB.organisms_featuredResources_card2_href,
		"en-US": en_US.organisms_featuredResources_card2_href,
		"es-ES": es_ES.organisms_featuredResources_card2_href,
		"fr-FR": fr_FR.organisms_featuredResources_card2_href,
		"it-IT": it_IT.organisms_featuredResources_card2_href,
		"ko-KR": ko_KR.organisms_featuredResources_card2_href,
		"pt-BR": pt_BR.organisms_featuredResources_card2_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card3_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card3_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card3_postTitle,
		"en-US": en_US.organisms_featuredResources_card3_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card3_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card3_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card3_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card3_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card3_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card3_resource,
		"en-AU": en_AU.organisms_featuredResources_card3_resource,
		"en-GB": en_GB.organisms_featuredResources_card3_resource,
		"en-US": en_US.organisms_featuredResources_card3_resource,
		"es-ES": es_ES.organisms_featuredResources_card3_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card3_resource,
		"it-IT": it_IT.organisms_featuredResources_card3_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card3_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card3_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card3_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card3_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card3_excerpt,
		"en-US": en_US.organisms_featuredResources_card3_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card3_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card3_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card3_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card3_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card3_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card3_href,
		"en-AU": en_AU.organisms_featuredResources_card3_href,
		"en-GB": en_GB.organisms_featuredResources_card3_href,
		"en-US": en_US.organisms_featuredResources_card3_href,
		"es-ES": es_ES.organisms_featuredResources_card3_href,
		"fr-FR": fr_FR.organisms_featuredResources_card3_href,
		"it-IT": it_IT.organisms_featuredResources_card3_href,
		"ko-KR": ko_KR.organisms_featuredResources_card3_href,
		"pt-BR": pt_BR.organisms_featuredResources_card3_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card4_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card4_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card4_postTitle,
		"en-US": en_US.organisms_featuredResources_card4_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card4_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card4_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card4_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card4_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card4_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card4_resource,
		"en-AU": en_AU.organisms_featuredResources_card4_resource,
		"en-GB": en_GB.organisms_featuredResources_card4_resource,
		"en-US": en_US.organisms_featuredResources_card4_resource,
		"es-ES": es_ES.organisms_featuredResources_card4_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card4_resource,
		"it-IT": it_IT.organisms_featuredResources_card4_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card4_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card4_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card4_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card4_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card4_excerpt,
		"en-US": en_US.organisms_featuredResources_card4_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card4_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card4_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card4_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card4_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card4_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card4_href,
		"en-AU": en_AU.organisms_featuredResources_card4_href,
		"en-GB": en_GB.organisms_featuredResources_card4_href,
		"en-US": en_US.organisms_featuredResources_card4_href,
		"es-ES": es_ES.organisms_featuredResources_card4_href,
		"fr-FR": fr_FR.organisms_featuredResources_card4_href,
		"it-IT": it_IT.organisms_featuredResources_card4_href,
		"ko-KR": ko_KR.organisms_featuredResources_card4_href,
		"pt-BR": pt_BR.organisms_featuredResources_card4_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card5_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card5_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card5_postTitle,
		"en-US": en_US.organisms_featuredResources_card5_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card5_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card5_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card5_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card5_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card5_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card5_resource,
		"en-AU": en_AU.organisms_featuredResources_card5_resource,
		"en-GB": en_GB.organisms_featuredResources_card5_resource,
		"en-US": en_US.organisms_featuredResources_card5_resource,
		"es-ES": es_ES.organisms_featuredResources_card5_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card5_resource,
		"it-IT": it_IT.organisms_featuredResources_card5_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card5_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card5_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card5_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card5_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card5_excerpt,
		"en-US": en_US.organisms_featuredResources_card5_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card5_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card5_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card5_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card5_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card5_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card5_href,
		"en-AU": en_AU.organisms_featuredResources_card5_href,
		"en-GB": en_GB.organisms_featuredResources_card5_href,
		"en-US": en_US.organisms_featuredResources_card5_href,
		"es-ES": es_ES.organisms_featuredResources_card5_href,
		"fr-FR": fr_FR.organisms_featuredResources_card5_href,
		"it-IT": it_IT.organisms_featuredResources_card5_href,
		"ko-KR": ko_KR.organisms_featuredResources_card5_href,
		"pt-BR": pt_BR.organisms_featuredResources_card5_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card6_postTitle,
		"en-AU": en_AU.organisms_featuredResources_card6_postTitle,
		"en-GB": en_GB.organisms_featuredResources_card6_postTitle,
		"en-US": en_US.organisms_featuredResources_card6_postTitle,
		"es-ES": es_ES.organisms_featuredResources_card6_postTitle,
		"fr-FR": fr_FR.organisms_featuredResources_card6_postTitle,
		"it-IT": it_IT.organisms_featuredResources_card6_postTitle,
		"ko-KR": ko_KR.organisms_featuredResources_card6_postTitle,
		"pt-BR": pt_BR.organisms_featuredResources_card6_postTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card6_resource,
		"en-AU": en_AU.organisms_featuredResources_card6_resource,
		"en-GB": en_GB.organisms_featuredResources_card6_resource,
		"en-US": en_US.organisms_featuredResources_card6_resource,
		"es-ES": es_ES.organisms_featuredResources_card6_resource,
		"fr-FR": fr_FR.organisms_featuredResources_card6_resource,
		"it-IT": it_IT.organisms_featuredResources_card6_resource,
		"ko-KR": ko_KR.organisms_featuredResources_card6_resource,
		"pt-BR": pt_BR.organisms_featuredResources_card6_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card6_excerpt,
		"en-AU": en_AU.organisms_featuredResources_card6_excerpt,
		"en-GB": en_GB.organisms_featuredResources_card6_excerpt,
		"en-US": en_US.organisms_featuredResources_card6_excerpt,
		"es-ES": es_ES.organisms_featuredResources_card6_excerpt,
		"fr-FR": fr_FR.organisms_featuredResources_card6_excerpt,
		"it-IT": it_IT.organisms_featuredResources_card6_excerpt,
		"ko-KR": ko_KR.organisms_featuredResources_card6_excerpt,
		"pt-BR": pt_BR.organisms_featuredResources_card6_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuredResources_card6_href,
		"en-AU": en_AU.organisms_featuredResources_card6_href,
		"en-GB": en_GB.organisms_featuredResources_card6_href,
		"en-US": en_US.organisms_featuredResources_card6_href,
		"es-ES": es_ES.organisms_featuredResources_card6_href,
		"fr-FR": fr_FR.organisms_featuredResources_card6_href,
		"it-IT": it_IT.organisms_featuredResources_card6_href,
		"ko-KR": ko_KR.organisms_featuredResources_card6_href,
		"pt-BR": pt_BR.organisms_featuredResources_card6_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_featuresList_loadMore,
		"en-AU": en_AU.organisms_featuresList_loadMore,
		"en-GB": en_GB.organisms_featuresList_loadMore,
		"en-US": en_US.organisms_featuresList_loadMore,
		"es-ES": es_ES.organisms_featuresList_loadMore,
		"fr-FR": fr_FR.organisms_featuresList_loadMore,
		"it-IT": it_IT.organisms_featuresList_loadMore,
		"ko-KR": ko_KR.organisms_featuresList_loadMore,
		"pt-BR": pt_BR.organisms_featuresList_loadMore
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ year: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params , options = {}) => {
	return {
		"de-DE": de_DE.organisms_footer_copyright,
		"en-AU": en_AU.organisms_footer_copyright,
		"en-GB": en_GB.organisms_footer_copyright,
		"en-US": en_US.organisms_footer_copyright,
		"es-ES": es_ES.organisms_footer_copyright,
		"fr-FR": fr_FR.organisms_footer_copyright,
		"it-IT": it_IT.organisms_footer_copyright,
		"ko-KR": ko_KR.organisms_footer_copyright,
		"pt-BR": pt_BR.organisms_footer_copyright
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_footer_privacySettings,
		"en-AU": en_AU.organisms_footer_privacySettings,
		"en-GB": en_GB.organisms_footer_privacySettings,
		"en-US": en_US.organisms_footer_privacySettings,
		"es-ES": es_ES.organisms_footer_privacySettings,
		"fr-FR": fr_FR.organisms_footer_privacySettings,
		"it-IT": it_IT.organisms_footer_privacySettings,
		"ko-KR": ko_KR.organisms_footer_privacySettings,
		"pt-BR": pt_BR.organisms_footer_privacySettings
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_headlineEmbedded,
		"en-AU": en_AU.organisms_forms_demo_headlineEmbedded,
		"en-GB": en_GB.organisms_forms_demo_headlineEmbedded,
		"en-US": en_US.organisms_forms_demo_headlineEmbedded,
		"es-ES": es_ES.organisms_forms_demo_headlineEmbedded,
		"fr-FR": fr_FR.organisms_forms_demo_headlineEmbedded,
		"it-IT": it_IT.organisms_forms_demo_headlineEmbedded,
		"ko-KR": ko_KR.organisms_forms_demo_headlineEmbedded,
		"pt-BR": pt_BR.organisms_forms_demo_headlineEmbedded
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_headline,
		"en-AU": en_AU.organisms_forms_demo_headline,
		"en-GB": en_GB.organisms_forms_demo_headline,
		"en-US": en_US.organisms_forms_demo_headline,
		"es-ES": es_ES.organisms_forms_demo_headline,
		"fr-FR": fr_FR.organisms_forms_demo_headline,
		"it-IT": it_IT.organisms_forms_demo_headline,
		"ko-KR": ko_KR.organisms_forms_demo_headline,
		"pt-BR": pt_BR.organisms_forms_demo_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_body,
		"en-AU": en_AU.organisms_forms_demo_body,
		"en-GB": en_GB.organisms_forms_demo_body,
		"en-US": en_US.organisms_forms_demo_body,
		"es-ES": es_ES.organisms_forms_demo_body,
		"fr-FR": fr_FR.organisms_forms_demo_body,
		"it-IT": it_IT.organisms_forms_demo_body,
		"ko-KR": ko_KR.organisms_forms_demo_body,
		"pt-BR": pt_BR.organisms_forms_demo_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_allRequired,
		"en-AU": en_AU.organisms_forms_demo_allRequired,
		"en-GB": en_GB.organisms_forms_demo_allRequired,
		"en-US": en_US.organisms_forms_demo_allRequired,
		"es-ES": es_ES.organisms_forms_demo_allRequired,
		"fr-FR": fr_FR.organisms_forms_demo_allRequired,
		"it-IT": it_IT.organisms_forms_demo_allRequired,
		"ko-KR": ko_KR.organisms_forms_demo_allRequired,
		"pt-BR": pt_BR.organisms_forms_demo_allRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_button,
		"en-AU": en_AU.organisms_forms_demo_button,
		"en-GB": en_GB.organisms_forms_demo_button,
		"en-US": en_US.organisms_forms_demo_button,
		"es-ES": es_ES.organisms_forms_demo_button,
		"fr-FR": fr_FR.organisms_forms_demo_button,
		"it-IT": it_IT.organisms_forms_demo_button,
		"ko-KR": ko_KR.organisms_forms_demo_button,
		"pt-BR": pt_BR.organisms_forms_demo_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_buttonSubmitting,
		"en-AU": en_AU.organisms_forms_demo_buttonSubmitting,
		"en-GB": en_GB.organisms_forms_demo_buttonSubmitting,
		"en-US": en_US.organisms_forms_demo_buttonSubmitting,
		"es-ES": es_ES.organisms_forms_demo_buttonSubmitting,
		"fr-FR": fr_FR.organisms_forms_demo_buttonSubmitting,
		"it-IT": it_IT.organisms_forms_demo_buttonSubmitting,
		"ko-KR": ko_KR.organisms_forms_demo_buttonSubmitting,
		"pt-BR": pt_BR.organisms_forms_demo_buttonSubmitting
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_success_headline,
		"en-AU": en_AU.organisms_forms_demo_success_headline,
		"en-GB": en_GB.organisms_forms_demo_success_headline,
		"en-US": en_US.organisms_forms_demo_success_headline,
		"es-ES": es_ES.organisms_forms_demo_success_headline,
		"fr-FR": fr_FR.organisms_forms_demo_success_headline,
		"it-IT": it_IT.organisms_forms_demo_success_headline,
		"ko-KR": ko_KR.organisms_forms_demo_success_headline,
		"pt-BR": pt_BR.organisms_forms_demo_success_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_success_buttonOne,
		"en-AU": en_AU.organisms_forms_demo_success_buttonOne,
		"en-GB": en_GB.organisms_forms_demo_success_buttonOne,
		"en-US": en_US.organisms_forms_demo_success_buttonOne,
		"es-ES": es_ES.organisms_forms_demo_success_buttonOne,
		"fr-FR": fr_FR.organisms_forms_demo_success_buttonOne,
		"it-IT": it_IT.organisms_forms_demo_success_buttonOne,
		"ko-KR": ko_KR.organisms_forms_demo_success_buttonOne,
		"pt-BR": pt_BR.organisms_forms_demo_success_buttonOne
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_demo_success_buttonTwo,
		"en-AU": en_AU.organisms_forms_demo_success_buttonTwo,
		"en-GB": en_GB.organisms_forms_demo_success_buttonTwo,
		"en-US": en_US.organisms_forms_demo_success_buttonTwo,
		"es-ES": es_ES.organisms_forms_demo_success_buttonTwo,
		"fr-FR": fr_FR.organisms_forms_demo_success_buttonTwo,
		"it-IT": it_IT.organisms_forms_demo_success_buttonTwo,
		"ko-KR": ko_KR.organisms_forms_demo_success_buttonTwo,
		"pt-BR": pt_BR.organisms_forms_demo_success_buttonTwo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_signup_headline,
		"en-AU": en_AU.organisms_forms_signup_headline,
		"en-GB": en_GB.organisms_forms_signup_headline,
		"en-US": en_US.organisms_forms_signup_headline,
		"es-ES": es_ES.organisms_forms_signup_headline,
		"fr-FR": fr_FR.organisms_forms_signup_headline,
		"it-IT": it_IT.organisms_forms_signup_headline,
		"ko-KR": ko_KR.organisms_forms_signup_headline,
		"pt-BR": pt_BR.organisms_forms_signup_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_signup_body,
		"en-AU": en_AU.organisms_forms_signup_body,
		"en-GB": en_GB.organisms_forms_signup_body,
		"en-US": en_US.organisms_forms_signup_body,
		"es-ES": es_ES.organisms_forms_signup_body,
		"fr-FR": fr_FR.organisms_forms_signup_body,
		"it-IT": it_IT.organisms_forms_signup_body,
		"ko-KR": ko_KR.organisms_forms_signup_body,
		"pt-BR": pt_BR.organisms_forms_signup_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_signup_button,
		"en-AU": en_AU.organisms_forms_signup_button,
		"en-GB": en_GB.organisms_forms_signup_button,
		"en-US": en_US.organisms_forms_signup_button,
		"es-ES": es_ES.organisms_forms_signup_button,
		"fr-FR": fr_FR.organisms_forms_signup_button,
		"it-IT": it_IT.organisms_forms_signup_button,
		"ko-KR": ko_KR.organisms_forms_signup_button,
		"pt-BR": pt_BR.organisms_forms_signup_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_signup_buttonSubmitting,
		"en-AU": en_AU.organisms_forms_signup_buttonSubmitting,
		"en-GB": en_GB.organisms_forms_signup_buttonSubmitting,
		"en-US": en_US.organisms_forms_signup_buttonSubmitting,
		"es-ES": es_ES.organisms_forms_signup_buttonSubmitting,
		"fr-FR": fr_FR.organisms_forms_signup_buttonSubmitting,
		"it-IT": it_IT.organisms_forms_signup_buttonSubmitting,
		"ko-KR": ko_KR.organisms_forms_signup_buttonSubmitting,
		"pt-BR": pt_BR.organisms_forms_signup_buttonSubmitting
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_privacyPolicy_label,
		"en-AU": en_AU.organisms_forms_legal_privacyPolicy_label,
		"en-GB": en_GB.organisms_forms_legal_privacyPolicy_label,
		"en-US": en_US.organisms_forms_legal_privacyPolicy_label,
		"es-ES": es_ES.organisms_forms_legal_privacyPolicy_label,
		"fr-FR": fr_FR.organisms_forms_legal_privacyPolicy_label,
		"it-IT": it_IT.organisms_forms_legal_privacyPolicy_label,
		"ko-KR": ko_KR.organisms_forms_legal_privacyPolicy_label,
		"pt-BR": pt_BR.organisms_forms_legal_privacyPolicy_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_privacyPolicy_href,
		"en-AU": en_AU.organisms_forms_legal_privacyPolicy_href,
		"en-GB": en_GB.organisms_forms_legal_privacyPolicy_href,
		"en-US": en_US.organisms_forms_legal_privacyPolicy_href,
		"es-ES": es_ES.organisms_forms_legal_privacyPolicy_href,
		"fr-FR": fr_FR.organisms_forms_legal_privacyPolicy_href,
		"it-IT": it_IT.organisms_forms_legal_privacyPolicy_href,
		"ko-KR": ko_KR.organisms_forms_legal_privacyPolicy_href,
		"pt-BR": pt_BR.organisms_forms_legal_privacyPolicy_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_termsOfService,
		"en-AU": en_AU.organisms_forms_legal_termsOfService,
		"en-GB": en_GB.organisms_forms_legal_termsOfService,
		"en-US": en_US.organisms_forms_legal_termsOfService,
		"es-ES": es_ES.organisms_forms_legal_termsOfService,
		"fr-FR": fr_FR.organisms_forms_legal_termsOfService,
		"it-IT": it_IT.organisms_forms_legal_termsOfService,
		"ko-KR": ko_KR.organisms_forms_legal_termsOfService,
		"pt-BR": pt_BR.organisms_forms_legal_termsOfService
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_acknowledgement,
		"en-AU": en_AU.organisms_forms_legal_acknowledgement,
		"en-GB": en_GB.organisms_forms_legal_acknowledgement,
		"en-US": en_US.organisms_forms_legal_acknowledgement,
		"es-ES": es_ES.organisms_forms_legal_acknowledgement,
		"fr-FR": fr_FR.organisms_forms_legal_acknowledgement,
		"it-IT": it_IT.organisms_forms_legal_acknowledgement,
		"ko-KR": ko_KR.organisms_forms_legal_acknowledgement,
		"pt-BR": pt_BR.organisms_forms_legal_acknowledgement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_termsOfService_href,
		"en-AU": en_AU.organisms_forms_legal_termsOfService_href,
		"en-GB": en_GB.organisms_forms_legal_termsOfService_href,
		"en-US": en_US.organisms_forms_legal_termsOfService_href,
		"es-ES": es_ES.organisms_forms_legal_termsOfService_href,
		"fr-FR": fr_FR.organisms_forms_legal_termsOfService_href,
		"it-IT": it_IT.organisms_forms_legal_termsOfService_href,
		"ko-KR": ko_KR.organisms_forms_legal_termsOfService_href,
		"pt-BR": pt_BR.organisms_forms_legal_termsOfService_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_and,
		"en-AU": en_AU.organisms_forms_legal_and,
		"en-GB": en_GB.organisms_forms_legal_and,
		"en-US": en_US.organisms_forms_legal_and,
		"es-ES": es_ES.organisms_forms_legal_and,
		"fr-FR": fr_FR.organisms_forms_legal_and,
		"it-IT": it_IT.organisms_forms_legal_and,
		"ko-KR": ko_KR.organisms_forms_legal_and,
		"pt-BR": pt_BR.organisms_forms_legal_and
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_errors_network,
		"en-AU": en_AU.organisms_forms_errors_network,
		"en-GB": en_GB.organisms_forms_errors_network,
		"en-US": en_US.organisms_forms_errors_network,
		"es-ES": es_ES.organisms_forms_errors_network,
		"fr-FR": fr_FR.organisms_forms_errors_network,
		"it-IT": it_IT.organisms_forms_errors_network,
		"ko-KR": ko_KR.organisms_forms_errors_network,
		"pt-BR": pt_BR.organisms_forms_errors_network
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_errors_generic,
		"en-AU": en_AU.organisms_forms_errors_generic,
		"en-GB": en_GB.organisms_forms_errors_generic,
		"en-US": en_US.organisms_forms_errors_generic,
		"es-ES": es_ES.organisms_forms_errors_generic,
		"fr-FR": fr_FR.organisms_forms_errors_generic,
		"it-IT": it_IT.organisms_forms_errors_generic,
		"ko-KR": ko_KR.organisms_forms_errors_generic,
		"pt-BR": pt_BR.organisms_forms_errors_generic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_errors_rateLimit,
		"en-AU": en_AU.organisms_forms_errors_rateLimit,
		"en-GB": en_GB.organisms_forms_errors_rateLimit,
		"en-US": en_US.organisms_forms_errors_rateLimit,
		"es-ES": es_ES.organisms_forms_errors_rateLimit,
		"fr-FR": fr_FR.organisms_forms_errors_rateLimit,
		"it-IT": it_IT.organisms_forms_errors_rateLimit,
		"ko-KR": ko_KR.organisms_forms_errors_rateLimit,
		"pt-BR": pt_BR.organisms_forms_errors_rateLimit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_errors_recaptcha,
		"en-AU": en_AU.organisms_forms_errors_recaptcha,
		"en-GB": en_GB.organisms_forms_errors_recaptcha,
		"en-US": en_US.organisms_forms_errors_recaptcha,
		"es-ES": es_ES.organisms_forms_errors_recaptcha,
		"fr-FR": fr_FR.organisms_forms_errors_recaptcha,
		"it-IT": it_IT.organisms_forms_errors_recaptcha,
		"ko-KR": ko_KR.organisms_forms_errors_recaptcha,
		"pt-BR": pt_BR.organisms_forms_errors_recaptcha
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_full_name_label,
		"en-AU": en_AU.organisms_forms_fields_full_name_label,
		"en-GB": en_GB.organisms_forms_fields_full_name_label,
		"en-US": en_US.organisms_forms_fields_full_name_label,
		"es-ES": es_ES.organisms_forms_fields_full_name_label,
		"fr-FR": fr_FR.organisms_forms_fields_full_name_label,
		"it-IT": it_IT.organisms_forms_fields_full_name_label,
		"ko-KR": ko_KR.organisms_forms_fields_full_name_label,
		"pt-BR": pt_BR.organisms_forms_fields_full_name_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_full_name_placeholder,
		"en-AU": en_AU.organisms_forms_fields_full_name_placeholder,
		"en-GB": en_GB.organisms_forms_fields_full_name_placeholder,
		"en-US": en_US.organisms_forms_fields_full_name_placeholder,
		"es-ES": es_ES.organisms_forms_fields_full_name_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_full_name_placeholder,
		"it-IT": it_IT.organisms_forms_fields_full_name_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_full_name_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_full_name_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_full_name_errors_required,
		"en-AU": en_AU.organisms_forms_fields_full_name_errors_required,
		"en-GB": en_GB.organisms_forms_fields_full_name_errors_required,
		"en-US": en_US.organisms_forms_fields_full_name_errors_required,
		"es-ES": es_ES.organisms_forms_fields_full_name_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_full_name_errors_required,
		"it-IT": it_IT.organisms_forms_fields_full_name_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_full_name_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_full_name_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_email_label,
		"en-AU": en_AU.organisms_forms_fields_email_label,
		"en-GB": en_GB.organisms_forms_fields_email_label,
		"en-US": en_US.organisms_forms_fields_email_label,
		"es-ES": es_ES.organisms_forms_fields_email_label,
		"fr-FR": fr_FR.organisms_forms_fields_email_label,
		"it-IT": it_IT.organisms_forms_fields_email_label,
		"ko-KR": ko_KR.organisms_forms_fields_email_label,
		"pt-BR": pt_BR.organisms_forms_fields_email_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_email_placeholder,
		"en-AU": en_AU.organisms_forms_fields_email_placeholder,
		"en-GB": en_GB.organisms_forms_fields_email_placeholder,
		"en-US": en_US.organisms_forms_fields_email_placeholder,
		"es-ES": es_ES.organisms_forms_fields_email_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_email_placeholder,
		"it-IT": it_IT.organisms_forms_fields_email_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_email_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_email_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_email_errors_email,
		"en-AU": en_AU.organisms_forms_fields_email_errors_email,
		"en-GB": en_GB.organisms_forms_fields_email_errors_email,
		"en-US": en_US.organisms_forms_fields_email_errors_email,
		"es-ES": es_ES.organisms_forms_fields_email_errors_email,
		"fr-FR": fr_FR.organisms_forms_fields_email_errors_email,
		"it-IT": it_IT.organisms_forms_fields_email_errors_email,
		"ko-KR": ko_KR.organisms_forms_fields_email_errors_email,
		"pt-BR": pt_BR.organisms_forms_fields_email_errors_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_email_errors_required,
		"en-AU": en_AU.organisms_forms_fields_email_errors_required,
		"en-GB": en_GB.organisms_forms_fields_email_errors_required,
		"en-US": en_US.organisms_forms_fields_email_errors_required,
		"es-ES": es_ES.organisms_forms_fields_email_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_email_errors_required,
		"it-IT": it_IT.organisms_forms_fields_email_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_email_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_email_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_label,
		"en-AU": en_AU.organisms_forms_fields_password_label,
		"en-GB": en_GB.organisms_forms_fields_password_label,
		"en-US": en_US.organisms_forms_fields_password_label,
		"es-ES": es_ES.organisms_forms_fields_password_label,
		"fr-FR": fr_FR.organisms_forms_fields_password_label,
		"it-IT": it_IT.organisms_forms_fields_password_label,
		"ko-KR": ko_KR.organisms_forms_fields_password_label,
		"pt-BR": pt_BR.organisms_forms_fields_password_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_placeholder,
		"en-AU": en_AU.organisms_forms_fields_password_placeholder,
		"en-GB": en_GB.organisms_forms_fields_password_placeholder,
		"en-US": en_US.organisms_forms_fields_password_placeholder,
		"es-ES": es_ES.organisms_forms_fields_password_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_password_placeholder,
		"it-IT": it_IT.organisms_forms_fields_password_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_password_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_password_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_errors_common,
		"en-AU": en_AU.organisms_forms_fields_password_errors_common,
		"en-GB": en_GB.organisms_forms_fields_password_errors_common,
		"en-US": en_US.organisms_forms_fields_password_errors_common,
		"es-ES": es_ES.organisms_forms_fields_password_errors_common,
		"fr-FR": fr_FR.organisms_forms_fields_password_errors_common,
		"it-IT": it_IT.organisms_forms_fields_password_errors_common,
		"ko-KR": ko_KR.organisms_forms_fields_password_errors_common,
		"pt-BR": pt_BR.organisms_forms_fields_password_errors_common
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_errors_min,
		"en-AU": en_AU.organisms_forms_fields_password_errors_min,
		"en-GB": en_GB.organisms_forms_fields_password_errors_min,
		"en-US": en_US.organisms_forms_fields_password_errors_min,
		"es-ES": es_ES.organisms_forms_fields_password_errors_min,
		"fr-FR": fr_FR.organisms_forms_fields_password_errors_min,
		"it-IT": it_IT.organisms_forms_fields_password_errors_min,
		"ko-KR": ko_KR.organisms_forms_fields_password_errors_min,
		"pt-BR": pt_BR.organisms_forms_fields_password_errors_min
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_errors_max,
		"en-AU": en_AU.organisms_forms_fields_password_errors_max,
		"en-GB": en_GB.organisms_forms_fields_password_errors_max,
		"en-US": en_US.organisms_forms_fields_password_errors_max,
		"es-ES": es_ES.organisms_forms_fields_password_errors_max,
		"fr-FR": fr_FR.organisms_forms_fields_password_errors_max,
		"it-IT": it_IT.organisms_forms_fields_password_errors_max,
		"ko-KR": ko_KR.organisms_forms_fields_password_errors_max,
		"pt-BR": pt_BR.organisms_forms_fields_password_errors_max
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_password_errors_required,
		"en-AU": en_AU.organisms_forms_fields_password_errors_required,
		"en-GB": en_GB.organisms_forms_fields_password_errors_required,
		"en-US": en_US.organisms_forms_fields_password_errors_required,
		"es-ES": es_ES.organisms_forms_fields_password_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_password_errors_required,
		"it-IT": it_IT.organisms_forms_fields_password_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_password_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_password_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_label,
		"en-AU": en_AU.organisms_forms_fields_company_label,
		"en-GB": en_GB.organisms_forms_fields_company_label,
		"en-US": en_US.organisms_forms_fields_company_label,
		"es-ES": es_ES.organisms_forms_fields_company_label,
		"fr-FR": fr_FR.organisms_forms_fields_company_label,
		"it-IT": it_IT.organisms_forms_fields_company_label,
		"ko-KR": ko_KR.organisms_forms_fields_company_label,
		"pt-BR": pt_BR.organisms_forms_fields_company_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_placeholder,
		"en-AU": en_AU.organisms_forms_fields_company_placeholder,
		"en-GB": en_GB.organisms_forms_fields_company_placeholder,
		"en-US": en_US.organisms_forms_fields_company_placeholder,
		"es-ES": es_ES.organisms_forms_fields_company_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_company_placeholder,
		"it-IT": it_IT.organisms_forms_fields_company_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_company_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_company_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_errors_required,
		"en-AU": en_AU.organisms_forms_fields_company_errors_required,
		"en-GB": en_GB.organisms_forms_fields_company_errors_required,
		"en-US": en_US.organisms_forms_fields_company_errors_required,
		"es-ES": es_ES.organisms_forms_fields_company_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_company_errors_required,
		"it-IT": it_IT.organisms_forms_fields_company_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_company_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_company_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_website_label,
		"en-AU": en_AU.organisms_forms_fields_company_website_label,
		"en-GB": en_GB.organisms_forms_fields_company_website_label,
		"en-US": en_US.organisms_forms_fields_company_website_label,
		"es-ES": es_ES.organisms_forms_fields_company_website_label,
		"fr-FR": fr_FR.organisms_forms_fields_company_website_label,
		"it-IT": it_IT.organisms_forms_fields_company_website_label,
		"ko-KR": ko_KR.organisms_forms_fields_company_website_label,
		"pt-BR": pt_BR.organisms_forms_fields_company_website_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_website_placeholder,
		"en-AU": en_AU.organisms_forms_fields_company_website_placeholder,
		"en-GB": en_GB.organisms_forms_fields_company_website_placeholder,
		"en-US": en_US.organisms_forms_fields_company_website_placeholder,
		"es-ES": es_ES.organisms_forms_fields_company_website_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_company_website_placeholder,
		"it-IT": it_IT.organisms_forms_fields_company_website_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_company_website_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_company_website_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_website_errors_url,
		"en-AU": en_AU.organisms_forms_fields_company_website_errors_url,
		"en-GB": en_GB.organisms_forms_fields_company_website_errors_url,
		"en-US": en_US.organisms_forms_fields_company_website_errors_url,
		"es-ES": es_ES.organisms_forms_fields_company_website_errors_url,
		"fr-FR": fr_FR.organisms_forms_fields_company_website_errors_url,
		"it-IT": it_IT.organisms_forms_fields_company_website_errors_url,
		"ko-KR": ko_KR.organisms_forms_fields_company_website_errors_url,
		"pt-BR": pt_BR.organisms_forms_fields_company_website_errors_url
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_website_errors_required,
		"en-AU": en_AU.organisms_forms_fields_company_website_errors_required,
		"en-GB": en_GB.organisms_forms_fields_company_website_errors_required,
		"en-US": en_US.organisms_forms_fields_company_website_errors_required,
		"es-ES": es_ES.organisms_forms_fields_company_website_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_company_website_errors_required,
		"it-IT": it_IT.organisms_forms_fields_company_website_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_company_website_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_company_website_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_phone_label,
		"en-AU": en_AU.organisms_forms_fields_phone_label,
		"en-GB": en_GB.organisms_forms_fields_phone_label,
		"en-US": en_US.organisms_forms_fields_phone_label,
		"es-ES": es_ES.organisms_forms_fields_phone_label,
		"fr-FR": fr_FR.organisms_forms_fields_phone_label,
		"it-IT": it_IT.organisms_forms_fields_phone_label,
		"ko-KR": ko_KR.organisms_forms_fields_phone_label,
		"pt-BR": pt_BR.organisms_forms_fields_phone_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_phone_placeholder,
		"en-AU": en_AU.organisms_forms_fields_phone_placeholder,
		"en-GB": en_GB.organisms_forms_fields_phone_placeholder,
		"en-US": en_US.organisms_forms_fields_phone_placeholder,
		"es-ES": es_ES.organisms_forms_fields_phone_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_phone_placeholder,
		"it-IT": it_IT.organisms_forms_fields_phone_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_phone_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_phone_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_phone_errors_matches,
		"en-AU": en_AU.organisms_forms_fields_phone_errors_matches,
		"en-GB": en_GB.organisms_forms_fields_phone_errors_matches,
		"en-US": en_US.organisms_forms_fields_phone_errors_matches,
		"es-ES": es_ES.organisms_forms_fields_phone_errors_matches,
		"fr-FR": fr_FR.organisms_forms_fields_phone_errors_matches,
		"it-IT": it_IT.organisms_forms_fields_phone_errors_matches,
		"ko-KR": ko_KR.organisms_forms_fields_phone_errors_matches,
		"pt-BR": pt_BR.organisms_forms_fields_phone_errors_matches
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_phone_errors_max,
		"en-AU": en_AU.organisms_forms_fields_phone_errors_max,
		"en-GB": en_GB.organisms_forms_fields_phone_errors_max,
		"en-US": en_US.organisms_forms_fields_phone_errors_max,
		"es-ES": es_ES.organisms_forms_fields_phone_errors_max,
		"fr-FR": fr_FR.organisms_forms_fields_phone_errors_max,
		"it-IT": it_IT.organisms_forms_fields_phone_errors_max,
		"ko-KR": ko_KR.organisms_forms_fields_phone_errors_max,
		"pt-BR": pt_BR.organisms_forms_fields_phone_errors_max
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_phone_errors_required,
		"en-AU": en_AU.organisms_forms_fields_phone_errors_required,
		"en-GB": en_GB.organisms_forms_fields_phone_errors_required,
		"en-US": en_US.organisms_forms_fields_phone_errors_required,
		"es-ES": es_ES.organisms_forms_fields_phone_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_phone_errors_required,
		"it-IT": it_IT.organisms_forms_fields_phone_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_phone_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_phone_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_label,
		"en-AU": en_AU.organisms_forms_fields_field_15_label,
		"en-GB": en_GB.organisms_forms_fields_field_15_label,
		"en-US": en_US.organisms_forms_fields_field_15_label,
		"es-ES": es_ES.organisms_forms_fields_field_15_label,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_label,
		"it-IT": it_IT.organisms_forms_fields_field_15_label,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_label,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_placeholder,
		"en-AU": en_AU.organisms_forms_fields_field_15_placeholder,
		"en-GB": en_GB.organisms_forms_fields_field_15_placeholder,
		"en-US": en_US.organisms_forms_fields_field_15_placeholder,
		"es-ES": es_ES.organisms_forms_fields_field_15_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_placeholder,
		"it-IT": it_IT.organisms_forms_fields_field_15_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_options_underFive,
		"en-AU": en_AU.organisms_forms_fields_field_15_options_underFive,
		"en-GB": en_GB.organisms_forms_fields_field_15_options_underFive,
		"en-US": en_US.organisms_forms_fields_field_15_options_underFive,
		"es-ES": es_ES.organisms_forms_fields_field_15_options_underFive,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_options_underFive,
		"it-IT": it_IT.organisms_forms_fields_field_15_options_underFive,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_options_underFive,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_options_underFive
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_options_five,
		"en-AU": en_AU.organisms_forms_fields_field_15_options_five,
		"en-GB": en_GB.organisms_forms_fields_field_15_options_five,
		"en-US": en_US.organisms_forms_fields_field_15_options_five,
		"es-ES": es_ES.organisms_forms_fields_field_15_options_five,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_options_five,
		"it-IT": it_IT.organisms_forms_fields_field_15_options_five,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_options_five,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_options_five
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_options_twenty,
		"en-AU": en_AU.organisms_forms_fields_field_15_options_twenty,
		"en-GB": en_GB.organisms_forms_fields_field_15_options_twenty,
		"en-US": en_US.organisms_forms_fields_field_15_options_twenty,
		"es-ES": es_ES.organisms_forms_fields_field_15_options_twenty,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_options_twenty,
		"it-IT": it_IT.organisms_forms_fields_field_15_options_twenty,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_options_twenty,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_options_twenty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_options_fourHundred,
		"en-AU": en_AU.organisms_forms_fields_field_15_options_fourHundred,
		"en-GB": en_GB.organisms_forms_fields_field_15_options_fourHundred,
		"en-US": en_US.organisms_forms_fields_field_15_options_fourHundred,
		"es-ES": es_ES.organisms_forms_fields_field_15_options_fourHundred,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_options_fourHundred,
		"it-IT": it_IT.organisms_forms_fields_field_15_options_fourHundred,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_options_fourHundred,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_options_fourHundred
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_15_errors_required,
		"en-AU": en_AU.organisms_forms_fields_field_15_errors_required,
		"en-GB": en_GB.organisms_forms_fields_field_15_errors_required,
		"en-US": en_US.organisms_forms_fields_field_15_errors_required,
		"es-ES": es_ES.organisms_forms_fields_field_15_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_field_15_errors_required,
		"it-IT": it_IT.organisms_forms_fields_field_15_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_field_15_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_field_15_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_16_label,
		"en-AU": en_AU.organisms_forms_fields_field_16_label,
		"en-GB": en_GB.organisms_forms_fields_field_16_label,
		"en-US": en_US.organisms_forms_fields_field_16_label,
		"es-ES": es_ES.organisms_forms_fields_field_16_label,
		"fr-FR": fr_FR.organisms_forms_fields_field_16_label,
		"it-IT": it_IT.organisms_forms_fields_field_16_label,
		"ko-KR": ko_KR.organisms_forms_fields_field_16_label,
		"pt-BR": pt_BR.organisms_forms_fields_field_16_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_16_placeholder,
		"en-AU": en_AU.organisms_forms_fields_field_16_placeholder,
		"en-GB": en_GB.organisms_forms_fields_field_16_placeholder,
		"en-US": en_US.organisms_forms_fields_field_16_placeholder,
		"es-ES": es_ES.organisms_forms_fields_field_16_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_field_16_placeholder,
		"it-IT": it_IT.organisms_forms_fields_field_16_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_field_16_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_field_16_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_16_options_ownBusiness,
		"en-AU": en_AU.organisms_forms_fields_field_16_options_ownBusiness,
		"en-GB": en_GB.organisms_forms_fields_field_16_options_ownBusiness,
		"en-US": en_US.organisms_forms_fields_field_16_options_ownBusiness,
		"es-ES": es_ES.organisms_forms_fields_field_16_options_ownBusiness,
		"fr-FR": fr_FR.organisms_forms_fields_field_16_options_ownBusiness,
		"it-IT": it_IT.organisms_forms_fields_field_16_options_ownBusiness,
		"ko-KR": ko_KR.organisms_forms_fields_field_16_options_ownBusiness,
		"pt-BR": pt_BR.organisms_forms_fields_field_16_options_ownBusiness
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_16_options_clientsBusiness,
		"en-AU": en_AU.organisms_forms_fields_field_16_options_clientsBusiness,
		"en-GB": en_GB.organisms_forms_fields_field_16_options_clientsBusiness,
		"en-US": en_US.organisms_forms_fields_field_16_options_clientsBusiness,
		"es-ES": es_ES.organisms_forms_fields_field_16_options_clientsBusiness,
		"fr-FR": fr_FR.organisms_forms_fields_field_16_options_clientsBusiness,
		"it-IT": it_IT.organisms_forms_fields_field_16_options_clientsBusiness,
		"ko-KR": ko_KR.organisms_forms_fields_field_16_options_clientsBusiness,
		"pt-BR": pt_BR.organisms_forms_fields_field_16_options_clientsBusiness
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_16_errors_required,
		"en-AU": en_AU.organisms_forms_fields_field_16_errors_required,
		"en-GB": en_GB.organisms_forms_fields_field_16_errors_required,
		"en-US": en_US.organisms_forms_fields_field_16_errors_required,
		"es-ES": es_ES.organisms_forms_fields_field_16_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_field_16_errors_required,
		"it-IT": it_IT.organisms_forms_fields_field_16_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_field_16_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_field_16_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_label,
		"en-AU": en_AU.organisms_forms_fields_field_17_label,
		"en-GB": en_GB.organisms_forms_fields_field_17_label,
		"en-US": en_US.organisms_forms_fields_field_17_label,
		"es-ES": es_ES.organisms_forms_fields_field_17_label,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_label,
		"it-IT": it_IT.organisms_forms_fields_field_17_label,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_label,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_placeholder,
		"en-AU": en_AU.organisms_forms_fields_field_17_placeholder,
		"en-GB": en_GB.organisms_forms_fields_field_17_placeholder,
		"en-US": en_US.organisms_forms_fields_field_17_placeholder,
		"es-ES": es_ES.organisms_forms_fields_field_17_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_placeholder,
		"it-IT": it_IT.organisms_forms_fields_field_17_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_options_retailGoods,
		"en-AU": en_AU.organisms_forms_fields_field_17_options_retailGoods,
		"en-GB": en_GB.organisms_forms_fields_field_17_options_retailGoods,
		"en-US": en_US.organisms_forms_fields_field_17_options_retailGoods,
		"es-ES": es_ES.organisms_forms_fields_field_17_options_retailGoods,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_options_retailGoods,
		"it-IT": it_IT.organisms_forms_fields_field_17_options_retailGoods,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_options_retailGoods,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_options_retailGoods
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_options_retailServices,
		"en-AU": en_AU.organisms_forms_fields_field_17_options_retailServices,
		"en-GB": en_GB.organisms_forms_fields_field_17_options_retailServices,
		"en-US": en_US.organisms_forms_fields_field_17_options_retailServices,
		"es-ES": es_ES.organisms_forms_fields_field_17_options_retailServices,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_options_retailServices,
		"it-IT": it_IT.organisms_forms_fields_field_17_options_retailServices,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_options_retailServices,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_options_retailServices
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_options_other,
		"en-AU": en_AU.organisms_forms_fields_field_17_options_other,
		"en-GB": en_GB.organisms_forms_fields_field_17_options_other,
		"en-US": en_US.organisms_forms_fields_field_17_options_other,
		"es-ES": es_ES.organisms_forms_fields_field_17_options_other,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_options_other,
		"it-IT": it_IT.organisms_forms_fields_field_17_options_other,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_options_other,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_options_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_field_17_errors_required,
		"en-AU": en_AU.organisms_forms_fields_field_17_errors_required,
		"en-GB": en_GB.organisms_forms_fields_field_17_errors_required,
		"en-US": en_US.organisms_forms_fields_field_17_errors_required,
		"es-ES": es_ES.organisms_forms_fields_field_17_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_field_17_errors_required,
		"it-IT": it_IT.organisms_forms_fields_field_17_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_field_17_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_field_17_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_label,
		"en-AU": en_AU.organisms_forms_fields_company_size_label,
		"en-GB": en_GB.organisms_forms_fields_company_size_label,
		"en-US": en_US.organisms_forms_fields_company_size_label,
		"es-ES": es_ES.organisms_forms_fields_company_size_label,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_label,
		"it-IT": it_IT.organisms_forms_fields_company_size_label,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_label,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_placeholder,
		"en-AU": en_AU.organisms_forms_fields_company_size_placeholder,
		"en-GB": en_GB.organisms_forms_fields_company_size_placeholder,
		"en-US": en_US.organisms_forms_fields_company_size_placeholder,
		"es-ES": es_ES.organisms_forms_fields_company_size_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_placeholder,
		"it-IT": it_IT.organisms_forms_fields_company_size_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_zero,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_zero,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_zero,
		"en-US": en_US.organisms_forms_fields_company_size_options_zero,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_zero,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_zero,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_zero,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_zero,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_zero
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_one,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_one,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_one,
		"en-US": en_US.organisms_forms_fields_company_size_options_one,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_one,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_one,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_one,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_one,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_one
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_three,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_three,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_three,
		"en-US": en_US.organisms_forms_fields_company_size_options_three,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_three,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_three,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_three,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_three,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_three
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_twentyFive,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_twentyFive,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_twentyFive,
		"en-US": en_US.organisms_forms_fields_company_size_options_twentyFive,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_twentyFive,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_twentyFive,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_twentyFive,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_twentyFive,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_twentyFive
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_oneHundred,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_oneHundred,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_oneHundred,
		"en-US": en_US.organisms_forms_fields_company_size_options_oneHundred,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_oneHundred,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_oneHundred,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_oneHundred,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_oneHundred,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_oneHundred
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_fiveHundred,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_fiveHundred,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_fiveHundred,
		"en-US": en_US.organisms_forms_fields_company_size_options_fiveHundred,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_fiveHundred,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_fiveHundred,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_fiveHundred,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_fiveHundred,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_fiveHundred
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_options_oneMillion,
		"en-AU": en_AU.organisms_forms_fields_company_size_options_oneMillion,
		"en-GB": en_GB.organisms_forms_fields_company_size_options_oneMillion,
		"en-US": en_US.organisms_forms_fields_company_size_options_oneMillion,
		"es-ES": es_ES.organisms_forms_fields_company_size_options_oneMillion,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_options_oneMillion,
		"it-IT": it_IT.organisms_forms_fields_company_size_options_oneMillion,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_options_oneMillion,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_options_oneMillion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_company_size_errors_required,
		"en-AU": en_AU.organisms_forms_fields_company_size_errors_required,
		"en-GB": en_GB.organisms_forms_fields_company_size_errors_required,
		"en-US": en_US.organisms_forms_fields_company_size_errors_required,
		"es-ES": es_ES.organisms_forms_fields_company_size_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_company_size_errors_required,
		"it-IT": it_IT.organisms_forms_fields_company_size_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_company_size_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_company_size_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_label,
		"en-AU": en_AU.organisms_forms_fields_product_interest_label,
		"en-GB": en_GB.organisms_forms_fields_product_interest_label,
		"en-US": en_US.organisms_forms_fields_product_interest_label,
		"es-ES": es_ES.organisms_forms_fields_product_interest_label,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_label,
		"it-IT": it_IT.organisms_forms_fields_product_interest_label,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_label,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_placeholder,
		"en-AU": en_AU.organisms_forms_fields_product_interest_placeholder,
		"en-GB": en_GB.organisms_forms_fields_product_interest_placeholder,
		"en-US": en_US.organisms_forms_fields_product_interest_placeholder,
		"es-ES": es_ES.organisms_forms_fields_product_interest_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_placeholder,
		"it-IT": it_IT.organisms_forms_fields_product_interest_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_options_email,
		"en-AU": en_AU.organisms_forms_fields_product_interest_options_email,
		"en-GB": en_GB.organisms_forms_fields_product_interest_options_email,
		"en-US": en_US.organisms_forms_fields_product_interest_options_email,
		"es-ES": es_ES.organisms_forms_fields_product_interest_options_email,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_options_email,
		"it-IT": it_IT.organisms_forms_fields_product_interest_options_email,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_options_email,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_options_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_options_sms,
		"en-AU": en_AU.organisms_forms_fields_product_interest_options_sms,
		"en-GB": en_GB.organisms_forms_fields_product_interest_options_sms,
		"en-US": en_US.organisms_forms_fields_product_interest_options_sms,
		"es-ES": es_ES.organisms_forms_fields_product_interest_options_sms,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_options_sms,
		"it-IT": it_IT.organisms_forms_fields_product_interest_options_sms,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_options_sms,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_options_sms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_options_cdp,
		"en-AU": en_AU.organisms_forms_fields_product_interest_options_cdp,
		"en-GB": en_GB.organisms_forms_fields_product_interest_options_cdp,
		"en-US": en_US.organisms_forms_fields_product_interest_options_cdp,
		"es-ES": es_ES.organisms_forms_fields_product_interest_options_cdp,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_options_cdp,
		"it-IT": it_IT.organisms_forms_fields_product_interest_options_cdp,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_options_cdp,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_options_cdp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_options_reviews,
		"en-AU": en_AU.organisms_forms_fields_product_interest_options_reviews,
		"en-GB": en_GB.organisms_forms_fields_product_interest_options_reviews,
		"en-US": en_US.organisms_forms_fields_product_interest_options_reviews,
		"es-ES": es_ES.organisms_forms_fields_product_interest_options_reviews,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_options_reviews,
		"it-IT": it_IT.organisms_forms_fields_product_interest_options_reviews,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_options_reviews,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_options_reviews
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_options_mobile_push,
		"en-AU": en_AU.organisms_forms_fields_product_interest_options_mobile_push,
		"en-GB": en_GB.organisms_forms_fields_product_interest_options_mobile_push,
		"en-US": en_US.organisms_forms_fields_product_interest_options_mobile_push,
		"es-ES": es_ES.organisms_forms_fields_product_interest_options_mobile_push,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_options_mobile_push,
		"it-IT": it_IT.organisms_forms_fields_product_interest_options_mobile_push,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_options_mobile_push,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_options_mobile_push
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_product_interest_errors_required,
		"en-AU": en_AU.organisms_forms_fields_product_interest_errors_required,
		"en-GB": en_GB.organisms_forms_fields_product_interest_errors_required,
		"en-US": en_US.organisms_forms_fields_product_interest_errors_required,
		"es-ES": es_ES.organisms_forms_fields_product_interest_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_product_interest_errors_required,
		"it-IT": it_IT.organisms_forms_fields_product_interest_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_product_interest_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_product_interest_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_label,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_label,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_label,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_label,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_label,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_label,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_label,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_label,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_placeholder,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_placeholder,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_placeholder,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_placeholder,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_placeholder,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_placeholder,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_placeholder,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_placeholder,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Magento,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Magento,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Magento,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Magento,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Magento,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Magento,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Magento,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Magento,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Magento
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_BigCommerce,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_BigCommerce
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Commercetools,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Commercetools
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Nuvemshop,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Nuvemshop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_OpenCart,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_OpenCart
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_PrestaShop,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_PrestaShop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Salesforce,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Salesforce
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Shopify,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Shopify,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Shopify,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Shopify,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Shopify,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Shopify,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Shopify,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Shopify,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Shopify
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_ShopifyPlus,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_ShopifyPlus
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Shopware,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Shopware,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Shopware,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Shopware,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Shopware,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Shopware,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Shopware,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Shopware,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Shopware
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_SquareOnline,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_SquareOnline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_Wix,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_Wix,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_Wix,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_Wix,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_Wix,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_Wix,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_Wix,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_Wix,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_Wix
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_WooCommerce,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_WooCommerce
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_other,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_other,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_other,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_other,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_other,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_other,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_other,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_other,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_custom,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_custom,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_custom,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_custom,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_custom,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_custom,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_custom,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_custom,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_custom
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_options_doesNotApply,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_options_doesNotApply
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_ecomm_platform_errors_required,
		"en-AU": en_AU.organisms_forms_fields_ecomm_platform_errors_required,
		"en-GB": en_GB.organisms_forms_fields_ecomm_platform_errors_required,
		"en-US": en_US.organisms_forms_fields_ecomm_platform_errors_required,
		"es-ES": es_ES.organisms_forms_fields_ecomm_platform_errors_required,
		"fr-FR": fr_FR.organisms_forms_fields_ecomm_platform_errors_required,
		"it-IT": it_IT.organisms_forms_fields_ecomm_platform_errors_required,
		"ko-KR": ko_KR.organisms_forms_fields_ecomm_platform_errors_required,
		"pt-BR": pt_BR.organisms_forms_fields_ecomm_platform_errors_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_newsletter_label,
		"en-AU": en_AU.organisms_forms_fields_newsletter_label,
		"en-GB": en_GB.organisms_forms_fields_newsletter_label,
		"en-US": en_US.organisms_forms_fields_newsletter_label,
		"es-ES": es_ES.organisms_forms_fields_newsletter_label,
		"fr-FR": fr_FR.organisms_forms_fields_newsletter_label,
		"it-IT": it_IT.organisms_forms_fields_newsletter_label,
		"ko-KR": ko_KR.organisms_forms_fields_newsletter_label,
		"pt-BR": pt_BR.organisms_forms_fields_newsletter_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_agency_label,
		"en-AU": en_AU.organisms_forms_fields_agency_label,
		"en-GB": en_GB.organisms_forms_fields_agency_label,
		"en-US": en_US.organisms_forms_fields_agency_label,
		"es-ES": es_ES.organisms_forms_fields_agency_label,
		"fr-FR": fr_FR.organisms_forms_fields_agency_label,
		"it-IT": it_IT.organisms_forms_fields_agency_label,
		"ko-KR": ko_KR.organisms_forms_fields_agency_label,
		"pt-BR": pt_BR.organisms_forms_fields_agency_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_fields_demo_requested_label,
		"en-AU": en_AU.organisms_forms_fields_demo_requested_label,
		"en-GB": en_GB.organisms_forms_fields_demo_requested_label,
		"en-US": en_US.organisms_forms_fields_demo_requested_label,
		"es-ES": es_ES.organisms_forms_fields_demo_requested_label,
		"fr-FR": fr_FR.organisms_forms_fields_demo_requested_label,
		"it-IT": it_IT.organisms_forms_fields_demo_requested_label,
		"ko-KR": ko_KR.organisms_forms_fields_demo_requested_label,
		"pt-BR": pt_BR.organisms_forms_fields_demo_requested_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_breadcrumb_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_breadcrumb_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_breadcrumb_label,
		"en-US": en_US.organisms_forms_accountAccessForm_breadcrumb_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_breadcrumb_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_breadcrumb_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_breadcrumb_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_breadcrumb_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_breadcrumb_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_breadcrumb_href,
		"en-AU": en_AU.organisms_forms_accountAccessForm_breadcrumb_href,
		"en-GB": en_GB.organisms_forms_accountAccessForm_breadcrumb_href,
		"en-US": en_US.organisms_forms_accountAccessForm_breadcrumb_href,
		"es-ES": es_ES.organisms_forms_accountAccessForm_breadcrumb_href,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_breadcrumb_href,
		"it-IT": it_IT.organisms_forms_accountAccessForm_breadcrumb_href,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_breadcrumb_href,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_breadcrumb_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_currentBreadcrumb,
		"en-AU": en_AU.organisms_forms_accountAccessForm_currentBreadcrumb,
		"en-GB": en_GB.organisms_forms_accountAccessForm_currentBreadcrumb,
		"en-US": en_US.organisms_forms_accountAccessForm_currentBreadcrumb,
		"es-ES": es_ES.organisms_forms_accountAccessForm_currentBreadcrumb,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_currentBreadcrumb,
		"it-IT": it_IT.organisms_forms_accountAccessForm_currentBreadcrumb,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_currentBreadcrumb,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_currentBreadcrumb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_articleMetaTitle,
		"en-AU": en_AU.organisms_forms_accountAccessForm_articleMetaTitle,
		"en-GB": en_GB.organisms_forms_accountAccessForm_articleMetaTitle,
		"en-US": en_US.organisms_forms_accountAccessForm_articleMetaTitle,
		"es-ES": es_ES.organisms_forms_accountAccessForm_articleMetaTitle,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_articleMetaTitle,
		"it-IT": it_IT.organisms_forms_accountAccessForm_articleMetaTitle,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_articleMetaTitle,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_articleMetaTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_headline,
		"en-AU": en_AU.organisms_forms_accountAccessForm_headline,
		"en-GB": en_GB.organisms_forms_accountAccessForm_headline,
		"en-US": en_US.organisms_forms_accountAccessForm_headline,
		"es-ES": es_ES.organisms_forms_accountAccessForm_headline,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_headline,
		"it-IT": it_IT.organisms_forms_accountAccessForm_headline,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_headline,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_subhead,
		"en-AU": en_AU.organisms_forms_accountAccessForm_subhead,
		"en-GB": en_GB.organisms_forms_accountAccessForm_subhead,
		"en-US": en_US.organisms_forms_accountAccessForm_subhead,
		"es-ES": es_ES.organisms_forms_accountAccessForm_subhead,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_subhead,
		"it-IT": it_IT.organisms_forms_accountAccessForm_subhead,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_subhead,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_error_email,
		"en-AU": en_AU.organisms_forms_accountAccessForm_error_email,
		"en-GB": en_GB.organisms_forms_accountAccessForm_error_email,
		"en-US": en_US.organisms_forms_accountAccessForm_error_email,
		"es-ES": es_ES.organisms_forms_accountAccessForm_error_email,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_error_email,
		"it-IT": it_IT.organisms_forms_accountAccessForm_error_email,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_error_email,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_error_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_error_websiteUrl,
		"en-AU": en_AU.organisms_forms_accountAccessForm_error_websiteUrl,
		"en-GB": en_GB.organisms_forms_accountAccessForm_error_websiteUrl,
		"en-US": en_US.organisms_forms_accountAccessForm_error_websiteUrl,
		"es-ES": es_ES.organisms_forms_accountAccessForm_error_websiteUrl,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_error_websiteUrl,
		"it-IT": it_IT.organisms_forms_accountAccessForm_error_websiteUrl,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_error_websiteUrl,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_error_websiteUrl
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_error_issueRecipeients,
		"en-AU": en_AU.organisms_forms_accountAccessForm_error_issueRecipeients,
		"en-GB": en_GB.organisms_forms_accountAccessForm_error_issueRecipeients,
		"en-US": en_US.organisms_forms_accountAccessForm_error_issueRecipeients,
		"es-ES": es_ES.organisms_forms_accountAccessForm_error_issueRecipeients,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_error_issueRecipeients,
		"it-IT": it_IT.organisms_forms_accountAccessForm_error_issueRecipeients,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_error_issueRecipeients,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_error_issueRecipeients
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_error_required,
		"en-AU": en_AU.organisms_forms_accountAccessForm_error_required,
		"en-GB": en_GB.organisms_forms_accountAccessForm_error_required,
		"en-US": en_US.organisms_forms_accountAccessForm_error_required,
		"es-ES": es_ES.organisms_forms_accountAccessForm_error_required,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_error_required,
		"it-IT": it_IT.organisms_forms_accountAccessForm_error_required,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_error_required,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_error_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issue_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issue_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issue_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issue_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issue_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issue_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issue_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issue_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issue_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issue_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issue_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issue_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issue_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issue_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issue_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issue_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issue_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issue_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_account_disabled,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_account_disabled
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_forgot_password,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_forgot_password
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_invoice_inquiry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_2_step_authentication,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_2_step_authentication
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_new_device_code,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_new_device_code
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_new_account_owner,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_new_account_owner
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_name_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_name_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_name_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_name_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_name_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_name_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_name_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_name_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_name_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_name_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_name_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_name_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_name_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_name_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_name_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_name_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_name_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_name_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_account_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_account_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_account_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_account_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_account_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_account_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_account_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_account_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_account_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_account_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_account_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_account_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_account_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_account_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_account_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_account_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_account_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_account_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_email_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_email_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_email_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_email_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_email_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_email_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_email_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_email_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_email_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_email_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_email_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_email_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_email_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_email_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_email_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_email_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_email_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_email_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_websiteUrl_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_websiteUrl_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_websiteUrl_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_websiteUrl_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_help_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_help_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_help_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_help_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_help_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_help_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_help_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_help_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_help_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_help_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_help_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_help_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_help_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_help_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_help_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_help_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_help_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_help_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_addRecipients_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_addRecipients_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_addRecipients_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_addRecipients_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_addRecipients_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_addRecipients_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_addRecipients_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_addRecipients_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_addRecipients_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_addRecipients_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_addRecipients_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_addRecipients_button_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_addRecipients_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_submit_button_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_submit_button_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_submit_button_label,
		"en-US": en_US.organisms_forms_accountAccessForm_form_submit_button_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_submit_button_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_submit_button_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_submit_button_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_submit_button_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_submit_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_success_headline,
		"en-AU": en_AU.organisms_forms_accountAccessForm_success_headline,
		"en-GB": en_GB.organisms_forms_accountAccessForm_success_headline,
		"en-US": en_US.organisms_forms_accountAccessForm_success_headline,
		"es-ES": es_ES.organisms_forms_accountAccessForm_success_headline,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_success_headline,
		"it-IT": it_IT.organisms_forms_accountAccessForm_success_headline,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_success_headline,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_success_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_success_subhead,
		"en-AU": en_AU.organisms_forms_accountAccessForm_success_subhead,
		"en-GB": en_GB.organisms_forms_accountAccessForm_success_subhead,
		"en-US": en_US.organisms_forms_accountAccessForm_success_subhead,
		"es-ES": es_ES.organisms_forms_accountAccessForm_success_subhead,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_success_subhead,
		"it-IT": it_IT.organisms_forms_accountAccessForm_success_subhead,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_success_subhead,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_success_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_success_button_label,
		"en-AU": en_AU.organisms_forms_accountAccessForm_success_button_label,
		"en-GB": en_GB.organisms_forms_accountAccessForm_success_button_label,
		"en-US": en_US.organisms_forms_accountAccessForm_success_button_label,
		"es-ES": es_ES.organisms_forms_accountAccessForm_success_button_label,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_success_button_label,
		"it-IT": it_IT.organisms_forms_accountAccessForm_success_button_label,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_success_button_label,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_success_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_success_button_href,
		"en-AU": en_AU.organisms_forms_accountAccessForm_success_button_href,
		"en-GB": en_GB.organisms_forms_accountAccessForm_success_button_href,
		"en-US": en_US.organisms_forms_accountAccessForm_success_button_href,
		"es-ES": es_ES.organisms_forms_accountAccessForm_success_button_href,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_success_button_href,
		"it-IT": it_IT.organisms_forms_accountAccessForm_success_button_href,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_success_button_href,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_success_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_glossary_jumpTo,
		"en-AU": en_AU.organisms_glossary_jumpTo,
		"en-GB": en_GB.organisms_glossary_jumpTo,
		"en-US": en_US.organisms_glossary_jumpTo,
		"es-ES": es_ES.organisms_glossary_jumpTo,
		"fr-FR": fr_FR.organisms_glossary_jumpTo,
		"it-IT": it_IT.organisms_glossary_jumpTo,
		"ko-KR": ko_KR.organisms_glossary_jumpTo,
		"pt-BR": pt_BR.organisms_glossary_jumpTo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_jobSearch_searchJobs,
		"en-AU": en_AU.organisms_jobSearch_searchJobs,
		"en-GB": en_GB.organisms_jobSearch_searchJobs,
		"en-US": en_US.organisms_jobSearch_searchJobs,
		"es-ES": es_ES.organisms_jobSearch_searchJobs,
		"fr-FR": fr_FR.organisms_jobSearch_searchJobs,
		"it-IT": it_IT.organisms_jobSearch_searchJobs,
		"ko-KR": ko_KR.organisms_jobSearch_searchJobs,
		"pt-BR": pt_BR.organisms_jobSearch_searchJobs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_jobSearch_allLocations,
		"en-AU": en_AU.organisms_jobSearch_allLocations,
		"en-GB": en_GB.organisms_jobSearch_allLocations,
		"en-US": en_US.organisms_jobSearch_allLocations,
		"es-ES": es_ES.organisms_jobSearch_allLocations,
		"fr-FR": fr_FR.organisms_jobSearch_allLocations,
		"it-IT": it_IT.organisms_jobSearch_allLocations,
		"ko-KR": ko_KR.organisms_jobSearch_allLocations,
		"pt-BR": pt_BR.organisms_jobSearch_allLocations
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_jobSearch_search,
		"en-AU": en_AU.organisms_jobSearch_search,
		"en-GB": en_GB.organisms_jobSearch_search,
		"en-US": en_US.organisms_jobSearch_search,
		"es-ES": es_ES.organisms_jobSearch_search,
		"fr-FR": fr_FR.organisms_jobSearch_search,
		"it-IT": it_IT.organisms_jobSearch_search,
		"ko-KR": ko_KR.organisms_jobSearch_search,
		"pt-BR": pt_BR.organisms_jobSearch_search
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_allSystemsOperational,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_allSystemsOperational
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_majorSystemOutage,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_majorSystemOutage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_partialSystemOutage,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_partialSystemOutage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_minorServiceOutage,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_minorServiceOutage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_minorSystemOutage,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_minorSystemOutage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_degradedSystemService,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_degradedSystemService
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_partiallyDegradedService,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_partiallyDegradedService
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"en-AU": en_AU.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"en-GB": en_GB.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"en-US": en_US.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"es-ES": es_ES.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"fr-FR": fr_FR.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"it-IT": it_IT.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"ko-KR": ko_KR.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance,
		"pt-BR": pt_BR.organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_modal_closeModal,
		"en-AU": en_AU.organisms_modal_closeModal,
		"en-GB": en_GB.organisms_modal_closeModal,
		"en-US": en_US.organisms_modal_closeModal,
		"es-ES": es_ES.organisms_modal_closeModal,
		"fr-FR": fr_FR.organisms_modal_closeModal,
		"it-IT": it_IT.organisms_modal_closeModal,
		"ko-KR": ko_KR.organisms_modal_closeModal,
		"pt-BR": pt_BR.organisms_modal_closeModal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_eyebrow,
		"en-AU": en_AU.organisms_moreCards_card1_eyebrow,
		"en-GB": en_GB.organisms_moreCards_card1_eyebrow,
		"en-US": en_US.organisms_moreCards_card1_eyebrow,
		"es-ES": es_ES.organisms_moreCards_card1_eyebrow,
		"fr-FR": fr_FR.organisms_moreCards_card1_eyebrow,
		"it-IT": it_IT.organisms_moreCards_card1_eyebrow,
		"ko-KR": ko_KR.organisms_moreCards_card1_eyebrow,
		"pt-BR": pt_BR.organisms_moreCards_card1_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_richText,
		"en-AU": en_AU.organisms_moreCards_card1_richText,
		"en-GB": en_GB.organisms_moreCards_card1_richText,
		"en-US": en_US.organisms_moreCards_card1_richText,
		"es-ES": es_ES.organisms_moreCards_card1_richText,
		"fr-FR": fr_FR.organisms_moreCards_card1_richText,
		"it-IT": it_IT.organisms_moreCards_card1_richText,
		"ko-KR": ko_KR.organisms_moreCards_card1_richText,
		"pt-BR": pt_BR.organisms_moreCards_card1_richText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_button_label,
		"en-AU": en_AU.organisms_moreCards_card1_button_label,
		"en-GB": en_GB.organisms_moreCards_card1_button_label,
		"en-US": en_US.organisms_moreCards_card1_button_label,
		"es-ES": es_ES.organisms_moreCards_card1_button_label,
		"fr-FR": fr_FR.organisms_moreCards_card1_button_label,
		"it-IT": it_IT.organisms_moreCards_card1_button_label,
		"ko-KR": ko_KR.organisms_moreCards_card1_button_label,
		"pt-BR": pt_BR.organisms_moreCards_card1_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_button_href,
		"en-AU": en_AU.organisms_moreCards_card1_button_href,
		"en-GB": en_GB.organisms_moreCards_card1_button_href,
		"en-US": en_US.organisms_moreCards_card1_button_href,
		"es-ES": es_ES.organisms_moreCards_card1_button_href,
		"fr-FR": fr_FR.organisms_moreCards_card1_button_href,
		"it-IT": it_IT.organisms_moreCards_card1_button_href,
		"ko-KR": ko_KR.organisms_moreCards_card1_button_href,
		"pt-BR": pt_BR.organisms_moreCards_card1_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_openInNewTab = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_button_openInNewTab,
		"en-AU": en_AU.organisms_moreCards_card1_button_openInNewTab,
		"en-GB": en_GB.organisms_moreCards_card1_button_openInNewTab,
		"en-US": en_US.organisms_moreCards_card1_button_openInNewTab,
		"es-ES": es_ES.organisms_moreCards_card1_button_openInNewTab,
		"fr-FR": fr_FR.organisms_moreCards_card1_button_openInNewTab,
		"it-IT": it_IT.organisms_moreCards_card1_button_openInNewTab,
		"ko-KR": ko_KR.organisms_moreCards_card1_button_openInNewTab,
		"pt-BR": pt_BR.organisms_moreCards_card1_button_openInNewTab
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_eyebrow,
		"en-AU": en_AU.organisms_moreCards_card2_eyebrow,
		"en-GB": en_GB.organisms_moreCards_card2_eyebrow,
		"en-US": en_US.organisms_moreCards_card2_eyebrow,
		"es-ES": es_ES.organisms_moreCards_card2_eyebrow,
		"fr-FR": fr_FR.organisms_moreCards_card2_eyebrow,
		"it-IT": it_IT.organisms_moreCards_card2_eyebrow,
		"ko-KR": ko_KR.organisms_moreCards_card2_eyebrow,
		"pt-BR": pt_BR.organisms_moreCards_card2_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_richText,
		"en-AU": en_AU.organisms_moreCards_card2_richText,
		"en-GB": en_GB.organisms_moreCards_card2_richText,
		"en-US": en_US.organisms_moreCards_card2_richText,
		"es-ES": es_ES.organisms_moreCards_card2_richText,
		"fr-FR": fr_FR.organisms_moreCards_card2_richText,
		"it-IT": it_IT.organisms_moreCards_card2_richText,
		"ko-KR": ko_KR.organisms_moreCards_card2_richText,
		"pt-BR": pt_BR.organisms_moreCards_card2_richText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_button_label,
		"en-AU": en_AU.organisms_moreCards_card2_button_label,
		"en-GB": en_GB.organisms_moreCards_card2_button_label,
		"en-US": en_US.organisms_moreCards_card2_button_label,
		"es-ES": es_ES.organisms_moreCards_card2_button_label,
		"fr-FR": fr_FR.organisms_moreCards_card2_button_label,
		"it-IT": it_IT.organisms_moreCards_card2_button_label,
		"ko-KR": ko_KR.organisms_moreCards_card2_button_label,
		"pt-BR": pt_BR.organisms_moreCards_card2_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_button_href,
		"en-AU": en_AU.organisms_moreCards_card2_button_href,
		"en-GB": en_GB.organisms_moreCards_card2_button_href,
		"en-US": en_US.organisms_moreCards_card2_button_href,
		"es-ES": es_ES.organisms_moreCards_card2_button_href,
		"fr-FR": fr_FR.organisms_moreCards_card2_button_href,
		"it-IT": it_IT.organisms_moreCards_card2_button_href,
		"ko-KR": ko_KR.organisms_moreCards_card2_button_href,
		"pt-BR": pt_BR.organisms_moreCards_card2_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_openInNewTab = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_button_openInNewTab,
		"en-AU": en_AU.organisms_moreCards_card2_button_openInNewTab,
		"en-GB": en_GB.organisms_moreCards_card2_button_openInNewTab,
		"en-US": en_US.organisms_moreCards_card2_button_openInNewTab,
		"es-ES": es_ES.organisms_moreCards_card2_button_openInNewTab,
		"fr-FR": fr_FR.organisms_moreCards_card2_button_openInNewTab,
		"it-IT": it_IT.organisms_moreCards_card2_button_openInNewTab,
		"ko-KR": ko_KR.organisms_moreCards_card2_button_openInNewTab,
		"pt-BR": pt_BR.organisms_moreCards_card2_button_openInNewTab
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_eyebrow,
		"en-AU": en_AU.organisms_moreCards_card3_eyebrow,
		"en-GB": en_GB.organisms_moreCards_card3_eyebrow,
		"en-US": en_US.organisms_moreCards_card3_eyebrow,
		"es-ES": es_ES.organisms_moreCards_card3_eyebrow,
		"fr-FR": fr_FR.organisms_moreCards_card3_eyebrow,
		"it-IT": it_IT.organisms_moreCards_card3_eyebrow,
		"ko-KR": ko_KR.organisms_moreCards_card3_eyebrow,
		"pt-BR": pt_BR.organisms_moreCards_card3_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_button_label,
		"en-AU": en_AU.organisms_moreCards_card3_button_label,
		"en-GB": en_GB.organisms_moreCards_card3_button_label,
		"en-US": en_US.organisms_moreCards_card3_button_label,
		"es-ES": es_ES.organisms_moreCards_card3_button_label,
		"fr-FR": fr_FR.organisms_moreCards_card3_button_label,
		"it-IT": it_IT.organisms_moreCards_card3_button_label,
		"ko-KR": ko_KR.organisms_moreCards_card3_button_label,
		"pt-BR": pt_BR.organisms_moreCards_card3_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_button_href,
		"en-AU": en_AU.organisms_moreCards_card3_button_href,
		"en-GB": en_GB.organisms_moreCards_card3_button_href,
		"en-US": en_US.organisms_moreCards_card3_button_href,
		"es-ES": es_ES.organisms_moreCards_card3_button_href,
		"fr-FR": fr_FR.organisms_moreCards_card3_button_href,
		"it-IT": it_IT.organisms_moreCards_card3_button_href,
		"ko-KR": ko_KR.organisms_moreCards_card3_button_href,
		"pt-BR": pt_BR.organisms_moreCards_card3_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_openInNewTab = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_button_openInNewTab,
		"en-AU": en_AU.organisms_moreCards_card3_button_openInNewTab,
		"en-GB": en_GB.organisms_moreCards_card3_button_openInNewTab,
		"en-US": en_US.organisms_moreCards_card3_button_openInNewTab,
		"es-ES": es_ES.organisms_moreCards_card3_button_openInNewTab,
		"fr-FR": fr_FR.organisms_moreCards_card3_button_openInNewTab,
		"it-IT": it_IT.organisms_moreCards_card3_button_openInNewTab,
		"ko-KR": ko_KR.organisms_moreCards_card3_button_openInNewTab,
		"pt-BR": pt_BR.organisms_moreCards_card3_button_openInNewTab
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_accessSupport,
		"en-AU": en_AU.organisms_moreCards_card3_richText_accessSupport,
		"en-GB": en_GB.organisms_moreCards_card3_richText_accessSupport,
		"en-US": en_US.organisms_moreCards_card3_richText_accessSupport,
		"es-ES": es_ES.organisms_moreCards_card3_richText_accessSupport,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_accessSupport,
		"it-IT": it_IT.organisms_moreCards_card3_richText_accessSupport,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_accessSupport,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_accessSupport
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_emailSupport,
		"en-AU": en_AU.organisms_moreCards_card3_richText_emailSupport,
		"en-GB": en_GB.organisms_moreCards_card3_richText_emailSupport,
		"en-US": en_US.organisms_moreCards_card3_richText_emailSupport,
		"es-ES": es_ES.organisms_moreCards_card3_richText_emailSupport,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_emailSupport,
		"it-IT": it_IT.organisms_moreCards_card3_richText_emailSupport,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_emailSupport,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_emailSupport
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"en-AU": en_AU.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"en-GB": en_GB.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"en-US": en_US.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"es-ES": es_ES.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"it-IT": it_IT.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_emailSupportAccountTypes,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_emailSupportAccountTypes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_emailSupportAvailability,
		"en-AU": en_AU.organisms_moreCards_card3_richText_emailSupportAvailability,
		"en-GB": en_GB.organisms_moreCards_card3_richText_emailSupportAvailability,
		"en-US": en_US.organisms_moreCards_card3_richText_emailSupportAvailability,
		"es-ES": es_ES.organisms_moreCards_card3_richText_emailSupportAvailability,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_emailSupportAvailability,
		"it-IT": it_IT.organisms_moreCards_card3_richText_emailSupportAvailability,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_emailSupportAvailability,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_emailSupportAvailability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"en-AU": en_AU.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"en-GB": en_GB.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"en-US": en_US.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"es-ES": es_ES.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"it-IT": it_IT.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_chatVirtualAssistance,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_chatVirtualAssistance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"en-AU": en_AU.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"en-GB": en_GB.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"en-US": en_US.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"es-ES": es_ES.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"it-IT": it_IT.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_logo_label,
		"en-AU": en_AU.organisms_navigation_logo_label,
		"en-GB": en_GB.organisms_navigation_logo_label,
		"en-US": en_US.organisms_navigation_logo_label,
		"es-ES": es_ES.organisms_navigation_logo_label,
		"fr-FR": fr_FR.organisms_navigation_logo_label,
		"it-IT": it_IT.organisms_navigation_logo_label,
		"ko-KR": ko_KR.organisms_navigation_logo_label,
		"pt-BR": pt_BR.organisms_navigation_logo_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_powerUpLogo_label,
		"en-AU": en_AU.organisms_navigation_powerUpLogo_label,
		"en-GB": en_GB.organisms_navigation_powerUpLogo_label,
		"en-US": en_US.organisms_navigation_powerUpLogo_label,
		"es-ES": es_ES.organisms_navigation_powerUpLogo_label,
		"fr-FR": fr_FR.organisms_navigation_powerUpLogo_label,
		"it-IT": it_IT.organisms_navigation_powerUpLogo_label,
		"ko-KR": ko_KR.organisms_navigation_powerUpLogo_label,
		"pt-BR": pt_BR.organisms_navigation_powerUpLogo_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_powerUpLogo_href,
		"en-AU": en_AU.organisms_navigation_powerUpLogo_href,
		"en-GB": en_GB.organisms_navigation_powerUpLogo_href,
		"en-US": en_US.organisms_navigation_powerUpLogo_href,
		"es-ES": es_ES.organisms_navigation_powerUpLogo_href,
		"fr-FR": fr_FR.organisms_navigation_powerUpLogo_href,
		"it-IT": it_IT.organisms_navigation_powerUpLogo_href,
		"ko-KR": ko_KR.organisms_navigation_powerUpLogo_href,
		"pt-BR": pt_BR.organisms_navigation_powerUpLogo_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_dataActions_signUp_button_href,
		"en-AU": en_AU.organisms_navigation_dataActions_signUp_button_href,
		"en-GB": en_GB.organisms_navigation_dataActions_signUp_button_href,
		"en-US": en_US.organisms_navigation_dataActions_signUp_button_href,
		"es-ES": es_ES.organisms_navigation_dataActions_signUp_button_href,
		"fr-FR": fr_FR.organisms_navigation_dataActions_signUp_button_href,
		"it-IT": it_IT.organisms_navigation_dataActions_signUp_button_href,
		"ko-KR": ko_KR.organisms_navigation_dataActions_signUp_button_href,
		"pt-BR": pt_BR.organisms_navigation_dataActions_signUp_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_dataActions_getADemo_button_label,
		"en-AU": en_AU.organisms_navigation_dataActions_getADemo_button_label,
		"en-GB": en_GB.organisms_navigation_dataActions_getADemo_button_label,
		"en-US": en_US.organisms_navigation_dataActions_getADemo_button_label,
		"es-ES": es_ES.organisms_navigation_dataActions_getADemo_button_label,
		"fr-FR": fr_FR.organisms_navigation_dataActions_getADemo_button_label,
		"it-IT": it_IT.organisms_navigation_dataActions_getADemo_button_label,
		"ko-KR": ko_KR.organisms_navigation_dataActions_getADemo_button_label,
		"pt-BR": pt_BR.organisms_navigation_dataActions_getADemo_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigation_dataActions_getADemo_button_href,
		"en-AU": en_AU.organisms_navigation_dataActions_getADemo_button_href,
		"en-GB": en_GB.organisms_navigation_dataActions_getADemo_button_href,
		"en-US": en_US.organisms_navigation_dataActions_getADemo_button_href,
		"es-ES": es_ES.organisms_navigation_dataActions_getADemo_button_href,
		"fr-FR": fr_FR.organisms_navigation_dataActions_getADemo_button_href,
		"it-IT": it_IT.organisms_navigation_dataActions_getADemo_button_href,
		"ko-KR": ko_KR.organisms_navigation_dataActions_getADemo_button_href,
		"pt-BR": pt_BR.organisms_navigation_dataActions_getADemo_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_newsFeed_productNews,
		"en-AU": en_AU.organisms_newsFeed_productNews,
		"en-GB": en_GB.organisms_newsFeed_productNews,
		"en-US": en_US.organisms_newsFeed_productNews,
		"es-ES": es_ES.organisms_newsFeed_productNews,
		"fr-FR": fr_FR.organisms_newsFeed_productNews,
		"it-IT": it_IT.organisms_newsFeed_productNews,
		"ko-KR": ko_KR.organisms_newsFeed_productNews,
		"pt-BR": pt_BR.organisms_newsFeed_productNews
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_newsFeed_read,
		"en-AU": en_AU.organisms_newsFeed_read,
		"en-GB": en_GB.organisms_newsFeed_read,
		"en-US": en_US.organisms_newsFeed_read,
		"es-ES": es_ES.organisms_newsFeed_read,
		"fr-FR": fr_FR.organisms_newsFeed_read,
		"it-IT": it_IT.organisms_newsFeed_read,
		"ko-KR": ko_KR.organisms_newsFeed_read,
		"pt-BR": pt_BR.organisms_newsFeed_read
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_newsFeed_klavioLogo,
		"en-AU": en_AU.organisms_newsFeed_klavioLogo,
		"en-GB": en_GB.organisms_newsFeed_klavioLogo,
		"en-US": en_US.organisms_newsFeed_klavioLogo,
		"es-ES": es_ES.organisms_newsFeed_klavioLogo,
		"fr-FR": fr_FR.organisms_newsFeed_klavioLogo,
		"it-IT": it_IT.organisms_newsFeed_klavioLogo,
		"ko-KR": ko_KR.organisms_newsFeed_klavioLogo,
		"pt-BR": pt_BR.organisms_newsFeed_klavioLogo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_newsFeed_viewAll,
		"en-AU": en_AU.organisms_newsFeed_viewAll,
		"en-GB": en_GB.organisms_newsFeed_viewAll,
		"en-US": en_US.organisms_newsFeed_viewAll,
		"es-ES": es_ES.organisms_newsFeed_viewAll,
		"fr-FR": fr_FR.organisms_newsFeed_viewAll,
		"it-IT": it_IT.organisms_newsFeed_viewAll,
		"ko-KR": ko_KR.organisms_newsFeed_viewAll,
		"pt-BR": pt_BR.organisms_newsFeed_viewAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCategory = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_ResourceCategory,
		"en-AU": en_AU.organisms_post_filter_ResourceCategory,
		"en-GB": en_GB.organisms_post_filter_ResourceCategory,
		"en-US": en_US.organisms_post_filter_ResourceCategory,
		"es-ES": es_ES.organisms_post_filter_ResourceCategory,
		"fr-FR": fr_FR.organisms_post_filter_ResourceCategory,
		"it-IT": it_IT.organisms_post_filter_ResourceCategory,
		"ko-KR": ko_KR.organisms_post_filter_ResourceCategory,
		"pt-BR": pt_BR.organisms_post_filter_ResourceCategory
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCollection = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_ResourceCollection,
		"en-AU": en_AU.organisms_post_filter_ResourceCollection,
		"en-GB": en_GB.organisms_post_filter_ResourceCollection,
		"en-US": en_US.organisms_post_filter_ResourceCollection,
		"es-ES": es_ES.organisms_post_filter_ResourceCollection,
		"fr-FR": fr_FR.organisms_post_filter_ResourceCollection,
		"it-IT": it_IT.organisms_post_filter_ResourceCollection,
		"ko-KR": ko_KR.organisms_post_filter_ResourceCollection,
		"pt-BR": pt_BR.organisms_post_filter_ResourceCollection
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceStage = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_ResourceStage,
		"en-AU": en_AU.organisms_post_filter_ResourceStage,
		"en-GB": en_GB.organisms_post_filter_ResourceStage,
		"en-US": en_US.organisms_post_filter_ResourceStage,
		"es-ES": es_ES.organisms_post_filter_ResourceStage,
		"fr-FR": fr_FR.organisms_post_filter_ResourceStage,
		"it-IT": it_IT.organisms_post_filter_ResourceStage,
		"ko-KR": ko_KR.organisms_post_filter_ResourceStage,
		"pt-BR": pt_BR.organisms_post_filter_ResourceStage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceTopic = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_ResourceTopic,
		"en-AU": en_AU.organisms_post_filter_ResourceTopic,
		"en-GB": en_GB.organisms_post_filter_ResourceTopic,
		"en-US": en_US.organisms_post_filter_ResourceTopic,
		"es-ES": es_ES.organisms_post_filter_ResourceTopic,
		"fr-FR": fr_FR.organisms_post_filter_ResourceTopic,
		"it-IT": it_IT.organisms_post_filter_ResourceTopic,
		"ko-KR": ko_KR.organisms_post_filter_ResourceTopic,
		"pt-BR": pt_BR.organisms_post_filter_ResourceTopic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_search = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_search,
		"en-AU": en_AU.organisms_post_filter_search,
		"en-GB": en_GB.organisms_post_filter_search,
		"en-US": en_US.organisms_post_filter_search,
		"es-ES": es_ES.organisms_post_filter_search,
		"fr-FR": fr_FR.organisms_post_filter_search,
		"it-IT": it_IT.organisms_post_filter_search,
		"ko-KR": ko_KR.organisms_post_filter_search,
		"pt-BR": pt_BR.organisms_post_filter_search
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_eyebrow,
		"en-AU": en_AU.organisms_pricing_eyebrow,
		"en-GB": en_GB.organisms_pricing_eyebrow,
		"en-US": en_US.organisms_pricing_eyebrow,
		"es-ES": es_ES.organisms_pricing_eyebrow,
		"fr-FR": fr_FR.organisms_pricing_eyebrow,
		"it-IT": it_IT.organisms_pricing_eyebrow,
		"ko-KR": ko_KR.organisms_pricing_eyebrow,
		"pt-BR": pt_BR.organisms_pricing_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_headline,
		"en-AU": en_AU.organisms_pricing_headline,
		"en-GB": en_GB.organisms_pricing_headline,
		"en-US": en_US.organisms_pricing_headline,
		"es-ES": es_ES.organisms_pricing_headline,
		"fr-FR": fr_FR.organisms_pricing_headline,
		"it-IT": it_IT.organisms_pricing_headline,
		"ko-KR": ko_KR.organisms_pricing_headline,
		"pt-BR": pt_BR.organisms_pricing_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_startingAt,
		"en-AU": en_AU.organisms_pricing_startingAt,
		"en-GB": en_GB.organisms_pricing_startingAt,
		"en-US": en_US.organisms_pricing_startingAt,
		"es-ES": es_ES.organisms_pricing_startingAt,
		"fr-FR": fr_FR.organisms_pricing_startingAt,
		"it-IT": it_IT.organisms_pricing_startingAt,
		"ko-KR": ko_KR.organisms_pricing_startingAt,
		"pt-BR": pt_BR.organisms_pricing_startingAt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_month,
		"en-AU": en_AU.organisms_pricing_month,
		"en-GB": en_GB.organisms_pricing_month,
		"en-US": en_US.organisms_pricing_month,
		"es-ES": es_ES.organisms_pricing_month,
		"fr-FR": fr_FR.organisms_pricing_month,
		"it-IT": it_IT.organisms_pricing_month,
		"ko-KR": ko_KR.organisms_pricing_month,
		"pt-BR": pt_BR.organisms_pricing_month
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contacts,
		"en-AU": en_AU.organisms_pricing_contacts,
		"en-GB": en_GB.organisms_pricing_contacts,
		"en-US": en_US.organisms_pricing_contacts,
		"es-ES": es_ES.organisms_pricing_contacts,
		"fr-FR": fr_FR.organisms_pricing_contacts,
		"it-IT": it_IT.organisms_pricing_contacts,
		"ko-KR": ko_KR.organisms_pricing_contacts,
		"pt-BR": pt_BR.organisms_pricing_contacts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contactLimitExceeded,
		"en-AU": en_AU.organisms_pricing_contactLimitExceeded,
		"en-GB": en_GB.organisms_pricing_contactLimitExceeded,
		"en-US": en_US.organisms_pricing_contactLimitExceeded,
		"es-ES": es_ES.organisms_pricing_contactLimitExceeded,
		"fr-FR": fr_FR.organisms_pricing_contactLimitExceeded,
		"it-IT": it_IT.organisms_pricing_contactLimitExceeded,
		"ko-KR": ko_KR.organisms_pricing_contactLimitExceeded,
		"pt-BR": pt_BR.organisms_pricing_contactLimitExceeded
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_signUp,
		"en-AU": en_AU.organisms_pricing_signUp,
		"en-GB": en_GB.organisms_pricing_signUp,
		"en-US": en_US.organisms_pricing_signUp,
		"es-ES": es_ES.organisms_pricing_signUp,
		"fr-FR": fr_FR.organisms_pricing_signUp,
		"it-IT": it_IT.organisms_pricing_signUp,
		"ko-KR": ko_KR.organisms_pricing_signUp,
		"pt-BR": pt_BR.organisms_pricing_signUp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_monthlyEmailSends,
		"en-AU": en_AU.organisms_pricing_monthlyEmailSends,
		"en-GB": en_GB.organisms_pricing_monthlyEmailSends,
		"en-US": en_US.organisms_pricing_monthlyEmailSends,
		"es-ES": es_ES.organisms_pricing_monthlyEmailSends,
		"fr-FR": fr_FR.organisms_pricing_monthlyEmailSends,
		"it-IT": it_IT.organisms_pricing_monthlyEmailSends,
		"ko-KR": ko_KR.organisms_pricing_monthlyEmailSends,
		"pt-BR": pt_BR.organisms_pricing_monthlyEmailSends
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_monthlySmsMmsCredits,
		"en-AU": en_AU.organisms_pricing_monthlySmsMmsCredits,
		"en-GB": en_GB.organisms_pricing_monthlySmsMmsCredits,
		"en-US": en_US.organisms_pricing_monthlySmsMmsCredits,
		"es-ES": es_ES.organisms_pricing_monthlySmsMmsCredits,
		"fr-FR": fr_FR.organisms_pricing_monthlySmsMmsCredits,
		"it-IT": it_IT.organisms_pricing_monthlySmsMmsCredits,
		"ko-KR": ko_KR.organisms_pricing_monthlySmsMmsCredits,
		"pt-BR": pt_BR.organisms_pricing_monthlySmsMmsCredits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_opensAModal,
		"en-AU": en_AU.organisms_pricing_opensAModal,
		"en-GB": en_GB.organisms_pricing_opensAModal,
		"en-US": en_US.organisms_pricing_opensAModal,
		"es-ES": es_ES.organisms_pricing_opensAModal,
		"fr-FR": fr_FR.organisms_pricing_opensAModal,
		"it-IT": it_IT.organisms_pricing_opensAModal,
		"ko-KR": ko_KR.organisms_pricing_opensAModal,
		"pt-BR": pt_BR.organisms_pricing_opensAModal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_mobilePush,
		"en-AU": en_AU.organisms_pricing_mobilePush,
		"en-GB": en_GB.organisms_pricing_mobilePush,
		"en-US": en_US.organisms_pricing_mobilePush,
		"es-ES": es_ES.organisms_pricing_mobilePush,
		"fr-FR": fr_FR.organisms_pricing_mobilePush,
		"it-IT": it_IT.organisms_pricing_mobilePush,
		"ko-KR": ko_KR.organisms_pricing_mobilePush,
		"pt-BR": pt_BR.organisms_pricing_mobilePush
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_freeCredits,
		"en-AU": en_AU.organisms_pricing_freeCredits,
		"en-GB": en_GB.organisms_pricing_freeCredits,
		"en-US": en_US.organisms_pricing_freeCredits,
		"es-ES": es_ES.organisms_pricing_freeCredits,
		"fr-FR": fr_FR.organisms_pricing_freeCredits,
		"it-IT": it_IT.organisms_pricing_freeCredits,
		"ko-KR": ko_KR.organisms_pricing_freeCredits,
		"pt-BR": pt_BR.organisms_pricing_freeCredits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_includesFees,
		"en-AU": en_AU.organisms_pricing_includesFees,
		"en-GB": en_GB.organisms_pricing_includesFees,
		"en-US": en_US.organisms_pricing_includesFees,
		"es-ES": es_ES.organisms_pricing_includesFees,
		"fr-FR": fr_FR.organisms_pricing_includesFees,
		"it-IT": it_IT.organisms_pricing_includesFees,
		"ko-KR": ko_KR.organisms_pricing_includesFees,
		"pt-BR": pt_BR.organisms_pricing_includesFees
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_supportToScale,
		"en-AU": en_AU.organisms_pricing_supportToScale,
		"en-GB": en_GB.organisms_pricing_supportToScale,
		"en-US": en_US.organisms_pricing_supportToScale,
		"es-ES": es_ES.organisms_pricing_supportToScale,
		"fr-FR": fr_FR.organisms_pricing_supportToScale,
		"it-IT": it_IT.organisms_pricing_supportToScale,
		"ko-KR": ko_KR.organisms_pricing_supportToScale,
		"pt-BR": pt_BR.organisms_pricing_supportToScale
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_onboarding,
		"en-AU": en_AU.organisms_pricing_onboarding,
		"en-GB": en_GB.organisms_pricing_onboarding,
		"en-US": en_US.organisms_pricing_onboarding,
		"es-ES": es_ES.organisms_pricing_onboarding,
		"fr-FR": fr_FR.organisms_pricing_onboarding,
		"it-IT": it_IT.organisms_pricing_onboarding,
		"ko-KR": ko_KR.organisms_pricing_onboarding,
		"pt-BR": pt_BR.organisms_pricing_onboarding
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_csm,
		"en-AU": en_AU.organisms_pricing_csm,
		"en-GB": en_GB.organisms_pricing_csm,
		"en-US": en_US.organisms_pricing_csm,
		"es-ES": es_ES.organisms_pricing_csm,
		"fr-FR": fr_FR.organisms_pricing_csm,
		"it-IT": it_IT.organisms_pricing_csm,
		"ko-KR": ko_KR.organisms_pricing_csm,
		"pt-BR": pt_BR.organisms_pricing_csm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_emailAndChatSupport,
		"en-AU": en_AU.organisms_pricing_emailAndChatSupport,
		"en-GB": en_GB.organisms_pricing_emailAndChatSupport,
		"en-US": en_US.organisms_pricing_emailAndChatSupport,
		"es-ES": es_ES.organisms_pricing_emailAndChatSupport,
		"fr-FR": fr_FR.organisms_pricing_emailAndChatSupport,
		"it-IT": it_IT.organisms_pricing_emailAndChatSupport,
		"ko-KR": ko_KR.organisms_pricing_emailAndChatSupport,
		"pt-BR": pt_BR.organisms_pricing_emailAndChatSupport
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_freeSupport,
		"en-AU": en_AU.organisms_pricing_freeSupport,
		"en-GB": en_GB.organisms_pricing_freeSupport,
		"en-US": en_US.organisms_pricing_freeSupport,
		"es-ES": es_ES.organisms_pricing_freeSupport,
		"fr-FR": fr_FR.organisms_pricing_freeSupport,
		"it-IT": it_IT.organisms_pricing_freeSupport,
		"ko-KR": ko_KR.organisms_pricing_freeSupport,
		"pt-BR": pt_BR.organisms_pricing_freeSupport
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_getADemo,
		"en-AU": en_AU.organisms_pricing_getADemo,
		"en-GB": en_GB.organisms_pricing_getADemo,
		"en-US": en_US.organisms_pricing_getADemo,
		"es-ES": es_ES.organisms_pricing_getADemo,
		"fr-FR": fr_FR.organisms_pricing_getADemo,
		"it-IT": it_IT.organisms_pricing_getADemo,
		"ko-KR": ko_KR.organisms_pricing_getADemo,
		"pt-BR": pt_BR.organisms_pricing_getADemo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plusSign,
		"en-AU": en_AU.organisms_pricing_plusSign,
		"en-GB": en_GB.organisms_pricing_plusSign,
		"en-US": en_US.organisms_pricing_plusSign,
		"es-ES": es_ES.organisms_pricing_plusSign,
		"fr-FR": fr_FR.organisms_pricing_plusSign,
		"it-IT": it_IT.organisms_pricing_plusSign,
		"ko-KR": ko_KR.organisms_pricing_plusSign,
		"pt-BR": pt_BR.organisms_pricing_plusSign
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailAndSms_calloutText,
		"en-AU": en_AU.organisms_pricing_plans_emailAndSms_calloutText,
		"en-GB": en_GB.organisms_pricing_plans_emailAndSms_calloutText,
		"en-US": en_US.organisms_pricing_plans_emailAndSms_calloutText,
		"es-ES": es_ES.organisms_pricing_plans_emailAndSms_calloutText,
		"fr-FR": fr_FR.organisms_pricing_plans_emailAndSms_calloutText,
		"it-IT": it_IT.organisms_pricing_plans_emailAndSms_calloutText,
		"ko-KR": ko_KR.organisms_pricing_plans_emailAndSms_calloutText,
		"pt-BR": pt_BR.organisms_pricing_plans_emailAndSms_calloutText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailAndSms_copy,
		"en-AU": en_AU.organisms_pricing_plans_emailAndSms_copy,
		"en-GB": en_GB.organisms_pricing_plans_emailAndSms_copy,
		"en-US": en_US.organisms_pricing_plans_emailAndSms_copy,
		"es-ES": es_ES.organisms_pricing_plans_emailAndSms_copy,
		"fr-FR": fr_FR.organisms_pricing_plans_emailAndSms_copy,
		"it-IT": it_IT.organisms_pricing_plans_emailAndSms_copy,
		"ko-KR": ko_KR.organisms_pricing_plans_emailAndSms_copy,
		"pt-BR": pt_BR.organisms_pricing_plans_emailAndSms_copy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailAndSms_name,
		"en-AU": en_AU.organisms_pricing_plans_emailAndSms_name,
		"en-GB": en_GB.organisms_pricing_plans_emailAndSms_name,
		"en-US": en_US.organisms_pricing_plans_emailAndSms_name,
		"es-ES": es_ES.organisms_pricing_plans_emailAndSms_name,
		"fr-FR": fr_FR.organisms_pricing_plans_emailAndSms_name,
		"it-IT": it_IT.organisms_pricing_plans_emailAndSms_name,
		"ko-KR": ko_KR.organisms_pricing_plans_emailAndSms_name,
		"pt-BR": pt_BR.organisms_pricing_plans_emailAndSms_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_email_calloutText,
		"en-AU": en_AU.organisms_pricing_plans_email_calloutText,
		"en-GB": en_GB.organisms_pricing_plans_email_calloutText,
		"en-US": en_US.organisms_pricing_plans_email_calloutText,
		"es-ES": es_ES.organisms_pricing_plans_email_calloutText,
		"fr-FR": fr_FR.organisms_pricing_plans_email_calloutText,
		"it-IT": it_IT.organisms_pricing_plans_email_calloutText,
		"ko-KR": ko_KR.organisms_pricing_plans_email_calloutText,
		"pt-BR": pt_BR.organisms_pricing_plans_email_calloutText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_email_copy,
		"en-AU": en_AU.organisms_pricing_plans_email_copy,
		"en-GB": en_GB.organisms_pricing_plans_email_copy,
		"en-US": en_US.organisms_pricing_plans_email_copy,
		"es-ES": es_ES.organisms_pricing_plans_email_copy,
		"fr-FR": fr_FR.organisms_pricing_plans_email_copy,
		"it-IT": it_IT.organisms_pricing_plans_email_copy,
		"ko-KR": ko_KR.organisms_pricing_plans_email_copy,
		"pt-BR": pt_BR.organisms_pricing_plans_email_copy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_email_name,
		"en-AU": en_AU.organisms_pricing_plans_email_name,
		"en-GB": en_GB.organisms_pricing_plans_email_name,
		"en-US": en_US.organisms_pricing_plans_email_name,
		"es-ES": es_ES.organisms_pricing_plans_email_name,
		"fr-FR": fr_FR.organisms_pricing_plans_email_name,
		"it-IT": it_IT.organisms_pricing_plans_email_name,
		"ko-KR": ko_KR.organisms_pricing_plans_email_name,
		"pt-BR": pt_BR.organisms_pricing_plans_email_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_free_calloutText,
		"en-AU": en_AU.organisms_pricing_plans_free_calloutText,
		"en-GB": en_GB.organisms_pricing_plans_free_calloutText,
		"en-US": en_US.organisms_pricing_plans_free_calloutText,
		"es-ES": es_ES.organisms_pricing_plans_free_calloutText,
		"fr-FR": fr_FR.organisms_pricing_plans_free_calloutText,
		"it-IT": it_IT.organisms_pricing_plans_free_calloutText,
		"ko-KR": ko_KR.organisms_pricing_plans_free_calloutText,
		"pt-BR": pt_BR.organisms_pricing_plans_free_calloutText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_free_copy,
		"en-AU": en_AU.organisms_pricing_plans_free_copy,
		"en-GB": en_GB.organisms_pricing_plans_free_copy,
		"en-US": en_US.organisms_pricing_plans_free_copy,
		"es-ES": es_ES.organisms_pricing_plans_free_copy,
		"fr-FR": fr_FR.organisms_pricing_plans_free_copy,
		"it-IT": it_IT.organisms_pricing_plans_free_copy,
		"ko-KR": ko_KR.organisms_pricing_plans_free_copy,
		"pt-BR": pt_BR.organisms_pricing_plans_free_copy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_free_name,
		"en-AU": en_AU.organisms_pricing_plans_free_name,
		"en-GB": en_GB.organisms_pricing_plans_free_name,
		"en-US": en_US.organisms_pricing_plans_free_name,
		"es-ES": es_ES.organisms_pricing_plans_free_name,
		"fr-FR": fr_FR.organisms_pricing_plans_free_name,
		"it-IT": it_IT.organisms_pricing_plans_free_name,
		"ko-KR": ko_KR.organisms_pricing_plans_free_name,
		"pt-BR": pt_BR.organisms_pricing_plans_free_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_maxContacts_buttons_getDemo,
		"en-AU": en_AU.organisms_pricing_maxContacts_buttons_getDemo,
		"en-GB": en_GB.organisms_pricing_maxContacts_buttons_getDemo,
		"en-US": en_US.organisms_pricing_maxContacts_buttons_getDemo,
		"es-ES": es_ES.organisms_pricing_maxContacts_buttons_getDemo,
		"fr-FR": fr_FR.organisms_pricing_maxContacts_buttons_getDemo,
		"it-IT": it_IT.organisms_pricing_maxContacts_buttons_getDemo,
		"ko-KR": ko_KR.organisms_pricing_maxContacts_buttons_getDemo,
		"pt-BR": pt_BR.organisms_pricing_maxContacts_buttons_getDemo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_maxContacts_richTextBody,
		"en-AU": en_AU.organisms_pricing_maxContacts_richTextBody,
		"en-GB": en_GB.organisms_pricing_maxContacts_richTextBody,
		"en-US": en_US.organisms_pricing_maxContacts_richTextBody,
		"es-ES": es_ES.organisms_pricing_maxContacts_richTextBody,
		"fr-FR": fr_FR.organisms_pricing_maxContacts_richTextBody,
		"it-IT": it_IT.organisms_pricing_maxContacts_richTextBody,
		"ko-KR": ko_KR.organisms_pricing_maxContacts_richTextBody,
		"pt-BR": pt_BR.organisms_pricing_maxContacts_richTextBody
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_maxContacts_headline,
		"en-AU": en_AU.organisms_pricing_maxContacts_headline,
		"en-GB": en_GB.organisms_pricing_maxContacts_headline,
		"en-US": en_US.organisms_pricing_maxContacts_headline,
		"es-ES": es_ES.organisms_pricing_maxContacts_headline,
		"fr-FR": fr_FR.organisms_pricing_maxContacts_headline,
		"it-IT": it_IT.organisms_pricing_maxContacts_headline,
		"ko-KR": ko_KR.organisms_pricing_maxContacts_headline,
		"pt-BR": pt_BR.organisms_pricing_maxContacts_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUSA_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionUSA_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionUSA_regionName,
		"en-US": en_US.organisms_pricing_rates_regionUSA_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionUSA_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUSA_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionUSA_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUSA_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUSA_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUSA_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionUSA_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionUSA_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionUSA_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionUSA_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUSA_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionUSA_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUSA_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUSA_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUSA_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionUSA_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionUSA_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionUSA_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionUSA_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUSA_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionUSA_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUSA_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUSA_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionCanada_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionCanada_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionCanada_regionName,
		"en-US": en_US.organisms_pricing_rates_regionCanada_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionCanada_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionCanada_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionCanada_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionCanada_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionCanada_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionCanada_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionCanada_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionCanada_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionCanada_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionCanada_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionCanada_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionCanada_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionCanada_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionCanada_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionCanada_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionCanada_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionCanada_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionCanada_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionCanada_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionCanada_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionCanada_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionCanada_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionCanada_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUK_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionUK_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionUK_regionName,
		"en-US": en_US.organisms_pricing_rates_regionUK_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionUK_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUK_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionUK_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUK_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUK_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUK_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionUK_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionUK_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionUK_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionUK_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUK_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionUK_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUK_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUK_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionUK_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionUK_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionUK_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionUK_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionUK_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionUK_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionUK_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionUK_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionUK_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionAUS_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionAUS_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionAUS_regionName,
		"en-US": en_US.organisms_pricing_rates_regionAUS_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionAUS_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionAUS_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionAUS_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionAUS_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionAUS_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionAUS_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionAUS_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionAUS_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionAUS_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionAUS_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionAUS_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionAUS_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionAUS_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionAUS_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionAUS_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionAUS_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionAUS_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionAUS_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionAUS_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionAUS_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionAUS_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionAUS_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionAUS_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNZ_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionNZ_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionNZ_regionName,
		"en-US": en_US.organisms_pricing_rates_regionNZ_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionNZ_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNZ_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionNZ_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNZ_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNZ_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNZ_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionNZ_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionNZ_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionNZ_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionNZ_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNZ_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionNZ_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNZ_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNZ_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNZ_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionNZ_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionNZ_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionNZ_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionNZ_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNZ_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionNZ_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNZ_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNZ_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionIreland_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionIreland_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionIreland_regionName,
		"en-US": en_US.organisms_pricing_rates_regionIreland_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionIreland_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionIreland_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionIreland_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionIreland_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionIreland_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionIreland_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionIreland_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionIreland_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionIreland_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionIreland_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionIreland_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionIreland_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionIreland_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionIreland_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionIreland_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionIreland_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionIreland_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionIreland_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionIreland_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionIreland_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionIreland_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionIreland_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionIreland_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionItaly_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionItaly_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionItaly_regionName,
		"en-US": en_US.organisms_pricing_rates_regionItaly_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionItaly_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionItaly_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionItaly_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionItaly_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionItaly_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionItaly_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionItaly_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionItaly_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionItaly_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionItaly_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionItaly_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionItaly_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionItaly_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionItaly_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionItaly_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionItaly_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionItaly_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionItaly_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionItaly_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionItaly_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionItaly_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionItaly_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionItaly_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionFrance_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionFrance_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionFrance_regionName,
		"en-US": en_US.organisms_pricing_rates_regionFrance_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionFrance_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionFrance_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionFrance_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionFrance_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionFrance_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionFrance_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionFrance_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionFrance_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionFrance_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionFrance_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionFrance_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionFrance_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionFrance_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionFrance_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionFrance_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionFrance_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionFrance_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionFrance_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionFrance_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionFrance_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionFrance_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionFrance_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionFrance_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionGermany_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionGermany_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionGermany_regionName,
		"en-US": en_US.organisms_pricing_rates_regionGermany_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionGermany_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionGermany_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionGermany_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionGermany_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionGermany_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionGermany_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionGermany_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionGermany_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionGermany_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionGermany_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionGermany_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionGermany_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionGermany_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionGermany_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionGermany_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionGermany_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionGermany_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionGermany_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionGermany_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionGermany_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionGermany_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionGermany_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionGermany_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNetherlands_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionNetherlands_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionNetherlands_regionName,
		"en-US": en_US.organisms_pricing_rates_regionNetherlands_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionNetherlands_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNetherlands_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionNetherlands_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNetherlands_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNetherlands_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNetherlands_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNetherlands_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionNetherlands_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionNetherlands_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionPortugal_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionPortugal_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionPortugal_regionName,
		"en-US": en_US.organisms_pricing_rates_regionPortugal_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionPortugal_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionPortugal_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionPortugal_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionPortugal_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionPortugal_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"en-AU": en_AU.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"en-GB": en_GB.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"en-US": en_US.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"es-ES": es_ES.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"it-IT": it_IT.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionPortugal_creditEntrySms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionPortugal_creditEntrySms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"en-AU": en_AU.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"en-GB": en_GB.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"en-US": en_US.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"es-ES": es_ES.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"fr-FR": fr_FR.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"it-IT": it_IT.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"ko-KR": ko_KR.organisms_pricing_rates_regionPortugal_creditEntryMms,
		"pt-BR": pt_BR.organisms_pricing_rates_regionPortugal_creditEntryMms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_modalContent_headline,
		"en-AU": en_AU.organisms_pricing_modalContent_headline,
		"en-GB": en_GB.organisms_pricing_modalContent_headline,
		"en-US": en_US.organisms_pricing_modalContent_headline,
		"es-ES": es_ES.organisms_pricing_modalContent_headline,
		"fr-FR": fr_FR.organisms_pricing_modalContent_headline,
		"it-IT": it_IT.organisms_pricing_modalContent_headline,
		"ko-KR": ko_KR.organisms_pricing_modalContent_headline,
		"pt-BR": pt_BR.organisms_pricing_modalContent_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_modalContent_copyText1,
		"en-AU": en_AU.organisms_pricing_modalContent_copyText1,
		"en-GB": en_GB.organisms_pricing_modalContent_copyText1,
		"en-US": en_US.organisms_pricing_modalContent_copyText1,
		"es-ES": es_ES.organisms_pricing_modalContent_copyText1,
		"fr-FR": fr_FR.organisms_pricing_modalContent_copyText1,
		"it-IT": it_IT.organisms_pricing_modalContent_copyText1,
		"ko-KR": ko_KR.organisms_pricing_modalContent_copyText1,
		"pt-BR": pt_BR.organisms_pricing_modalContent_copyText1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_modalContent_copyText2,
		"en-AU": en_AU.organisms_pricing_modalContent_copyText2,
		"en-GB": en_GB.organisms_pricing_modalContent_copyText2,
		"en-US": en_US.organisms_pricing_modalContent_copyText2,
		"es-ES": es_ES.organisms_pricing_modalContent_copyText2,
		"fr-FR": fr_FR.organisms_pricing_modalContent_copyText2,
		"it-IT": it_IT.organisms_pricing_modalContent_copyText2,
		"ko-KR": ko_KR.organisms_pricing_modalContent_copyText2,
		"pt-BR": pt_BR.organisms_pricing_modalContent_copyText2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_AU,
		"en-AU": en_AU.organisms_pricing_calculator_locales_AU,
		"en-GB": en_GB.organisms_pricing_calculator_locales_AU,
		"en-US": en_US.organisms_pricing_calculator_locales_AU,
		"es-ES": es_ES.organisms_pricing_calculator_locales_AU,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_AU,
		"it-IT": it_IT.organisms_pricing_calculator_locales_AU,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_AU,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_AU
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_AT,
		"en-AU": en_AU.organisms_pricing_calculator_locales_AT,
		"en-GB": en_GB.organisms_pricing_calculator_locales_AT,
		"en-US": en_US.organisms_pricing_calculator_locales_AT,
		"es-ES": es_ES.organisms_pricing_calculator_locales_AT,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_AT,
		"it-IT": it_IT.organisms_pricing_calculator_locales_AT,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_AT,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_AT
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_BE,
		"en-AU": en_AU.organisms_pricing_calculator_locales_BE,
		"en-GB": en_GB.organisms_pricing_calculator_locales_BE,
		"en-US": en_US.organisms_pricing_calculator_locales_BE,
		"es-ES": es_ES.organisms_pricing_calculator_locales_BE,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_BE,
		"it-IT": it_IT.organisms_pricing_calculator_locales_BE,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_BE,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_BE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_CA,
		"en-AU": en_AU.organisms_pricing_calculator_locales_CA,
		"en-GB": en_GB.organisms_pricing_calculator_locales_CA,
		"en-US": en_US.organisms_pricing_calculator_locales_CA,
		"es-ES": es_ES.organisms_pricing_calculator_locales_CA,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_CA,
		"it-IT": it_IT.organisms_pricing_calculator_locales_CA,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_CA,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_CA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_DK,
		"en-AU": en_AU.organisms_pricing_calculator_locales_DK,
		"en-GB": en_GB.organisms_pricing_calculator_locales_DK,
		"en-US": en_US.organisms_pricing_calculator_locales_DK,
		"es-ES": es_ES.organisms_pricing_calculator_locales_DK,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_DK,
		"it-IT": it_IT.organisms_pricing_calculator_locales_DK,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_DK,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_DK
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_FR,
		"en-AU": en_AU.organisms_pricing_calculator_locales_FR,
		"en-GB": en_GB.organisms_pricing_calculator_locales_FR,
		"en-US": en_US.organisms_pricing_calculator_locales_FR,
		"es-ES": es_ES.organisms_pricing_calculator_locales_FR,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_FR,
		"it-IT": it_IT.organisms_pricing_calculator_locales_FR,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_FR,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_FR
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_FI,
		"en-AU": en_AU.organisms_pricing_calculator_locales_FI,
		"en-GB": en_GB.organisms_pricing_calculator_locales_FI,
		"en-US": en_US.organisms_pricing_calculator_locales_FI,
		"es-ES": es_ES.organisms_pricing_calculator_locales_FI,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_FI,
		"it-IT": it_IT.organisms_pricing_calculator_locales_FI,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_FI,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_FI
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_DE,
		"en-AU": en_AU.organisms_pricing_calculator_locales_DE,
		"en-GB": en_GB.organisms_pricing_calculator_locales_DE,
		"en-US": en_US.organisms_pricing_calculator_locales_DE,
		"es-ES": es_ES.organisms_pricing_calculator_locales_DE,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_DE,
		"it-IT": it_IT.organisms_pricing_calculator_locales_DE,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_DE,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_DE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_IE,
		"en-AU": en_AU.organisms_pricing_calculator_locales_IE,
		"en-GB": en_GB.organisms_pricing_calculator_locales_IE,
		"en-US": en_US.organisms_pricing_calculator_locales_IE,
		"es-ES": es_ES.organisms_pricing_calculator_locales_IE,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_IE,
		"it-IT": it_IT.organisms_pricing_calculator_locales_IE,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_IE,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_IE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_IT,
		"en-AU": en_AU.organisms_pricing_calculator_locales_IT,
		"en-GB": en_GB.organisms_pricing_calculator_locales_IT,
		"en-US": en_US.organisms_pricing_calculator_locales_IT,
		"es-ES": es_ES.organisms_pricing_calculator_locales_IT,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_IT,
		"it-IT": it_IT.organisms_pricing_calculator_locales_IT,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_IT,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_IT
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_NL,
		"en-AU": en_AU.organisms_pricing_calculator_locales_NL,
		"en-GB": en_GB.organisms_pricing_calculator_locales_NL,
		"en-US": en_US.organisms_pricing_calculator_locales_NL,
		"es-ES": es_ES.organisms_pricing_calculator_locales_NL,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_NL,
		"it-IT": it_IT.organisms_pricing_calculator_locales_NL,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_NL,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_NL
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_NZ,
		"en-AU": en_AU.organisms_pricing_calculator_locales_NZ,
		"en-GB": en_GB.organisms_pricing_calculator_locales_NZ,
		"en-US": en_US.organisms_pricing_calculator_locales_NZ,
		"es-ES": es_ES.organisms_pricing_calculator_locales_NZ,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_NZ,
		"it-IT": it_IT.organisms_pricing_calculator_locales_NZ,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_NZ,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_NZ
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_NO,
		"en-AU": en_AU.organisms_pricing_calculator_locales_NO,
		"en-GB": en_GB.organisms_pricing_calculator_locales_NO,
		"en-US": en_US.organisms_pricing_calculator_locales_NO,
		"es-ES": es_ES.organisms_pricing_calculator_locales_NO,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_NO,
		"it-IT": it_IT.organisms_pricing_calculator_locales_NO,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_NO,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_NO
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BR = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_BR,
		"en-AU": en_AU.organisms_pricing_calculator_locales_BR,
		"en-GB": en_GB.organisms_pricing_calculator_locales_BR,
		"en-US": en_US.organisms_pricing_calculator_locales_BR,
		"es-ES": es_ES.organisms_pricing_calculator_locales_BR,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_BR,
		"it-IT": it_IT.organisms_pricing_calculator_locales_BR,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_BR,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_BR
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_GB,
		"en-AU": en_AU.organisms_pricing_calculator_locales_GB,
		"en-GB": en_GB.organisms_pricing_calculator_locales_GB,
		"en-US": en_US.organisms_pricing_calculator_locales_GB,
		"es-ES": es_ES.organisms_pricing_calculator_locales_GB,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_GB,
		"it-IT": it_IT.organisms_pricing_calculator_locales_GB,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_GB,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_GB
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_US,
		"en-AU": en_AU.organisms_pricing_calculator_locales_US,
		"en-GB": en_GB.organisms_pricing_calculator_locales_US,
		"en-US": en_US.organisms_pricing_calculator_locales_US,
		"es-ES": es_ES.organisms_pricing_calculator_locales_US,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_US,
		"it-IT": it_IT.organisms_pricing_calculator_locales_US,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_US,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_US
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_ES,
		"en-AU": en_AU.organisms_pricing_calculator_locales_ES,
		"en-GB": en_GB.organisms_pricing_calculator_locales_ES,
		"en-US": en_US.organisms_pricing_calculator_locales_ES,
		"es-ES": es_ES.organisms_pricing_calculator_locales_ES,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_ES,
		"it-IT": it_IT.organisms_pricing_calculator_locales_ES,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_ES,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_ES
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_SE,
		"en-AU": en_AU.organisms_pricing_calculator_locales_SE,
		"en-GB": en_GB.organisms_pricing_calculator_locales_SE,
		"en-US": en_US.organisms_pricing_calculator_locales_SE,
		"es-ES": es_ES.organisms_pricing_calculator_locales_SE,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_SE,
		"it-IT": it_IT.organisms_pricing_calculator_locales_SE,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_SE,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_SE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_CH,
		"en-AU": en_AU.organisms_pricing_calculator_locales_CH,
		"en-GB": en_GB.organisms_pricing_calculator_locales_CH,
		"en-US": en_US.organisms_pricing_calculator_locales_CH,
		"es-ES": es_ES.organisms_pricing_calculator_locales_CH,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_CH,
		"it-IT": it_IT.organisms_pricing_calculator_locales_CH,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_CH,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_CH
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_sendTo,
		"en-AU": en_AU.organisms_pricing_calculator_sendTo,
		"en-GB": en_GB.organisms_pricing_calculator_sendTo,
		"en-US": en_US.organisms_pricing_calculator_sendTo,
		"es-ES": es_ES.organisms_pricing_calculator_sendTo,
		"fr-FR": fr_FR.organisms_pricing_calculator_sendTo,
		"it-IT": it_IT.organisms_pricing_calculator_sendTo,
		"ko-KR": ko_KR.organisms_pricing_calculator_sendTo,
		"pt-BR": pt_BR.organisms_pricing_calculator_sendTo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_sms,
		"en-AU": en_AU.organisms_pricing_calculator_sms,
		"en-GB": en_GB.organisms_pricing_calculator_sms,
		"en-US": en_US.organisms_pricing_calculator_sms,
		"es-ES": es_ES.organisms_pricing_calculator_sms,
		"fr-FR": fr_FR.organisms_pricing_calculator_sms,
		"it-IT": it_IT.organisms_pricing_calculator_sms,
		"ko-KR": ko_KR.organisms_pricing_calculator_sms,
		"pt-BR": pt_BR.organisms_pricing_calculator_sms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_mms,
		"en-AU": en_AU.organisms_pricing_calculator_mms,
		"en-GB": en_GB.organisms_pricing_calculator_mms,
		"en-US": en_US.organisms_pricing_calculator_mms,
		"es-ES": es_ES.organisms_pricing_calculator_mms,
		"fr-FR": fr_FR.organisms_pricing_calculator_mms,
		"it-IT": it_IT.organisms_pricing_calculator_mms,
		"ko-KR": ko_KR.organisms_pricing_calculator_mms,
		"pt-BR": pt_BR.organisms_pricing_calculator_mms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_maxSends,
		"en-AU": en_AU.organisms_pricing_calculator_maxSends,
		"en-GB": en_GB.organisms_pricing_calculator_maxSends,
		"en-US": en_US.organisms_pricing_calculator_maxSends,
		"es-ES": es_ES.organisms_pricing_calculator_maxSends,
		"fr-FR": fr_FR.organisms_pricing_calculator_maxSends,
		"it-IT": it_IT.organisms_pricing_calculator_maxSends,
		"ko-KR": ko_KR.organisms_pricing_calculator_maxSends,
		"pt-BR": pt_BR.organisms_pricing_calculator_maxSends
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_pricePer,
		"en-AU": en_AU.organisms_pricing_calculator_pricePer,
		"en-GB": en_GB.organisms_pricing_calculator_pricePer,
		"en-US": en_US.organisms_pricing_calculator_pricePer,
		"es-ES": es_ES.organisms_pricing_calculator_pricePer,
		"fr-FR": fr_FR.organisms_pricing_calculator_pricePer,
		"it-IT": it_IT.organisms_pricing_calculator_pricePer,
		"ko-KR": ko_KR.organisms_pricing_calculator_pricePer,
		"pt-BR": pt_BR.organisms_pricing_calculator_pricePer
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_credit,
		"en-AU": en_AU.organisms_pricing_calculator_credit,
		"en-GB": en_GB.organisms_pricing_calculator_credit,
		"en-US": en_US.organisms_pricing_calculator_credit,
		"es-ES": es_ES.organisms_pricing_calculator_credit,
		"fr-FR": fr_FR.organisms_pricing_calculator_credit,
		"it-IT": it_IT.organisms_pricing_calculator_credit,
		"ko-KR": ko_KR.organisms_pricing_calculator_credit,
		"pt-BR": pt_BR.organisms_pricing_calculator_credit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_credits,
		"en-AU": en_AU.organisms_pricing_calculator_credits,
		"en-GB": en_GB.organisms_pricing_calculator_credits,
		"en-US": en_US.organisms_pricing_calculator_credits,
		"es-ES": es_ES.organisms_pricing_calculator_credits,
		"fr-FR": fr_FR.organisms_pricing_calculator_credits,
		"it-IT": it_IT.organisms_pricing_calculator_credits,
		"ko-KR": ko_KR.organisms_pricing_calculator_credits,
		"pt-BR": pt_BR.organisms_pricing_calculator_credits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_carrierFeeDisclaimer,
		"en-AU": en_AU.organisms_pricing_calculator_carrierFeeDisclaimer,
		"en-GB": en_GB.organisms_pricing_calculator_carrierFeeDisclaimer,
		"en-US": en_US.organisms_pricing_calculator_carrierFeeDisclaimer,
		"es-ES": es_ES.organisms_pricing_calculator_carrierFeeDisclaimer,
		"fr-FR": fr_FR.organisms_pricing_calculator_carrierFeeDisclaimer,
		"it-IT": it_IT.organisms_pricing_calculator_carrierFeeDisclaimer,
		"ko-KR": ko_KR.organisms_pricing_calculator_carrierFeeDisclaimer,
		"pt-BR": pt_BR.organisms_pricing_calculator_carrierFeeDisclaimer
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"en-AU": en_AU.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"en-GB": en_GB.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"en-US": en_US.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"es-ES": es_ES.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"fr-FR": fr_FR.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"it-IT": it_IT.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"ko-KR": ko_KR.organisms_pricing_calculator_carrierFeeDisclaimerEnd,
		"pt-BR": pt_BR.organisms_pricing_calculator_carrierFeeDisclaimerEnd
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_tileList_viewAll,
		"en-AU": en_AU.organisms_tileList_viewAll,
		"en-GB": en_GB.organisms_tileList_viewAll,
		"en-US": en_US.organisms_tileList_viewAll,
		"es-ES": es_ES.organisms_tileList_viewAll,
		"fr-FR": fr_FR.organisms_tileList_viewAll,
		"it-IT": it_IT.organisms_tileList_viewAll,
		"ko-KR": ko_KR.organisms_tileList_viewAll,
		"pt-BR": pt_BR.organisms_tileList_viewAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_video_playVideo,
		"en-AU": en_AU.organisms_video_playVideo,
		"en-GB": en_GB.organisms_video_playVideo,
		"en-US": en_US.organisms_video_playVideo,
		"es-ES": es_ES.organisms_video_playVideo,
		"fr-FR": fr_FR.organisms_video_playVideo,
		"it-IT": it_IT.organisms_video_playVideo,
		"ko-KR": ko_KR.organisms_video_playVideo,
		"pt-BR": pt_BR.organisms_video_playVideo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_filterTitle,
		"en-AU": en_AU.organisms_whatsNew_filterTitle,
		"en-GB": en_GB.organisms_whatsNew_filterTitle,
		"en-US": en_US.organisms_whatsNew_filterTitle,
		"es-ES": es_ES.organisms_whatsNew_filterTitle,
		"fr-FR": fr_FR.organisms_whatsNew_filterTitle,
		"it-IT": it_IT.organisms_whatsNew_filterTitle,
		"ko-KR": ko_KR.organisms_whatsNew_filterTitle,
		"pt-BR": pt_BR.organisms_whatsNew_filterTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_collapseAll,
		"en-AU": en_AU.organisms_whatsNew_collapseAll,
		"en-GB": en_GB.organisms_whatsNew_collapseAll,
		"en-US": en_US.organisms_whatsNew_collapseAll,
		"es-ES": es_ES.organisms_whatsNew_collapseAll,
		"fr-FR": fr_FR.organisms_whatsNew_collapseAll,
		"it-IT": it_IT.organisms_whatsNew_collapseAll,
		"ko-KR": ko_KR.organisms_whatsNew_collapseAll,
		"pt-BR": pt_BR.organisms_whatsNew_collapseAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_clearAll,
		"en-AU": en_AU.organisms_whatsNew_clearAll,
		"en-GB": en_GB.organisms_whatsNew_clearAll,
		"en-US": en_US.organisms_whatsNew_clearAll,
		"es-ES": es_ES.organisms_whatsNew_clearAll,
		"fr-FR": fr_FR.organisms_whatsNew_clearAll,
		"it-IT": it_IT.organisms_whatsNew_clearAll,
		"ko-KR": ko_KR.organisms_whatsNew_clearAll,
		"pt-BR": pt_BR.organisms_whatsNew_clearAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_placeholder,
		"en-AU": en_AU.organisms_whatsNew_placeholder,
		"en-GB": en_GB.organisms_whatsNew_placeholder,
		"en-US": en_US.organisms_whatsNew_placeholder,
		"es-ES": es_ES.organisms_whatsNew_placeholder,
		"fr-FR": fr_FR.organisms_whatsNew_placeholder,
		"it-IT": it_IT.organisms_whatsNew_placeholder,
		"ko-KR": ko_KR.organisms_whatsNew_placeholder,
		"pt-BR": pt_BR.organisms_whatsNew_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_watchQuarterlyRecap,
		"en-AU": en_AU.organisms_whatsNew_watchQuarterlyRecap,
		"en-GB": en_GB.organisms_whatsNew_watchQuarterlyRecap,
		"en-US": en_US.organisms_whatsNew_watchQuarterlyRecap,
		"es-ES": es_ES.organisms_whatsNew_watchQuarterlyRecap,
		"fr-FR": fr_FR.organisms_whatsNew_watchQuarterlyRecap,
		"it-IT": it_IT.organisms_whatsNew_watchQuarterlyRecap,
		"ko-KR": ko_KR.organisms_whatsNew_watchQuarterlyRecap,
		"pt-BR": pt_BR.organisms_whatsNew_watchQuarterlyRecap
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_topic,
		"en-AU": en_AU.organisms_whatsNew_refinements_topic,
		"en-GB": en_GB.organisms_whatsNew_refinements_topic,
		"en-US": en_US.organisms_whatsNew_refinements_topic,
		"es-ES": es_ES.organisms_whatsNew_refinements_topic,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_topic,
		"it-IT": it_IT.organisms_whatsNew_refinements_topic,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_topic,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_topic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_release_type,
		"en-AU": en_AU.organisms_whatsNew_refinements_release_type,
		"en-GB": en_GB.organisms_whatsNew_refinements_release_type,
		"en-US": en_US.organisms_whatsNew_refinements_release_type,
		"es-ES": es_ES.organisms_whatsNew_refinements_release_type,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_release_type,
		"it-IT": it_IT.organisms_whatsNew_refinements_release_type,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_release_type,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_release_type
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_benefits,
		"en-AU": en_AU.organisms_whatsNew_refinements_benefits,
		"en-GB": en_GB.organisms_whatsNew_refinements_benefits,
		"en-US": en_US.organisms_whatsNew_refinements_benefits,
		"es-ES": es_ES.organisms_whatsNew_refinements_benefits,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_benefits,
		"it-IT": it_IT.organisms_whatsNew_refinements_benefits,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_benefits,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_benefits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_accounts_billing,
		"en-AU": en_AU.organisms_whatsNew_refinements_accounts_billing,
		"en-GB": en_GB.organisms_whatsNew_refinements_accounts_billing,
		"en-US": en_US.organisms_whatsNew_refinements_accounts_billing,
		"es-ES": es_ES.organisms_whatsNew_refinements_accounts_billing,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_accounts_billing,
		"it-IT": it_IT.organisms_whatsNew_refinements_accounts_billing,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_accounts_billing,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_accounts_billing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_analytics,
		"en-AU": en_AU.organisms_whatsNew_refinements_analytics,
		"en-GB": en_GB.organisms_whatsNew_refinements_analytics,
		"en-US": en_US.organisms_whatsNew_refinements_analytics,
		"es-ES": es_ES.organisms_whatsNew_refinements_analytics,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_analytics,
		"it-IT": it_IT.organisms_whatsNew_refinements_analytics,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_analytics,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_analytics
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_audience,
		"en-AU": en_AU.organisms_whatsNew_refinements_audience,
		"en-GB": en_GB.organisms_whatsNew_refinements_audience,
		"en-US": en_US.organisms_whatsNew_refinements_audience,
		"es-ES": es_ES.organisms_whatsNew_refinements_audience,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_audience,
		"it-IT": it_IT.organisms_whatsNew_refinements_audience,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_audience,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_audience
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_cdp,
		"en-AU": en_AU.organisms_whatsNew_refinements_cdp,
		"en-GB": en_GB.organisms_whatsNew_refinements_cdp,
		"en-US": en_US.organisms_whatsNew_refinements_cdp,
		"es-ES": es_ES.organisms_whatsNew_refinements_cdp,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_cdp,
		"it-IT": it_IT.organisms_whatsNew_refinements_cdp,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_cdp,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_cdp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_campaigns,
		"en-AU": en_AU.organisms_whatsNew_refinements_campaigns,
		"en-GB": en_GB.organisms_whatsNew_refinements_campaigns,
		"en-US": en_US.organisms_whatsNew_refinements_campaigns,
		"es-ES": es_ES.organisms_whatsNew_refinements_campaigns,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_campaigns,
		"it-IT": it_IT.organisms_whatsNew_refinements_campaigns,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_campaigns,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_campaigns
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_deliver_compliance,
		"en-AU": en_AU.organisms_whatsNew_refinements_deliver_compliance,
		"en-GB": en_GB.organisms_whatsNew_refinements_deliver_compliance,
		"en-US": en_US.organisms_whatsNew_refinements_deliver_compliance,
		"es-ES": es_ES.organisms_whatsNew_refinements_deliver_compliance,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_deliver_compliance,
		"it-IT": it_IT.organisms_whatsNew_refinements_deliver_compliance,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_deliver_compliance,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_deliver_compliance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_email,
		"en-AU": en_AU.organisms_whatsNew_refinements_email,
		"en-GB": en_GB.organisms_whatsNew_refinements_email,
		"en-US": en_US.organisms_whatsNew_refinements_email,
		"es-ES": es_ES.organisms_whatsNew_refinements_email,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_email,
		"it-IT": it_IT.organisms_whatsNew_refinements_email,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_email,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_flows,
		"en-AU": en_AU.organisms_whatsNew_refinements_flows,
		"en-GB": en_GB.organisms_whatsNew_refinements_flows,
		"en-US": en_US.organisms_whatsNew_refinements_flows,
		"es-ES": es_ES.organisms_whatsNew_refinements_flows,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_flows,
		"it-IT": it_IT.organisms_whatsNew_refinements_flows,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_flows,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_flows
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_integrations,
		"en-AU": en_AU.organisms_whatsNew_refinements_integrations,
		"en-GB": en_GB.organisms_whatsNew_refinements_integrations,
		"en-US": en_US.organisms_whatsNew_refinements_integrations,
		"es-ES": es_ES.organisms_whatsNew_refinements_integrations,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_integrations,
		"it-IT": it_IT.organisms_whatsNew_refinements_integrations,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_integrations,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_integrations
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_push_notifications,
		"en-AU": en_AU.organisms_whatsNew_refinements_push_notifications,
		"en-GB": en_GB.organisms_whatsNew_refinements_push_notifications,
		"en-US": en_US.organisms_whatsNew_refinements_push_notifications,
		"es-ES": es_ES.organisms_whatsNew_refinements_push_notifications,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_push_notifications,
		"it-IT": it_IT.organisms_whatsNew_refinements_push_notifications,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_push_notifications,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_push_notifications
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_reviews,
		"en-AU": en_AU.organisms_whatsNew_refinements_reviews,
		"en-GB": en_GB.organisms_whatsNew_refinements_reviews,
		"en-US": en_US.organisms_whatsNew_refinements_reviews,
		"es-ES": es_ES.organisms_whatsNew_refinements_reviews,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_reviews,
		"it-IT": it_IT.organisms_whatsNew_refinements_reviews,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_reviews,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_reviews
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_sign_up_forms,
		"en-AU": en_AU.organisms_whatsNew_refinements_sign_up_forms,
		"en-GB": en_GB.organisms_whatsNew_refinements_sign_up_forms,
		"en-US": en_US.organisms_whatsNew_refinements_sign_up_forms,
		"es-ES": es_ES.organisms_whatsNew_refinements_sign_up_forms,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_sign_up_forms,
		"it-IT": it_IT.organisms_whatsNew_refinements_sign_up_forms,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_sign_up_forms,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_sign_up_forms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_sms,
		"en-AU": en_AU.organisms_whatsNew_refinements_sms,
		"en-GB": en_GB.organisms_whatsNew_refinements_sms,
		"en-US": en_US.organisms_whatsNew_refinements_sms,
		"es-ES": es_ES.organisms_whatsNew_refinements_sms,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_sms,
		"it-IT": it_IT.organisms_whatsNew_refinements_sms,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_sms,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_sms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_klaviyo_ai,
		"en-AU": en_AU.organisms_whatsNew_refinements_klaviyo_ai,
		"en-GB": en_GB.organisms_whatsNew_refinements_klaviyo_ai,
		"en-US": en_US.organisms_whatsNew_refinements_klaviyo_ai,
		"es-ES": es_ES.organisms_whatsNew_refinements_klaviyo_ai,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_klaviyo_ai,
		"it-IT": it_IT.organisms_whatsNew_refinements_klaviyo_ai,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_klaviyo_ai,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_klaviyo_ai
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_coming_soon,
		"en-AU": en_AU.organisms_whatsNew_refinements_coming_soon,
		"en-GB": en_GB.organisms_whatsNew_refinements_coming_soon,
		"en-US": en_US.organisms_whatsNew_refinements_coming_soon,
		"es-ES": es_ES.organisms_whatsNew_refinements_coming_soon,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_coming_soon,
		"it-IT": it_IT.organisms_whatsNew_refinements_coming_soon,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_coming_soon,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_coming_soon
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_limited_availability,
		"en-AU": en_AU.organisms_whatsNew_refinements_limited_availability,
		"en-GB": en_GB.organisms_whatsNew_refinements_limited_availability,
		"en-US": en_US.organisms_whatsNew_refinements_limited_availability,
		"es-ES": es_ES.organisms_whatsNew_refinements_limited_availability,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_limited_availability,
		"it-IT": it_IT.organisms_whatsNew_refinements_limited_availability,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_limited_availability,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_limited_availability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_gradual_release,
		"en-AU": en_AU.organisms_whatsNew_refinements_gradual_release,
		"en-GB": en_GB.organisms_whatsNew_refinements_gradual_release,
		"en-US": en_US.organisms_whatsNew_refinements_gradual_release,
		"es-ES": es_ES.organisms_whatsNew_refinements_gradual_release,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_gradual_release,
		"it-IT": it_IT.organisms_whatsNew_refinements_gradual_release,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_gradual_release,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_gradual_release
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_whatsNew_refinements_general_availability,
		"en-AU": en_AU.organisms_whatsNew_refinements_general_availability,
		"en-GB": en_GB.organisms_whatsNew_refinements_general_availability,
		"en-US": en_US.organisms_whatsNew_refinements_general_availability,
		"es-ES": es_ES.organisms_whatsNew_refinements_general_availability,
		"fr-FR": fr_FR.organisms_whatsNew_refinements_general_availability,
		"it-IT": it_IT.organisms_whatsNew_refinements_general_availability,
		"ko-KR": ko_KR.organisms_whatsNew_refinements_general_availability,
		"pt-BR": pt_BR.organisms_whatsNew_refinements_general_availability
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_notFound_eyebrow,
		"en-AU": en_AU.pages_notFound_eyebrow,
		"en-GB": en_GB.pages_notFound_eyebrow,
		"en-US": en_US.pages_notFound_eyebrow,
		"es-ES": es_ES.pages_notFound_eyebrow,
		"fr-FR": fr_FR.pages_notFound_eyebrow,
		"it-IT": it_IT.pages_notFound_eyebrow,
		"ko-KR": ko_KR.pages_notFound_eyebrow,
		"pt-BR": pt_BR.pages_notFound_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_notFound_itsPronounced,
		"en-AU": en_AU.pages_notFound_itsPronounced,
		"en-GB": en_GB.pages_notFound_itsPronounced,
		"en-US": en_US.pages_notFound_itsPronounced,
		"es-ES": es_ES.pages_notFound_itsPronounced,
		"fr-FR": fr_FR.pages_notFound_itsPronounced,
		"it-IT": it_IT.pages_notFound_itsPronounced,
		"ko-KR": ko_KR.pages_notFound_itsPronounced,
		"pt-BR": pt_BR.pages_notFound_itsPronounced
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_notFound_bodyCopy,
		"en-AU": en_AU.pages_notFound_bodyCopy,
		"en-GB": en_GB.pages_notFound_bodyCopy,
		"en-US": en_US.pages_notFound_bodyCopy,
		"es-ES": es_ES.pages_notFound_bodyCopy,
		"fr-FR": fr_FR.pages_notFound_bodyCopy,
		"it-IT": it_IT.pages_notFound_bodyCopy,
		"ko-KR": ko_KR.pages_notFound_bodyCopy,
		"pt-BR": pt_BR.pages_notFound_bodyCopy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_notFound_button,
		"en-AU": en_AU.pages_notFound_button,
		"en-GB": en_GB.pages_notFound_button,
		"en-US": en_US.pages_notFound_button,
		"es-ES": es_ES.pages_notFound_button,
		"fr-FR": fr_FR.pages_notFound_button,
		"it-IT": it_IT.pages_notFound_button,
		"ko-KR": ko_KR.pages_notFound_button,
		"pt-BR": pt_BR.pages_notFound_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_pageTitle,
		"en-AU": en_AU.pages_careers_searchJobs_pageTitle,
		"en-GB": en_GB.pages_careers_searchJobs_pageTitle,
		"en-US": en_US.pages_careers_searchJobs_pageTitle,
		"es-ES": es_ES.pages_careers_searchJobs_pageTitle,
		"fr-FR": fr_FR.pages_careers_searchJobs_pageTitle,
		"it-IT": it_IT.pages_careers_searchJobs_pageTitle,
		"ko-KR": ko_KR.pages_careers_searchJobs_pageTitle,
		"pt-BR": pt_BR.pages_careers_searchJobs_pageTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_headline,
		"en-AU": en_AU.pages_careers_searchJobs_headline,
		"en-GB": en_GB.pages_careers_searchJobs_headline,
		"en-US": en_US.pages_careers_searchJobs_headline,
		"es-ES": es_ES.pages_careers_searchJobs_headline,
		"fr-FR": fr_FR.pages_careers_searchJobs_headline,
		"it-IT": it_IT.pages_careers_searchJobs_headline,
		"ko-KR": ko_KR.pages_careers_searchJobs_headline,
		"pt-BR": pt_BR.pages_careers_searchJobs_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_recentJobs,
		"en-AU": en_AU.pages_careers_searchJobs_recentJobs,
		"en-GB": en_GB.pages_careers_searchJobs_recentJobs,
		"en-US": en_US.pages_careers_searchJobs_recentJobs,
		"es-ES": es_ES.pages_careers_searchJobs_recentJobs,
		"fr-FR": fr_FR.pages_careers_searchJobs_recentJobs,
		"it-IT": it_IT.pages_careers_searchJobs_recentJobs,
		"ko-KR": ko_KR.pages_careers_searchJobs_recentJobs,
		"pt-BR": pt_BR.pages_careers_searchJobs_recentJobs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_savedJobs,
		"en-AU": en_AU.pages_careers_searchJobs_savedJobs,
		"en-GB": en_GB.pages_careers_searchJobs_savedJobs,
		"en-US": en_US.pages_careers_searchJobs_savedJobs,
		"es-ES": es_ES.pages_careers_searchJobs_savedJobs,
		"fr-FR": fr_FR.pages_careers_searchJobs_savedJobs,
		"it-IT": it_IT.pages_careers_searchJobs_savedJobs,
		"ko-KR": ko_KR.pages_careers_searchJobs_savedJobs,
		"pt-BR": pt_BR.pages_careers_searchJobs_savedJobs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_breadcrumbs_home,
		"en-AU": en_AU.pages_careers_searchJobs_breadcrumbs_home,
		"en-GB": en_GB.pages_careers_searchJobs_breadcrumbs_home,
		"en-US": en_US.pages_careers_searchJobs_breadcrumbs_home,
		"es-ES": es_ES.pages_careers_searchJobs_breadcrumbs_home,
		"fr-FR": fr_FR.pages_careers_searchJobs_breadcrumbs_home,
		"it-IT": it_IT.pages_careers_searchJobs_breadcrumbs_home,
		"ko-KR": ko_KR.pages_careers_searchJobs_breadcrumbs_home,
		"pt-BR": pt_BR.pages_careers_searchJobs_breadcrumbs_home
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"en-AU": en_AU.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"en-GB": en_GB.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"en-US": en_US.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"es-ES": es_ES.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"fr-FR": fr_FR.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"it-IT": it_IT.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"ko-KR": ko_KR.pages_careers_searchJobs_breadcrumbs_searchJobs,
		"pt-BR": pt_BR.pages_careers_searchJobs_breadcrumbs_searchJobs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params , options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_searchResults,
		"en-AU": en_AU.pages_careers_searchJobs_form_searchResults,
		"en-GB": en_GB.pages_careers_searchJobs_form_searchResults,
		"en-US": en_US.pages_careers_searchJobs_form_searchResults,
		"es-ES": es_ES.pages_careers_searchJobs_form_searchResults,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_searchResults,
		"it-IT": it_IT.pages_careers_searchJobs_form_searchResults,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_searchResults,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_searchResults
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_noResults,
		"en-AU": en_AU.pages_careers_searchJobs_form_noResults,
		"en-GB": en_GB.pages_careers_searchJobs_form_noResults,
		"en-US": en_US.pages_careers_searchJobs_form_noResults,
		"es-ES": es_ES.pages_careers_searchJobs_form_noResults,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_noResults,
		"it-IT": it_IT.pages_careers_searchJobs_form_noResults,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_noResults,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_noResults
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_noResultsReset,
		"en-AU": en_AU.pages_careers_searchJobs_form_noResultsReset,
		"en-GB": en_GB.pages_careers_searchJobs_form_noResultsReset,
		"en-US": en_US.pages_careers_searchJobs_form_noResultsReset,
		"es-ES": es_ES.pages_careers_searchJobs_form_noResultsReset,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_noResultsReset,
		"it-IT": it_IT.pages_careers_searchJobs_form_noResultsReset,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_noResultsReset,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_noResultsReset
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_legend,
		"en-AU": en_AU.pages_careers_searchJobs_form_legend,
		"en-GB": en_GB.pages_careers_searchJobs_form_legend,
		"en-US": en_US.pages_careers_searchJobs_form_legend,
		"es-ES": es_ES.pages_careers_searchJobs_form_legend,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_legend,
		"it-IT": it_IT.pages_careers_searchJobs_form_legend,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_legend,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_legend
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_keywords,
		"en-AU": en_AU.pages_careers_searchJobs_form_keywords,
		"en-GB": en_GB.pages_careers_searchJobs_form_keywords,
		"en-US": en_US.pages_careers_searchJobs_form_keywords,
		"es-ES": es_ES.pages_careers_searchJobs_form_keywords,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_keywords,
		"it-IT": it_IT.pages_careers_searchJobs_form_keywords,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_keywords,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_keywords
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_keywordsPlaceholder,
		"en-AU": en_AU.pages_careers_searchJobs_form_keywordsPlaceholder,
		"en-GB": en_GB.pages_careers_searchJobs_form_keywordsPlaceholder,
		"en-US": en_US.pages_careers_searchJobs_form_keywordsPlaceholder,
		"es-ES": es_ES.pages_careers_searchJobs_form_keywordsPlaceholder,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_keywordsPlaceholder,
		"it-IT": it_IT.pages_careers_searchJobs_form_keywordsPlaceholder,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_keywordsPlaceholder,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_keywordsPlaceholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_country,
		"en-AU": en_AU.pages_careers_searchJobs_form_country,
		"en-GB": en_GB.pages_careers_searchJobs_form_country,
		"en-US": en_US.pages_careers_searchJobs_form_country,
		"es-ES": es_ES.pages_careers_searchJobs_form_country,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_country,
		"it-IT": it_IT.pages_careers_searchJobs_form_country,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_country,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_country
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_location,
		"en-AU": en_AU.pages_careers_searchJobs_form_location,
		"en-GB": en_GB.pages_careers_searchJobs_form_location,
		"en-US": en_US.pages_careers_searchJobs_form_location,
		"es-ES": es_ES.pages_careers_searchJobs_form_location,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_location,
		"it-IT": it_IT.pages_careers_searchJobs_form_location,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_location,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_location
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_team,
		"en-AU": en_AU.pages_careers_searchJobs_form_team,
		"en-GB": en_GB.pages_careers_searchJobs_form_team,
		"en-US": en_US.pages_careers_searchJobs_form_team,
		"es-ES": es_ES.pages_careers_searchJobs_form_team,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_team,
		"it-IT": it_IT.pages_careers_searchJobs_form_team,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_team,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_team
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_applyFilters,
		"en-AU": en_AU.pages_careers_searchJobs_form_applyFilters,
		"en-GB": en_GB.pages_careers_searchJobs_form_applyFilters,
		"en-US": en_US.pages_careers_searchJobs_form_applyFilters,
		"es-ES": es_ES.pages_careers_searchJobs_form_applyFilters,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_applyFilters,
		"it-IT": it_IT.pages_careers_searchJobs_form_applyFilters,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_applyFilters,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_applyFilters
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_careers_searchJobs_form_clearFilters,
		"en-AU": en_AU.pages_careers_searchJobs_form_clearFilters,
		"en-GB": en_GB.pages_careers_searchJobs_form_clearFilters,
		"en-US": en_US.pages_careers_searchJobs_form_clearFilters,
		"es-ES": es_ES.pages_careers_searchJobs_form_clearFilters,
		"fr-FR": fr_FR.pages_careers_searchJobs_form_clearFilters,
		"it-IT": it_IT.pages_careers_searchJobs_form_clearFilters,
		"ko-KR": ko_KR.pages_careers_searchJobs_form_clearFilters,
		"pt-BR": pt_BR.pages_careers_searchJobs_form_clearFilters
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_community_answered,
		"en-AU": en_AU.pages_search_community_answered,
		"en-GB": en_GB.pages_search_community_answered,
		"en-US": en_US.pages_search_community_answered,
		"es-ES": es_ES.pages_search_community_answered,
		"fr-FR": fr_FR.pages_search_community_answered,
		"it-IT": it_IT.pages_search_community_answered,
		"ko-KR": ko_KR.pages_search_community_answered,
		"pt-BR": pt_BR.pages_search_community_answered
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_cardMinutes,
		"en-AU": en_AU.pages_search_cardMinutes,
		"en-GB": en_GB.pages_search_cardMinutes,
		"en-US": en_US.pages_search_cardMinutes,
		"es-ES": es_ES.pages_search_cardMinutes,
		"fr-FR": fr_FR.pages_search_cardMinutes,
		"it-IT": it_IT.pages_search_cardMinutes,
		"ko-KR": ko_KR.pages_search_cardMinutes,
		"pt-BR": pt_BR.pages_search_cardMinutes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_cardSingularMinute,
		"en-AU": en_AU.pages_search_cardSingularMinute,
		"en-GB": en_GB.pages_search_cardSingularMinute,
		"en-US": en_US.pages_search_cardSingularMinute,
		"es-ES": es_ES.pages_search_cardSingularMinute,
		"fr-FR": fr_FR.pages_search_cardSingularMinute,
		"it-IT": it_IT.pages_search_cardSingularMinute,
		"ko-KR": ko_KR.pages_search_cardSingularMinute,
		"pt-BR": pt_BR.pages_search_cardSingularMinute
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_cardHours,
		"en-AU": en_AU.pages_search_cardHours,
		"en-GB": en_GB.pages_search_cardHours,
		"en-US": en_US.pages_search_cardHours,
		"es-ES": es_ES.pages_search_cardHours,
		"fr-FR": fr_FR.pages_search_cardHours,
		"it-IT": it_IT.pages_search_cardHours,
		"ko-KR": ko_KR.pages_search_cardHours,
		"pt-BR": pt_BR.pages_search_cardHours
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_cardSingularHour,
		"en-AU": en_AU.pages_search_cardSingularHour,
		"en-GB": en_GB.pages_search_cardSingularHour,
		"en-US": en_US.pages_search_cardSingularHour,
		"es-ES": es_ES.pages_search_cardSingularHour,
		"fr-FR": fr_FR.pages_search_cardSingularHour,
		"it-IT": it_IT.pages_search_cardSingularHour,
		"ko-KR": ko_KR.pages_search_cardSingularHour,
		"pt-BR": pt_BR.pages_search_cardSingularHour
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_headline,
		"en-AU": en_AU.pages_search_headline,
		"en-GB": en_GB.pages_search_headline,
		"en-US": en_US.pages_search_headline,
		"es-ES": es_ES.pages_search_headline,
		"fr-FR": fr_FR.pages_search_headline,
		"it-IT": it_IT.pages_search_headline,
		"ko-KR": ko_KR.pages_search_headline,
		"pt-BR": pt_BR.pages_search_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_placeholder,
		"en-AU": en_AU.pages_search_placeholder,
		"en-GB": en_GB.pages_search_placeholder,
		"en-US": en_US.pages_search_placeholder,
		"es-ES": es_ES.pages_search_placeholder,
		"fr-FR": fr_FR.pages_search_placeholder,
		"it-IT": it_IT.pages_search_placeholder,
		"ko-KR": ko_KR.pages_search_placeholder,
		"pt-BR": pt_BR.pages_search_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_toggleLabel,
		"en-AU": en_AU.pages_search_toggleLabel,
		"en-GB": en_GB.pages_search_toggleLabel,
		"en-US": en_US.pages_search_toggleLabel,
		"es-ES": es_ES.pages_search_toggleLabel,
		"fr-FR": fr_FR.pages_search_toggleLabel,
		"it-IT": it_IT.pages_search_toggleLabel,
		"ko-KR": ko_KR.pages_search_toggleLabel,
		"pt-BR": pt_BR.pages_search_toggleLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_resultLabelTop,
		"en-AU": en_AU.pages_search_resultLabelTop,
		"en-GB": en_GB.pages_search_resultLabelTop,
		"en-US": en_US.pages_search_resultLabelTop,
		"es-ES": es_ES.pages_search_resultLabelTop,
		"fr-FR": fr_FR.pages_search_resultLabelTop,
		"it-IT": it_IT.pages_search_resultLabelTop,
		"ko-KR": ko_KR.pages_search_resultLabelTop,
		"pt-BR": pt_BR.pages_search_resultLabelTop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ ' y ': NonNullable<unknown>, ' x ': NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params , options = {}) => {
	return {
		"de-DE": de_DE.pages_search_resultLabelYofX,
		"en-AU": en_AU.pages_search_resultLabelYofX,
		"en-GB": en_GB.pages_search_resultLabelYofX,
		"en-US": en_US.pages_search_resultLabelYofX,
		"es-ES": es_ES.pages_search_resultLabelYofX,
		"fr-FR": fr_FR.pages_search_resultLabelYofX,
		"it-IT": it_IT.pages_search_resultLabelYofX,
		"ko-KR": ko_KR.pages_search_resultLabelYofX,
		"pt-BR": pt_BR.pages_search_resultLabelYofX
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ ' index ': NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params , options = {}) => {
	return {
		"de-DE": de_DE.pages_search_viewAllResults,
		"en-AU": en_AU.pages_search_viewAllResults,
		"en-GB": en_GB.pages_search_viewAllResults,
		"en-US": en_US.pages_search_viewAllResults,
		"es-ES": es_ES.pages_search_viewAllResults,
		"fr-FR": fr_FR.pages_search_viewAllResults,
		"it-IT": it_IT.pages_search_viewAllResults,
		"ko-KR": ko_KR.pages_search_viewAllResults,
		"pt-BR": pt_BR.pages_search_viewAllResults
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_viewMoreResults,
		"en-AU": en_AU.pages_search_viewMoreResults,
		"en-GB": en_GB.pages_search_viewMoreResults,
		"en-US": en_US.pages_search_viewMoreResults,
		"es-ES": es_ES.pages_search_viewMoreResults,
		"fr-FR": fr_FR.pages_search_viewMoreResults,
		"it-IT": it_IT.pages_search_viewMoreResults,
		"ko-KR": ko_KR.pages_search_viewMoreResults,
		"pt-BR": pt_BR.pages_search_viewMoreResults
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ ' query ': NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params , options = {}) => {
	return {
		"de-DE": de_DE.pages_search_noResultsTitle,
		"en-AU": en_AU.pages_search_noResultsTitle,
		"en-GB": en_GB.pages_search_noResultsTitle,
		"en-US": en_US.pages_search_noResultsTitle,
		"es-ES": es_ES.pages_search_noResultsTitle,
		"fr-FR": fr_FR.pages_search_noResultsTitle,
		"it-IT": it_IT.pages_search_noResultsTitle,
		"ko-KR": ko_KR.pages_search_noResultsTitle,
		"pt-BR": pt_BR.pages_search_noResultsTitle
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_noResultsSubTitle,
		"en-AU": en_AU.pages_search_noResultsSubTitle,
		"en-GB": en_GB.pages_search_noResultsSubTitle,
		"en-US": en_US.pages_search_noResultsSubTitle,
		"es-ES": es_ES.pages_search_noResultsSubTitle,
		"fr-FR": fr_FR.pages_search_noResultsSubTitle,
		"it-IT": it_IT.pages_search_noResultsSubTitle,
		"ko-KR": ko_KR.pages_search_noResultsSubTitle,
		"pt-BR": pt_BR.pages_search_noResultsSubTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearchesTitle,
		"en-AU": en_AU.pages_search_suggestedSearchesTitle,
		"en-GB": en_GB.pages_search_suggestedSearchesTitle,
		"en-US": en_US.pages_search_suggestedSearchesTitle,
		"es-ES": es_ES.pages_search_suggestedSearchesTitle,
		"fr-FR": fr_FR.pages_search_suggestedSearchesTitle,
		"it-IT": it_IT.pages_search_suggestedSearchesTitle,
		"ko-KR": ko_KR.pages_search_suggestedSearchesTitle,
		"pt-BR": pt_BR.pages_search_suggestedSearchesTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search1,
		"en-AU": en_AU.pages_search_suggestedSearches_search1,
		"en-GB": en_GB.pages_search_suggestedSearches_search1,
		"en-US": en_US.pages_search_suggestedSearches_search1,
		"es-ES": es_ES.pages_search_suggestedSearches_search1,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search1,
		"it-IT": it_IT.pages_search_suggestedSearches_search1,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search1,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search2,
		"en-AU": en_AU.pages_search_suggestedSearches_search2,
		"en-GB": en_GB.pages_search_suggestedSearches_search2,
		"en-US": en_US.pages_search_suggestedSearches_search2,
		"es-ES": es_ES.pages_search_suggestedSearches_search2,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search2,
		"it-IT": it_IT.pages_search_suggestedSearches_search2,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search2,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search3,
		"en-AU": en_AU.pages_search_suggestedSearches_search3,
		"en-GB": en_GB.pages_search_suggestedSearches_search3,
		"en-US": en_US.pages_search_suggestedSearches_search3,
		"es-ES": es_ES.pages_search_suggestedSearches_search3,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search3,
		"it-IT": it_IT.pages_search_suggestedSearches_search3,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search3,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search4,
		"en-AU": en_AU.pages_search_suggestedSearches_search4,
		"en-GB": en_GB.pages_search_suggestedSearches_search4,
		"en-US": en_US.pages_search_suggestedSearches_search4,
		"es-ES": es_ES.pages_search_suggestedSearches_search4,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search4,
		"it-IT": it_IT.pages_search_suggestedSearches_search4,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search4,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search5,
		"en-AU": en_AU.pages_search_suggestedSearches_search5,
		"en-GB": en_GB.pages_search_suggestedSearches_search5,
		"en-US": en_US.pages_search_suggestedSearches_search5,
		"es-ES": es_ES.pages_search_suggestedSearches_search5,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search5,
		"it-IT": it_IT.pages_search_suggestedSearches_search5,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search5,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_suggestedSearches_search6,
		"en-AU": en_AU.pages_search_suggestedSearches_search6,
		"en-GB": en_GB.pages_search_suggestedSearches_search6,
		"en-US": en_US.pages_search_suggestedSearches_search6,
		"es-ES": es_ES.pages_search_suggestedSearches_search6,
		"fr-FR": fr_FR.pages_search_suggestedSearches_search6,
		"it-IT": it_IT.pages_search_suggestedSearches_search6,
		"ko-KR": ko_KR.pages_search_suggestedSearches_search6,
		"pt-BR": pt_BR.pages_search_suggestedSearches_search6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_collapseAll,
		"en-AU": en_AU.pages_search_filters_collapseAll,
		"en-GB": en_GB.pages_search_filters_collapseAll,
		"en-US": en_US.pages_search_filters_collapseAll,
		"es-ES": es_ES.pages_search_filters_collapseAll,
		"fr-FR": fr_FR.pages_search_filters_collapseAll,
		"it-IT": it_IT.pages_search_filters_collapseAll,
		"ko-KR": ko_KR.pages_search_filters_collapseAll,
		"pt-BR": pt_BR.pages_search_filters_collapseAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_clearAll,
		"en-AU": en_AU.pages_search_filters_clearAll,
		"en-GB": en_GB.pages_search_filters_clearAll,
		"en-US": en_US.pages_search_filters_clearAll,
		"es-ES": es_ES.pages_search_filters_clearAll,
		"fr-FR": fr_FR.pages_search_filters_clearAll,
		"it-IT": it_IT.pages_search_filters_clearAll,
		"ko-KR": ko_KR.pages_search_filters_clearAll,
		"pt-BR": pt_BR.pages_search_filters_clearAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_resource,
		"en-AU": en_AU.pages_search_filters_resource,
		"en-GB": en_GB.pages_search_filters_resource,
		"en-US": en_US.pages_search_filters_resource,
		"es-ES": es_ES.pages_search_filters_resource,
		"fr-FR": fr_FR.pages_search_filters_resource,
		"it-IT": it_IT.pages_search_filters_resource,
		"ko-KR": ko_KR.pages_search_filters_resource,
		"pt-BR": pt_BR.pages_search_filters_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_allResources,
		"en-AU": en_AU.pages_search_filters_allResources,
		"en-GB": en_GB.pages_search_filters_allResources,
		"en-US": en_US.pages_search_filters_allResources,
		"es-ES": es_ES.pages_search_filters_allResources,
		"fr-FR": fr_FR.pages_search_filters_allResources,
		"it-IT": it_IT.pages_search_filters_allResources,
		"ko-KR": ko_KR.pages_search_filters_allResources,
		"pt-BR": pt_BR.pages_search_filters_allResources
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_academy,
		"en-AU": en_AU.pages_search_filters_academy,
		"en-GB": en_GB.pages_search_filters_academy,
		"en-US": en_US.pages_search_filters_academy,
		"es-ES": es_ES.pages_search_filters_academy,
		"fr-FR": fr_FR.pages_search_filters_academy,
		"it-IT": it_IT.pages_search_filters_academy,
		"ko-KR": ko_KR.pages_search_filters_academy,
		"pt-BR": pt_BR.pages_search_filters_academy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_community,
		"en-AU": en_AU.pages_search_filters_community,
		"en-GB": en_GB.pages_search_filters_community,
		"en-US": en_US.pages_search_filters_community,
		"es-ES": es_ES.pages_search_filters_community,
		"fr-FR": fr_FR.pages_search_filters_community,
		"it-IT": it_IT.pages_search_filters_community,
		"ko-KR": ko_KR.pages_search_filters_community,
		"pt-BR": pt_BR.pages_search_filters_community
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_developers,
		"en-AU": en_AU.pages_search_filters_developers,
		"en-GB": en_GB.pages_search_filters_developers,
		"en-US": en_US.pages_search_filters_developers,
		"es-ES": es_ES.pages_search_filters_developers,
		"fr-FR": fr_FR.pages_search_filters_developers,
		"it-IT": it_IT.pages_search_filters_developers,
		"ko-KR": ko_KR.pages_search_filters_developers,
		"pt-BR": pt_BR.pages_search_filters_developers
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_helpCenter,
		"en-AU": en_AU.pages_search_filters_helpCenter,
		"en-GB": en_GB.pages_search_filters_helpCenter,
		"en-US": en_US.pages_search_filters_helpCenter,
		"es-ES": es_ES.pages_search_filters_helpCenter,
		"fr-FR": fr_FR.pages_search_filters_helpCenter,
		"it-IT": it_IT.pages_search_filters_helpCenter,
		"ko-KR": ko_KR.pages_search_filters_helpCenter,
		"pt-BR": pt_BR.pages_search_filters_helpCenter
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_filters_klaviyoHome,
		"en-AU": en_AU.pages_search_filters_klaviyoHome,
		"en-GB": en_GB.pages_search_filters_klaviyoHome,
		"en-US": en_US.pages_search_filters_klaviyoHome,
		"es-ES": es_ES.pages_search_filters_klaviyoHome,
		"fr-FR": fr_FR.pages_search_filters_klaviyoHome,
		"it-IT": it_IT.pages_search_filters_klaviyoHome,
		"ko-KR": ko_KR.pages_search_filters_klaviyoHome,
		"pt-BR": pt_BR.pages_search_filters_klaviyoHome
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_accounts_billing,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_accounts_billing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_analytics,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_analytics,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_analytics,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_analytics,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_analytics,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_analytics,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_analytics,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_analytics,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_analytics
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_audience,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_audience,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_audience,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_audience,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_audience,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_audience,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_audience,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_audience,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_audience
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_cdp,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_cdp,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_cdp,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_cdp,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_cdp,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_cdp,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_cdp,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_cdp,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_cdp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_campaigns,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_campaigns,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_campaigns,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_campaigns,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_campaigns,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_campaigns,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_campaigns,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_campaigns,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_campaigns
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_deliver_compliance,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_deliver_compliance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_email,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_email,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_email,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_email,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_email,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_email,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_email,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_email,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_flows,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_flows,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_flows,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_flows,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_flows,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_flows,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_flows,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_flows,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_flows
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_integrations,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_integrations,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_integrations,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_integrations,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_integrations,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_integrations,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_integrations,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_integrations,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_integrations
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_push_notifications,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_push_notifications
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_reviews,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_reviews,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_reviews,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_reviews,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_reviews,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_reviews,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_reviews,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_reviews,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_reviews
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_sign_up_forms,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_sign_up_forms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_sms,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_sms,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_sms,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_sms,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_sms,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_sms,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_sms,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_sms,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_sms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"en-US": en_US.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_topics_klaviyo_ai,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_topics_klaviyo_ai
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_sitemap_title,
		"en-AU": en_AU.pages_sitemap_title,
		"en-GB": en_GB.pages_sitemap_title,
		"en-US": en_US.pages_sitemap_title,
		"es-ES": es_ES.pages_sitemap_title,
		"fr-FR": fr_FR.pages_sitemap_title,
		"it-IT": it_IT.pages_sitemap_title,
		"ko-KR": ko_KR.pages_sitemap_title,
		"pt-BR": pt_BR.pages_sitemap_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_sitemap_header,
		"en-AU": en_AU.pages_sitemap_header,
		"en-GB": en_GB.pages_sitemap_header,
		"en-US": en_US.pages_sitemap_header,
		"es-ES": es_ES.pages_sitemap_header,
		"fr-FR": fr_FR.pages_sitemap_header,
		"it-IT": it_IT.pages_sitemap_header,
		"ko-KR": ko_KR.pages_sitemap_header,
		"pt-BR": pt_BR.pages_sitemap_header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_archive_author_postsByThisAuthor,
		"en-AU": en_AU.templates_archive_author_postsByThisAuthor,
		"en-GB": en_GB.templates_archive_author_postsByThisAuthor,
		"en-US": en_US.templates_archive_author_postsByThisAuthor,
		"es-ES": es_ES.templates_archive_author_postsByThisAuthor,
		"fr-FR": fr_FR.templates_archive_author_postsByThisAuthor,
		"it-IT": it_IT.templates_archive_author_postsByThisAuthor,
		"ko-KR": ko_KR.templates_archive_author_postsByThisAuthor,
		"pt-BR": pt_BR.templates_archive_author_postsByThisAuthor
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_archive_author_openInANewTab,
		"en-AU": en_AU.templates_archive_author_openInANewTab,
		"en-GB": en_GB.templates_archive_author_openInANewTab,
		"en-US": en_US.templates_archive_author_openInANewTab,
		"es-ES": es_ES.templates_archive_author_openInANewTab,
		"fr-FR": fr_FR.templates_archive_author_openInANewTab,
		"it-IT": it_IT.templates_archive_author_openInANewTab,
		"ko-KR": ko_KR.templates_archive_author_openInANewTab,
		"pt-BR": pt_BR.templates_archive_author_openInANewTab
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_archive_category_featured,
		"en-AU": en_AU.templates_archive_category_featured,
		"en-GB": en_GB.templates_archive_category_featured,
		"en-US": en_US.templates_archive_category_featured,
		"es-ES": es_ES.templates_archive_category_featured,
		"fr-FR": fr_FR.templates_archive_category_featured,
		"it-IT": it_IT.templates_archive_category_featured,
		"ko-KR": ko_KR.templates_archive_category_featured,
		"pt-BR": pt_BR.templates_archive_category_featured
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_archive_category_articles,
		"en-AU": en_AU.templates_archive_category_articles,
		"en-GB": en_GB.templates_archive_category_articles,
		"en-US": en_US.templates_archive_category_articles,
		"es-ES": es_ES.templates_archive_category_articles,
		"fr-FR": fr_FR.templates_archive_category_articles,
		"it-IT": it_IT.templates_archive_category_articles,
		"ko-KR": ko_KR.templates_archive_category_articles,
		"pt-BR": pt_BR.templates_archive_category_articles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_caseStudy_customer,
		"en-AU": en_AU.templates_caseStudy_customer,
		"en-GB": en_GB.templates_caseStudy_customer,
		"en-US": en_US.templates_caseStudy_customer,
		"es-ES": es_ES.templates_caseStudy_customer,
		"fr-FR": fr_FR.templates_caseStudy_customer,
		"it-IT": it_IT.templates_caseStudy_customer,
		"ko-KR": ko_KR.templates_caseStudy_customer,
		"pt-BR": pt_BR.templates_caseStudy_customer
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_caseStudy_industry,
		"en-AU": en_AU.templates_caseStudy_industry,
		"en-GB": en_GB.templates_caseStudy_industry,
		"en-US": en_US.templates_caseStudy_industry,
		"es-ES": es_ES.templates_caseStudy_industry,
		"fr-FR": fr_FR.templates_caseStudy_industry,
		"it-IT": it_IT.templates_caseStudy_industry,
		"ko-KR": ko_KR.templates_caseStudy_industry,
		"pt-BR": pt_BR.templates_caseStudy_industry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.templates_caseStudy_platform,
		"en-AU": en_AU.templates_caseStudy_platform,
		"en-GB": en_GB.templates_caseStudy_platform,
		"en-US": en_US.templates_caseStudy_platform,
		"es-ES": es_ES.templates_caseStudy_platform,
		"fr-FR": fr_FR.templates_caseStudy_platform,
		"it-IT": it_IT.templates_caseStudy_platform,
		"ko-KR": ko_KR.templates_caseStudy_platform,
		"pt-BR": pt_BR.templates_caseStudy_platform
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_article_callout_general,
		"en-AU": en_AU.helpCenter_article_callout_general,
		"en-GB": en_GB.helpCenter_article_callout_general,
		"en-US": en_US.helpCenter_article_callout_general,
		"es-ES": es_ES.helpCenter_article_callout_general,
		"fr-FR": fr_FR.helpCenter_article_callout_general,
		"it-IT": it_IT.helpCenter_article_callout_general,
		"ko-KR": ko_KR.helpCenter_article_callout_general,
		"pt-BR": pt_BR.helpCenter_article_callout_general
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_article_callout_warning,
		"en-AU": en_AU.helpCenter_article_callout_warning,
		"en-GB": en_GB.helpCenter_article_callout_warning,
		"en-US": en_US.helpCenter_article_callout_warning,
		"es-ES": es_ES.helpCenter_article_callout_warning,
		"fr-FR": fr_FR.helpCenter_article_callout_warning,
		"it-IT": it_IT.helpCenter_article_callout_warning,
		"ko-KR": ko_KR.helpCenter_article_callout_warning,
		"pt-BR": pt_BR.helpCenter_article_callout_warning
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_article_callout_requirements,
		"en-AU": en_AU.helpCenter_article_callout_requirements,
		"en-GB": en_GB.helpCenter_article_callout_requirements,
		"en-US": en_US.helpCenter_article_callout_requirements,
		"es-ES": es_ES.helpCenter_article_callout_requirements,
		"fr-FR": fr_FR.helpCenter_article_callout_requirements,
		"it-IT": it_IT.helpCenter_article_callout_requirements,
		"ko-KR": ko_KR.helpCenter_article_callout_requirements,
		"pt-BR": pt_BR.helpCenter_article_callout_requirements
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_siteName,
		"en-AU": en_AU.helpCenter_siteName,
		"en-GB": en_GB.helpCenter_siteName,
		"en-US": en_US.helpCenter_siteName,
		"es-ES": es_ES.helpCenter_siteName,
		"fr-FR": fr_FR.helpCenter_siteName,
		"it-IT": it_IT.helpCenter_siteName,
		"ko-KR": ko_KR.helpCenter_siteName,
		"pt-BR": pt_BR.helpCenter_siteName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_title,
		"en-AU": en_AU.helpCenter_globalHead_title,
		"en-GB": en_GB.helpCenter_globalHead_title,
		"en-US": en_US.helpCenter_globalHead_title,
		"es-ES": es_ES.helpCenter_globalHead_title,
		"fr-FR": fr_FR.helpCenter_globalHead_title,
		"it-IT": it_IT.helpCenter_globalHead_title,
		"ko-KR": ko_KR.helpCenter_globalHead_title,
		"pt-BR": pt_BR.helpCenter_globalHead_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_metaDesc,
		"en-AU": en_AU.helpCenter_globalHead_metaDesc,
		"en-GB": en_GB.helpCenter_globalHead_metaDesc,
		"en-US": en_US.helpCenter_globalHead_metaDesc,
		"es-ES": es_ES.helpCenter_globalHead_metaDesc,
		"fr-FR": fr_FR.helpCenter_globalHead_metaDesc,
		"it-IT": it_IT.helpCenter_globalHead_metaDesc,
		"ko-KR": ko_KR.helpCenter_globalHead_metaDesc,
		"pt-BR": pt_BR.helpCenter_globalHead_metaDesc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_opengraphSiteName,
		"en-AU": en_AU.helpCenter_globalHead_opengraphSiteName,
		"en-GB": en_GB.helpCenter_globalHead_opengraphSiteName,
		"en-US": en_US.helpCenter_globalHead_opengraphSiteName,
		"es-ES": es_ES.helpCenter_globalHead_opengraphSiteName,
		"fr-FR": fr_FR.helpCenter_globalHead_opengraphSiteName,
		"it-IT": it_IT.helpCenter_globalHead_opengraphSiteName,
		"ko-KR": ko_KR.helpCenter_globalHead_opengraphSiteName,
		"pt-BR": pt_BR.helpCenter_globalHead_opengraphSiteName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_account,
		"en-AU": en_AU.helpCenter_globalHead_account,
		"en-GB": en_GB.helpCenter_globalHead_account,
		"en-US": en_US.helpCenter_globalHead_account,
		"es-ES": es_ES.helpCenter_globalHead_account,
		"fr-FR": fr_FR.helpCenter_globalHead_account,
		"it-IT": it_IT.helpCenter_globalHead_account,
		"ko-KR": ko_KR.helpCenter_globalHead_account,
		"pt-BR": pt_BR.helpCenter_globalHead_account
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_article,
		"en-AU": en_AU.helpCenter_globalHead_article,
		"en-GB": en_GB.helpCenter_globalHead_article,
		"en-US": en_US.helpCenter_globalHead_article,
		"es-ES": es_ES.helpCenter_globalHead_article,
		"fr-FR": fr_FR.helpCenter_globalHead_article,
		"it-IT": it_IT.helpCenter_globalHead_article,
		"ko-KR": ko_KR.helpCenter_globalHead_article,
		"pt-BR": pt_BR.helpCenter_globalHead_article
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_category,
		"en-AU": en_AU.helpCenter_globalHead_category,
		"en-GB": en_GB.helpCenter_globalHead_category,
		"en-US": en_US.helpCenter_globalHead_category,
		"es-ES": es_ES.helpCenter_globalHead_category,
		"fr-FR": fr_FR.helpCenter_globalHead_category,
		"it-IT": it_IT.helpCenter_globalHead_category,
		"ko-KR": ko_KR.helpCenter_globalHead_category,
		"pt-BR": pt_BR.helpCenter_globalHead_category
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_section,
		"en-AU": en_AU.helpCenter_globalHead_section,
		"en-GB": en_GB.helpCenter_globalHead_section,
		"en-US": en_US.helpCenter_globalHead_section,
		"es-ES": es_ES.helpCenter_globalHead_section,
		"fr-FR": fr_FR.helpCenter_globalHead_section,
		"it-IT": it_IT.helpCenter_globalHead_section,
		"ko-KR": ko_KR.helpCenter_globalHead_section,
		"pt-BR": pt_BR.helpCenter_globalHead_section
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_globalHead_search,
		"en-AU": en_AU.helpCenter_globalHead_search,
		"en-GB": en_GB.helpCenter_globalHead_search,
		"en-US": en_US.helpCenter_globalHead_search,
		"es-ES": es_ES.helpCenter_globalHead_search,
		"fr-FR": fr_FR.helpCenter_globalHead_search,
		"it-IT": it_IT.helpCenter_globalHead_search,
		"ko-KR": ko_KR.helpCenter_globalHead_search,
		"pt-BR": pt_BR.helpCenter_globalHead_search
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_components_topicsMenu_featuredResources_name,
		"en-AU": en_AU.helpCenter_components_topicsMenu_featuredResources_name,
		"en-GB": en_GB.helpCenter_components_topicsMenu_featuredResources_name,
		"en-US": en_US.helpCenter_components_topicsMenu_featuredResources_name,
		"es-ES": es_ES.helpCenter_components_topicsMenu_featuredResources_name,
		"fr-FR": fr_FR.helpCenter_components_topicsMenu_featuredResources_name,
		"it-IT": it_IT.helpCenter_components_topicsMenu_featuredResources_name,
		"ko-KR": ko_KR.helpCenter_components_topicsMenu_featuredResources_name,
		"pt-BR": pt_BR.helpCenter_components_topicsMenu_featuredResources_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_components_topicsMenu_featuredResources_slug,
		"en-AU": en_AU.helpCenter_components_topicsMenu_featuredResources_slug,
		"en-GB": en_GB.helpCenter_components_topicsMenu_featuredResources_slug,
		"en-US": en_US.helpCenter_components_topicsMenu_featuredResources_slug,
		"es-ES": es_ES.helpCenter_components_topicsMenu_featuredResources_slug,
		"fr-FR": fr_FR.helpCenter_components_topicsMenu_featuredResources_slug,
		"it-IT": it_IT.helpCenter_components_topicsMenu_featuredResources_slug,
		"ko-KR": ko_KR.helpCenter_components_topicsMenu_featuredResources_slug,
		"pt-BR": pt_BR.helpCenter_components_topicsMenu_featuredResources_slug
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_layout_searchHeadline,
		"en-AU": en_AU.helpCenter_layout_searchHeadline,
		"en-GB": en_GB.helpCenter_layout_searchHeadline,
		"en-US": en_US.helpCenter_layout_searchHeadline,
		"es-ES": es_ES.helpCenter_layout_searchHeadline,
		"fr-FR": fr_FR.helpCenter_layout_searchHeadline,
		"it-IT": it_IT.helpCenter_layout_searchHeadline,
		"ko-KR": ko_KR.helpCenter_layout_searchHeadline,
		"pt-BR": pt_BR.helpCenter_layout_searchHeadline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_layout_moreCardHeadline,
		"en-AU": en_AU.helpCenter_layout_moreCardHeadline,
		"en-GB": en_GB.helpCenter_layout_moreCardHeadline,
		"en-US": en_US.helpCenter_layout_moreCardHeadline,
		"es-ES": es_ES.helpCenter_layout_moreCardHeadline,
		"fr-FR": fr_FR.helpCenter_layout_moreCardHeadline,
		"it-IT": it_IT.helpCenter_layout_moreCardHeadline,
		"ko-KR": ko_KR.helpCenter_layout_moreCardHeadline,
		"pt-BR": pt_BR.helpCenter_layout_moreCardHeadline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_pages_404_button_label,
		"en-AU": en_AU.helpCenter_pages_404_button_label,
		"en-GB": en_GB.helpCenter_pages_404_button_label,
		"en-US": en_US.helpCenter_pages_404_button_label,
		"es-ES": es_ES.helpCenter_pages_404_button_label,
		"fr-FR": fr_FR.helpCenter_pages_404_button_label,
		"it-IT": it_IT.helpCenter_pages_404_button_label,
		"ko-KR": ko_KR.helpCenter_pages_404_button_label,
		"pt-BR": pt_BR.helpCenter_pages_404_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_pages_404_button_href,
		"en-AU": en_AU.helpCenter_pages_404_button_href,
		"en-GB": en_GB.helpCenter_pages_404_button_href,
		"en-US": en_US.helpCenter_pages_404_button_href,
		"es-ES": es_ES.helpCenter_pages_404_button_href,
		"fr-FR": fr_FR.helpCenter_pages_404_button_href,
		"it-IT": it_IT.helpCenter_pages_404_button_href,
		"ko-KR": ko_KR.helpCenter_pages_404_button_href,
		"pt-BR": pt_BR.helpCenter_pages_404_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_pages_404_titleText,
		"en-AU": en_AU.helpCenter_pages_404_titleText,
		"en-GB": en_GB.helpCenter_pages_404_titleText,
		"en-US": en_US.helpCenter_pages_404_titleText,
		"es-ES": es_ES.helpCenter_pages_404_titleText,
		"fr-FR": fr_FR.helpCenter_pages_404_titleText,
		"it-IT": it_IT.helpCenter_pages_404_titleText,
		"ko-KR": ko_KR.helpCenter_pages_404_titleText,
		"pt-BR": pt_BR.helpCenter_pages_404_titleText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_home_featuredResources_headline,
		"en-AU": en_AU.helpCenter_templates_home_featuredResources_headline,
		"en-GB": en_GB.helpCenter_templates_home_featuredResources_headline,
		"en-US": en_US.helpCenter_templates_home_featuredResources_headline,
		"es-ES": es_ES.helpCenter_templates_home_featuredResources_headline,
		"fr-FR": fr_FR.helpCenter_templates_home_featuredResources_headline,
		"it-IT": it_IT.helpCenter_templates_home_featuredResources_headline,
		"ko-KR": ko_KR.helpCenter_templates_home_featuredResources_headline,
		"pt-BR": pt_BR.helpCenter_templates_home_featuredResources_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_home_featuredResources_subhead,
		"en-AU": en_AU.helpCenter_templates_home_featuredResources_subhead,
		"en-GB": en_GB.helpCenter_templates_home_featuredResources_subhead,
		"en-US": en_US.helpCenter_templates_home_featuredResources_subhead,
		"es-ES": es_ES.helpCenter_templates_home_featuredResources_subhead,
		"fr-FR": fr_FR.helpCenter_templates_home_featuredResources_subhead,
		"it-IT": it_IT.helpCenter_templates_home_featuredResources_subhead,
		"ko-KR": ko_KR.helpCenter_templates_home_featuredResources_subhead,
		"pt-BR": pt_BR.helpCenter_templates_home_featuredResources_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_home_twoColumnL20R80_headline,
		"en-AU": en_AU.helpCenter_templates_home_twoColumnL20R80_headline,
		"en-GB": en_GB.helpCenter_templates_home_twoColumnL20R80_headline,
		"en-US": en_US.helpCenter_templates_home_twoColumnL20R80_headline,
		"es-ES": es_ES.helpCenter_templates_home_twoColumnL20R80_headline,
		"fr-FR": fr_FR.helpCenter_templates_home_twoColumnL20R80_headline,
		"it-IT": it_IT.helpCenter_templates_home_twoColumnL20R80_headline,
		"ko-KR": ko_KR.helpCenter_templates_home_twoColumnL20R80_headline,
		"pt-BR": pt_BR.helpCenter_templates_home_twoColumnL20R80_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_home_twoColumnL30R70_headline,
		"en-AU": en_AU.helpCenter_templates_home_twoColumnL30R70_headline,
		"en-GB": en_GB.helpCenter_templates_home_twoColumnL30R70_headline,
		"en-US": en_US.helpCenter_templates_home_twoColumnL30R70_headline,
		"es-ES": es_ES.helpCenter_templates_home_twoColumnL30R70_headline,
		"fr-FR": fr_FR.helpCenter_templates_home_twoColumnL30R70_headline,
		"it-IT": it_IT.helpCenter_templates_home_twoColumnL30R70_headline,
		"ko-KR": ko_KR.helpCenter_templates_home_twoColumnL30R70_headline,
		"pt-BR": pt_BR.helpCenter_templates_home_twoColumnL30R70_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_category_topArticles,
		"en-AU": en_AU.helpCenter_templates_category_topArticles,
		"en-GB": en_GB.helpCenter_templates_category_topArticles,
		"en-US": en_US.helpCenter_templates_category_topArticles,
		"es-ES": es_ES.helpCenter_templates_category_topArticles,
		"fr-FR": fr_FR.helpCenter_templates_category_topArticles,
		"it-IT": it_IT.helpCenter_templates_category_topArticles,
		"ko-KR": ko_KR.helpCenter_templates_category_topArticles,
		"pt-BR": pt_BR.helpCenter_templates_category_topArticles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_noResults_noResultsWrapperText,
		"en-AU": en_AU.helpCenter_templates_search_noResults_noResultsWrapperText,
		"en-GB": en_GB.helpCenter_templates_search_noResults_noResultsWrapperText,
		"en-US": en_US.helpCenter_templates_search_noResults_noResultsWrapperText,
		"es-ES": es_ES.helpCenter_templates_search_noResults_noResultsWrapperText,
		"fr-FR": fr_FR.helpCenter_templates_search_noResults_noResultsWrapperText,
		"it-IT": it_IT.helpCenter_templates_search_noResults_noResultsWrapperText,
		"ko-KR": ko_KR.helpCenter_templates_search_noResults_noResultsWrapperText,
		"pt-BR": pt_BR.helpCenter_templates_search_noResults_noResultsWrapperText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"en-AU": en_AU.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"en-GB": en_GB.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"en-US": en_US.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"es-ES": es_ES.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"fr-FR": fr_FR.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"it-IT": it_IT.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"ko-KR": ko_KR.helpCenter_templates_search_noResults_noResultsWrapperSuggestion,
		"pt-BR": pt_BR.helpCenter_templates_search_noResults_noResultsWrapperSuggestion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"en-AU": en_AU.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"en-GB": en_GB.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"en-US": en_US.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"es-ES": es_ES.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"fr-FR": fr_FR.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"it-IT": it_IT.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"ko-KR": ko_KR.helpCenter_templates_search_noResults_noResultsInstantSearch,
		"pt-BR": pt_BR.helpCenter_templates_search_noResults_noResultsInstantSearch
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_helpCenter_headline,
		"en-AU": en_AU.helpCenter_templates_search_searchData_helpCenter_headline,
		"en-GB": en_GB.helpCenter_templates_search_searchData_helpCenter_headline,
		"en-US": en_US.helpCenter_templates_search_searchData_helpCenter_headline,
		"es-ES": es_ES.helpCenter_templates_search_searchData_helpCenter_headline,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_helpCenter_headline,
		"it-IT": it_IT.helpCenter_templates_search_searchData_helpCenter_headline,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_helpCenter_headline,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_helpCenter_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_community_headline,
		"en-AU": en_AU.helpCenter_templates_search_searchData_community_headline,
		"en-GB": en_GB.helpCenter_templates_search_searchData_community_headline,
		"en-US": en_US.helpCenter_templates_search_searchData_community_headline,
		"es-ES": es_ES.helpCenter_templates_search_searchData_community_headline,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_community_headline,
		"it-IT": it_IT.helpCenter_templates_search_searchData_community_headline,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_community_headline,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_community_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_developers_headline,
		"en-AU": en_AU.helpCenter_templates_search_searchData_developers_headline,
		"en-GB": en_GB.helpCenter_templates_search_searchData_developers_headline,
		"en-US": en_US.helpCenter_templates_search_searchData_developers_headline,
		"es-ES": es_ES.helpCenter_templates_search_searchData_developers_headline,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_developers_headline,
		"it-IT": it_IT.helpCenter_templates_search_searchData_developers_headline,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_developers_headline,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_developers_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_academy_headline,
		"en-AU": en_AU.helpCenter_templates_search_searchData_academy_headline,
		"en-GB": en_GB.helpCenter_templates_search_searchData_academy_headline,
		"en-US": en_US.helpCenter_templates_search_searchData_academy_headline,
		"es-ES": es_ES.helpCenter_templates_search_searchData_academy_headline,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_academy_headline,
		"it-IT": it_IT.helpCenter_templates_search_searchData_academy_headline,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_academy_headline,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_academy_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_marketing_headline,
		"en-AU": en_AU.helpCenter_templates_search_searchData_marketing_headline,
		"en-GB": en_GB.helpCenter_templates_search_searchData_marketing_headline,
		"en-US": en_US.helpCenter_templates_search_searchData_marketing_headline,
		"es-ES": es_ES.helpCenter_templates_search_searchData_marketing_headline,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_marketing_headline,
		"it-IT": it_IT.helpCenter_templates_search_searchData_marketing_headline,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_marketing_headline,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_marketing_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_searchData_viewAll,
		"en-AU": en_AU.helpCenter_templates_search_searchData_viewAll,
		"en-GB": en_GB.helpCenter_templates_search_searchData_viewAll,
		"en-US": en_US.helpCenter_templates_search_searchData_viewAll,
		"es-ES": es_ES.helpCenter_templates_search_searchData_viewAll,
		"fr-FR": fr_FR.helpCenter_templates_search_searchData_viewAll,
		"it-IT": it_IT.helpCenter_templates_search_searchData_viewAll,
		"ko-KR": ko_KR.helpCenter_templates_search_searchData_viewAll,
		"pt-BR": pt_BR.helpCenter_templates_search_searchData_viewAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_title,
		"en-AU": en_AU.academy_globalHead_title,
		"en-GB": en_GB.academy_globalHead_title,
		"en-US": en_US.academy_globalHead_title,
		"es-ES": es_ES.academy_globalHead_title,
		"fr-FR": fr_FR.academy_globalHead_title,
		"it-IT": it_IT.academy_globalHead_title,
		"ko-KR": ko_KR.academy_globalHead_title,
		"pt-BR": pt_BR.academy_globalHead_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_opengraphSiteName,
		"en-AU": en_AU.academy_globalHead_opengraphSiteName,
		"en-GB": en_GB.academy_globalHead_opengraphSiteName,
		"en-US": en_US.academy_globalHead_opengraphSiteName,
		"es-ES": es_ES.academy_globalHead_opengraphSiteName,
		"fr-FR": fr_FR.academy_globalHead_opengraphSiteName,
		"it-IT": it_IT.academy_globalHead_opengraphSiteName,
		"ko-KR": ko_KR.academy_globalHead_opengraphSiteName,
		"pt-BR": pt_BR.academy_globalHead_opengraphSiteName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_metaDesc,
		"en-AU": en_AU.academy_globalHead_metaDesc,
		"en-GB": en_GB.academy_globalHead_metaDesc,
		"en-US": en_US.academy_globalHead_metaDesc,
		"es-ES": es_ES.academy_globalHead_metaDesc,
		"fr-FR": fr_FR.academy_globalHead_metaDesc,
		"it-IT": it_IT.academy_globalHead_metaDesc,
		"ko-KR": ko_KR.academy_globalHead_metaDesc,
		"pt-BR": pt_BR.academy_globalHead_metaDesc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_bestPractices,
		"en-AU": en_AU.academy_globalHead_bestPractices,
		"en-GB": en_GB.academy_globalHead_bestPractices,
		"en-US": en_US.academy_globalHead_bestPractices,
		"es-ES": es_ES.academy_globalHead_bestPractices,
		"fr-FR": fr_FR.academy_globalHead_bestPractices,
		"it-IT": it_IT.academy_globalHead_bestPractices,
		"ko-KR": ko_KR.academy_globalHead_bestPractices,
		"pt-BR": pt_BR.academy_globalHead_bestPractices
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_collection,
		"en-AU": en_AU.academy_globalHead_collection,
		"en-GB": en_GB.academy_globalHead_collection,
		"en-US": en_US.academy_globalHead_collection,
		"es-ES": es_ES.academy_globalHead_collection,
		"fr-FR": fr_FR.academy_globalHead_collection,
		"it-IT": it_IT.academy_globalHead_collection,
		"ko-KR": ko_KR.academy_globalHead_collection,
		"pt-BR": pt_BR.academy_globalHead_collection
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_course,
		"en-AU": en_AU.academy_globalHead_course,
		"en-GB": en_GB.academy_globalHead_course,
		"en-US": en_US.academy_globalHead_course,
		"es-ES": es_ES.academy_globalHead_course,
		"fr-FR": fr_FR.academy_globalHead_course,
		"it-IT": it_IT.academy_globalHead_course,
		"ko-KR": ko_KR.academy_globalHead_course,
		"pt-BR": pt_BR.academy_globalHead_course
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_lesson,
		"en-AU": en_AU.academy_globalHead_lesson,
		"en-GB": en_GB.academy_globalHead_lesson,
		"en-US": en_US.academy_globalHead_lesson,
		"es-ES": es_ES.academy_globalHead_lesson,
		"fr-FR": fr_FR.academy_globalHead_lesson,
		"it-IT": it_IT.academy_globalHead_lesson,
		"ko-KR": ko_KR.academy_globalHead_lesson,
		"pt-BR": pt_BR.academy_globalHead_lesson
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_globalHead_search,
		"en-AU": en_AU.academy_globalHead_search,
		"en-GB": en_GB.academy_globalHead_search,
		"en-US": en_US.academy_globalHead_search,
		"es-ES": es_ES.academy_globalHead_search,
		"fr-FR": fr_FR.academy_globalHead_search,
		"it-IT": it_IT.academy_globalHead_search,
		"ko-KR": ko_KR.academy_globalHead_search,
		"pt-BR": pt_BR.academy_globalHead_search
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_registered,
		"en-AU": en_AU.academy_courseStatus_registered,
		"en-GB": en_GB.academy_courseStatus_registered,
		"en-US": en_US.academy_courseStatus_registered,
		"es-ES": es_ES.academy_courseStatus_registered,
		"fr-FR": fr_FR.academy_courseStatus_registered,
		"it-IT": it_IT.academy_courseStatus_registered,
		"ko-KR": ko_KR.academy_courseStatus_registered,
		"pt-BR": pt_BR.academy_courseStatus_registered
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_completed,
		"en-AU": en_AU.academy_courseStatus_completed,
		"en-GB": en_GB.academy_courseStatus_completed,
		"en-US": en_US.academy_courseStatus_completed,
		"es-ES": es_ES.academy_courseStatus_completed,
		"fr-FR": fr_FR.academy_courseStatus_completed,
		"it-IT": it_IT.academy_courseStatus_completed,
		"ko-KR": ko_KR.academy_courseStatus_completed,
		"pt-BR": pt_BR.academy_courseStatus_completed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_viewed,
		"en-AU": en_AU.academy_courseStatus_viewed,
		"en-GB": en_GB.academy_courseStatus_viewed,
		"en-US": en_US.academy_courseStatus_viewed,
		"es-ES": es_ES.academy_courseStatus_viewed,
		"fr-FR": fr_FR.academy_courseStatus_viewed,
		"it-IT": it_IT.academy_courseStatus_viewed,
		"ko-KR": ko_KR.academy_courseStatus_viewed,
		"pt-BR": pt_BR.academy_courseStatus_viewed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_inProgress_startingText,
		"en-AU": en_AU.academy_courseStatus_inProgress_startingText,
		"en-GB": en_GB.academy_courseStatus_inProgress_startingText,
		"en-US": en_US.academy_courseStatus_inProgress_startingText,
		"es-ES": es_ES.academy_courseStatus_inProgress_startingText,
		"fr-FR": fr_FR.academy_courseStatus_inProgress_startingText,
		"it-IT": it_IT.academy_courseStatus_inProgress_startingText,
		"ko-KR": ko_KR.academy_courseStatus_inProgress_startingText,
		"pt-BR": pt_BR.academy_courseStatus_inProgress_startingText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_inProgress_endingText,
		"en-AU": en_AU.academy_courseStatus_inProgress_endingText,
		"en-GB": en_GB.academy_courseStatus_inProgress_endingText,
		"en-US": en_US.academy_courseStatus_inProgress_endingText,
		"es-ES": es_ES.academy_courseStatus_inProgress_endingText,
		"fr-FR": fr_FR.academy_courseStatus_inProgress_endingText,
		"it-IT": it_IT.academy_courseStatus_inProgress_endingText,
		"ko-KR": ko_KR.academy_courseStatus_inProgress_endingText,
		"pt-BR": pt_BR.academy_courseStatus_inProgress_endingText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_404_button_label,
		"en-AU": en_AU.academy_pages_404_button_label,
		"en-GB": en_GB.academy_pages_404_button_label,
		"en-US": en_US.academy_pages_404_button_label,
		"es-ES": es_ES.academy_pages_404_button_label,
		"fr-FR": fr_FR.academy_pages_404_button_label,
		"it-IT": it_IT.academy_pages_404_button_label,
		"ko-KR": ko_KR.academy_pages_404_button_label,
		"pt-BR": pt_BR.academy_pages_404_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_404_button_href,
		"en-AU": en_AU.academy_pages_404_button_href,
		"en-GB": en_GB.academy_pages_404_button_href,
		"en-US": en_US.academy_pages_404_button_href,
		"es-ES": es_ES.academy_pages_404_button_href,
		"fr-FR": fr_FR.academy_pages_404_button_href,
		"it-IT": it_IT.academy_pages_404_button_href,
		"ko-KR": ko_KR.academy_pages_404_button_href,
		"pt-BR": pt_BR.academy_pages_404_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_404_titleText,
		"en-AU": en_AU.academy_pages_404_titleText,
		"en-GB": en_GB.academy_pages_404_titleText,
		"en-US": en_US.academy_pages_404_titleText,
		"es-ES": es_ES.academy_pages_404_titleText,
		"fr-FR": fr_FR.academy_pages_404_titleText,
		"it-IT": it_IT.academy_pages_404_titleText,
		"ko-KR": ko_KR.academy_pages_404_titleText,
		"pt-BR": pt_BR.academy_pages_404_titleText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_hero_headline,
		"en-AU": en_AU.academy_pages_home_hero_headline,
		"en-GB": en_GB.academy_pages_home_hero_headline,
		"en-US": en_US.academy_pages_home_hero_headline,
		"es-ES": es_ES.academy_pages_home_hero_headline,
		"fr-FR": fr_FR.academy_pages_home_hero_headline,
		"it-IT": it_IT.academy_pages_home_hero_headline,
		"ko-KR": ko_KR.academy_pages_home_hero_headline,
		"pt-BR": pt_BR.academy_pages_home_hero_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_hero_subhead,
		"en-AU": en_AU.academy_pages_home_hero_subhead,
		"en-GB": en_GB.academy_pages_home_hero_subhead,
		"en-US": en_US.academy_pages_home_hero_subhead,
		"es-ES": es_ES.academy_pages_home_hero_subhead,
		"fr-FR": fr_FR.academy_pages_home_hero_subhead,
		"it-IT": it_IT.academy_pages_home_hero_subhead,
		"ko-KR": ko_KR.academy_pages_home_hero_subhead,
		"pt-BR": pt_BR.academy_pages_home_hero_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_hero_button_label,
		"en-AU": en_AU.academy_pages_home_hero_button_label,
		"en-GB": en_GB.academy_pages_home_hero_button_label,
		"en-US": en_US.academy_pages_home_hero_button_label,
		"es-ES": es_ES.academy_pages_home_hero_button_label,
		"fr-FR": fr_FR.academy_pages_home_hero_button_label,
		"it-IT": it_IT.academy_pages_home_hero_button_label,
		"ko-KR": ko_KR.academy_pages_home_hero_button_label,
		"pt-BR": pt_BR.academy_pages_home_hero_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_hero_button_href,
		"en-AU": en_AU.academy_pages_home_hero_button_href,
		"en-GB": en_GB.academy_pages_home_hero_button_href,
		"en-US": en_US.academy_pages_home_hero_button_href,
		"es-ES": es_ES.academy_pages_home_hero_button_href,
		"fr-FR": fr_FR.academy_pages_home_hero_button_href,
		"it-IT": it_IT.academy_pages_home_hero_button_href,
		"ko-KR": ko_KR.academy_pages_home_hero_button_href,
		"pt-BR": pt_BR.academy_pages_home_hero_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_headline,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_headline,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_headline,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_headline,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_headline,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_headline,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_headline,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_headline,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_subhead,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_subhead,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_subhead,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_subhead,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_subhead,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_subhead,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_subhead,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_subhead,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_first_title,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_first_title,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_first_title,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_first_title,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_first_title,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_first_title,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_first_title,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_first_title,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_first_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_first_excerpt,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_first_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_first_button_label,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_first_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_first_button_href,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_first_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_second_title,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_second_title,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_second_title,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_second_title,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_second_title,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_second_title,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_second_title,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_second_title,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_second_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_second_excerpt,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_second_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_second_button_label,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_second_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_second_button_href,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_second_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_third_title,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_third_title,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_third_title,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_third_title,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_third_title,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_third_title,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_third_title,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_third_title,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_third_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_third_excerpt,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_third_excerpt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_third_button_label,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_third_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"en-AU": en_AU.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"en-GB": en_GB.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"en-US": en_US.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"es-ES": es_ES.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"fr-FR": fr_FR.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"it-IT": it_IT.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"ko-KR": ko_KR.academy_pages_home_newAndNoteworthy_cards_third_button_href,
		"pt-BR": pt_BR.academy_pages_home_newAndNoteworthy_cards_third_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_headline,
		"en-AU": en_AU.academy_pages_home_learn_headline,
		"en-GB": en_GB.academy_pages_home_learn_headline,
		"en-US": en_US.academy_pages_home_learn_headline,
		"es-ES": es_ES.academy_pages_home_learn_headline,
		"fr-FR": fr_FR.academy_pages_home_learn_headline,
		"it-IT": it_IT.academy_pages_home_learn_headline,
		"ko-KR": ko_KR.academy_pages_home_learn_headline,
		"pt-BR": pt_BR.academy_pages_home_learn_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_subhead,
		"en-AU": en_AU.academy_pages_home_learn_subhead,
		"en-GB": en_GB.academy_pages_home_learn_subhead,
		"en-US": en_US.academy_pages_home_learn_subhead,
		"es-ES": es_ES.academy_pages_home_learn_subhead,
		"fr-FR": fr_FR.academy_pages_home_learn_subhead,
		"it-IT": it_IT.academy_pages_home_learn_subhead,
		"ko-KR": ko_KR.academy_pages_home_learn_subhead,
		"pt-BR": pt_BR.academy_pages_home_learn_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row1_title,
		"en-AU": en_AU.academy_pages_home_learn_row1_title,
		"en-GB": en_GB.academy_pages_home_learn_row1_title,
		"en-US": en_US.academy_pages_home_learn_row1_title,
		"es-ES": es_ES.academy_pages_home_learn_row1_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row1_title,
		"it-IT": it_IT.academy_pages_home_learn_row1_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row1_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row1_content,
		"en-AU": en_AU.academy_pages_home_learn_row1_content,
		"en-GB": en_GB.academy_pages_home_learn_row1_content,
		"en-US": en_US.academy_pages_home_learn_row1_content,
		"es-ES": es_ES.academy_pages_home_learn_row1_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row1_content,
		"it-IT": it_IT.academy_pages_home_learn_row1_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row1_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row1_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row1_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row1_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row1_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row1_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row1_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row1_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row1_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row1_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row1_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row1_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row1_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row1_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row1_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row1_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row1_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row1_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row1_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row1_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row2_title,
		"en-AU": en_AU.academy_pages_home_learn_row2_title,
		"en-GB": en_GB.academy_pages_home_learn_row2_title,
		"en-US": en_US.academy_pages_home_learn_row2_title,
		"es-ES": es_ES.academy_pages_home_learn_row2_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row2_title,
		"it-IT": it_IT.academy_pages_home_learn_row2_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row2_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row2_content,
		"en-AU": en_AU.academy_pages_home_learn_row2_content,
		"en-GB": en_GB.academy_pages_home_learn_row2_content,
		"en-US": en_US.academy_pages_home_learn_row2_content,
		"es-ES": es_ES.academy_pages_home_learn_row2_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row2_content,
		"it-IT": it_IT.academy_pages_home_learn_row2_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row2_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row2_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row2_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row2_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row2_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row2_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row2_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row2_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row2_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row2_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row2_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row2_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row2_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row2_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row2_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row2_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row2_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row2_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row2_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row2_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row3_title,
		"en-AU": en_AU.academy_pages_home_learn_row3_title,
		"en-GB": en_GB.academy_pages_home_learn_row3_title,
		"en-US": en_US.academy_pages_home_learn_row3_title,
		"es-ES": es_ES.academy_pages_home_learn_row3_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row3_title,
		"it-IT": it_IT.academy_pages_home_learn_row3_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row3_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row3_content,
		"en-AU": en_AU.academy_pages_home_learn_row3_content,
		"en-GB": en_GB.academy_pages_home_learn_row3_content,
		"en-US": en_US.academy_pages_home_learn_row3_content,
		"es-ES": es_ES.academy_pages_home_learn_row3_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row3_content,
		"it-IT": it_IT.academy_pages_home_learn_row3_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row3_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row3_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row3_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row3_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row3_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row3_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row3_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row3_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row3_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row3_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row3_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row3_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row3_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row3_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row3_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row3_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row3_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row3_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row3_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row3_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row4_title,
		"en-AU": en_AU.academy_pages_home_learn_row4_title,
		"en-GB": en_GB.academy_pages_home_learn_row4_title,
		"en-US": en_US.academy_pages_home_learn_row4_title,
		"es-ES": es_ES.academy_pages_home_learn_row4_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row4_title,
		"it-IT": it_IT.academy_pages_home_learn_row4_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row4_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row4_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row4_content,
		"en-AU": en_AU.academy_pages_home_learn_row4_content,
		"en-GB": en_GB.academy_pages_home_learn_row4_content,
		"en-US": en_US.academy_pages_home_learn_row4_content,
		"es-ES": es_ES.academy_pages_home_learn_row4_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row4_content,
		"it-IT": it_IT.academy_pages_home_learn_row4_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row4_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row4_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row4_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row4_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row4_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row4_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row4_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row4_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row4_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row4_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row4_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row4_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row4_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row4_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row4_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row4_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row4_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row4_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row4_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row4_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row5_title,
		"en-AU": en_AU.academy_pages_home_learn_row5_title,
		"en-GB": en_GB.academy_pages_home_learn_row5_title,
		"en-US": en_US.academy_pages_home_learn_row5_title,
		"es-ES": es_ES.academy_pages_home_learn_row5_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row5_title,
		"it-IT": it_IT.academy_pages_home_learn_row5_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row5_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row5_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row5_content,
		"en-AU": en_AU.academy_pages_home_learn_row5_content,
		"en-GB": en_GB.academy_pages_home_learn_row5_content,
		"en-US": en_US.academy_pages_home_learn_row5_content,
		"es-ES": es_ES.academy_pages_home_learn_row5_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row5_content,
		"it-IT": it_IT.academy_pages_home_learn_row5_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row5_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row5_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row5_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row5_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row5_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row5_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row5_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row5_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row5_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row5_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row5_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row5_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row5_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row5_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row5_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row5_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row5_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row5_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row5_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row5_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row6_title,
		"en-AU": en_AU.academy_pages_home_learn_row6_title,
		"en-GB": en_GB.academy_pages_home_learn_row6_title,
		"en-US": en_US.academy_pages_home_learn_row6_title,
		"es-ES": es_ES.academy_pages_home_learn_row6_title,
		"fr-FR": fr_FR.academy_pages_home_learn_row6_title,
		"it-IT": it_IT.academy_pages_home_learn_row6_title,
		"ko-KR": ko_KR.academy_pages_home_learn_row6_title,
		"pt-BR": pt_BR.academy_pages_home_learn_row6_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row6_content,
		"en-AU": en_AU.academy_pages_home_learn_row6_content,
		"en-GB": en_GB.academy_pages_home_learn_row6_content,
		"en-US": en_US.academy_pages_home_learn_row6_content,
		"es-ES": es_ES.academy_pages_home_learn_row6_content,
		"fr-FR": fr_FR.academy_pages_home_learn_row6_content,
		"it-IT": it_IT.academy_pages_home_learn_row6_content,
		"ko-KR": ko_KR.academy_pages_home_learn_row6_content,
		"pt-BR": pt_BR.academy_pages_home_learn_row6_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row6_buttons_label,
		"en-AU": en_AU.academy_pages_home_learn_row6_buttons_label,
		"en-GB": en_GB.academy_pages_home_learn_row6_buttons_label,
		"en-US": en_US.academy_pages_home_learn_row6_buttons_label,
		"es-ES": es_ES.academy_pages_home_learn_row6_buttons_label,
		"fr-FR": fr_FR.academy_pages_home_learn_row6_buttons_label,
		"it-IT": it_IT.academy_pages_home_learn_row6_buttons_label,
		"ko-KR": ko_KR.academy_pages_home_learn_row6_buttons_label,
		"pt-BR": pt_BR.academy_pages_home_learn_row6_buttons_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_learn_row6_buttons_href,
		"en-AU": en_AU.academy_pages_home_learn_row6_buttons_href,
		"en-GB": en_GB.academy_pages_home_learn_row6_buttons_href,
		"en-US": en_US.academy_pages_home_learn_row6_buttons_href,
		"es-ES": es_ES.academy_pages_home_learn_row6_buttons_href,
		"fr-FR": fr_FR.academy_pages_home_learn_row6_buttons_href,
		"it-IT": it_IT.academy_pages_home_learn_row6_buttons_href,
		"ko-KR": ko_KR.academy_pages_home_learn_row6_buttons_href,
		"pt-BR": pt_BR.academy_pages_home_learn_row6_buttons_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedIn_title,
		"en-AU": en_AU.academy_pages_home_start_loggedIn_title,
		"en-GB": en_GB.academy_pages_home_start_loggedIn_title,
		"en-US": en_US.academy_pages_home_start_loggedIn_title,
		"es-ES": es_ES.academy_pages_home_start_loggedIn_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedIn_title,
		"it-IT": it_IT.academy_pages_home_start_loggedIn_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedIn_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedIn_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedIn_button_label,
		"en-AU": en_AU.academy_pages_home_start_loggedIn_button_label,
		"en-GB": en_GB.academy_pages_home_start_loggedIn_button_label,
		"en-US": en_US.academy_pages_home_start_loggedIn_button_label,
		"es-ES": es_ES.academy_pages_home_start_loggedIn_button_label,
		"fr-FR": fr_FR.academy_pages_home_start_loggedIn_button_label,
		"it-IT": it_IT.academy_pages_home_start_loggedIn_button_label,
		"ko-KR": ko_KR.academy_pages_home_start_loggedIn_button_label,
		"pt-BR": pt_BR.academy_pages_home_start_loggedIn_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedIn_button_href,
		"en-AU": en_AU.academy_pages_home_start_loggedIn_button_href,
		"en-GB": en_GB.academy_pages_home_start_loggedIn_button_href,
		"en-US": en_US.academy_pages_home_start_loggedIn_button_href,
		"es-ES": es_ES.academy_pages_home_start_loggedIn_button_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedIn_button_href,
		"it-IT": it_IT.academy_pages_home_start_loggedIn_button_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedIn_button_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedIn_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedIn_coursePath,
		"en-AU": en_AU.academy_pages_home_start_loggedIn_coursePath,
		"en-GB": en_GB.academy_pages_home_start_loggedIn_coursePath,
		"en-US": en_US.academy_pages_home_start_loggedIn_coursePath,
		"es-ES": es_ES.academy_pages_home_start_loggedIn_coursePath,
		"fr-FR": fr_FR.academy_pages_home_start_loggedIn_coursePath,
		"it-IT": it_IT.academy_pages_home_start_loggedIn_coursePath,
		"ko-KR": ko_KR.academy_pages_home_start_loggedIn_coursePath,
		"pt-BR": pt_BR.academy_pages_home_start_loggedIn_coursePath
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedIn_collectionPath,
		"en-AU": en_AU.academy_pages_home_start_loggedIn_collectionPath,
		"en-GB": en_GB.academy_pages_home_start_loggedIn_collectionPath,
		"en-US": en_US.academy_pages_home_start_loggedIn_collectionPath,
		"es-ES": es_ES.academy_pages_home_start_loggedIn_collectionPath,
		"fr-FR": fr_FR.academy_pages_home_start_loggedIn_collectionPath,
		"it-IT": it_IT.academy_pages_home_start_loggedIn_collectionPath,
		"ko-KR": ko_KR.academy_pages_home_start_loggedIn_collectionPath,
		"pt-BR": pt_BR.academy_pages_home_start_loggedIn_collectionPath
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_title,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_title,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_title,
		"en-US": en_US.academy_pages_home_start_loggedOut_title,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_title,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_button_label,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_button_label,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_button_label,
		"en-US": en_US.academy_pages_home_start_loggedOut_button_label,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_button_label,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_button_label,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_button_label,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_button_label,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_button_href,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_button_href,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_button_href,
		"en-US": en_US.academy_pages_home_start_loggedOut_button_href,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_button_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_button_href,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_button_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_button_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_description,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_description,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_description,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_description,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_description,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_description,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_description,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_description,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_divider = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_divider,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_divider,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_divider,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_divider,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_divider,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_divider,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_divider,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_divider,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_divider
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_href,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_href,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_href,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_href,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_href,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_metadata,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_metadata,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_metadata,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_metadata,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_metadata,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_metadata,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_metadata,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_metadata,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_pill,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_pill,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_pill,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_pill,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_pill,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_pill,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_pill,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_pill,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start1_title,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start1_title,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start1_title,
		"en-US": en_US.academy_pages_home_start_loggedOut_start1_title,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start1_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start1_title,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start1_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start1_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_description,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_description,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_description,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_description,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_description,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_description,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_description,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_description,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_divider = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_divider,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_divider,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_divider,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_divider,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_divider,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_divider,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_divider,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_divider,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_divider
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_href,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_href,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_href,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_href,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_href,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_metadata,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_metadata,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_metadata,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_metadata,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_metadata,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_metadata,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_metadata,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_metadata,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_pill,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_pill,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_pill,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_pill,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_pill,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_pill,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_pill,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_pill,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start2_title,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start2_title,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start2_title,
		"en-US": en_US.academy_pages_home_start_loggedOut_start2_title,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start2_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start2_title,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start2_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start2_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_description,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_description,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_description,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_description,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_description,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_description,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_description,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_description,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_divider = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_divider,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_divider,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_divider,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_divider,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_divider,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_divider,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_divider,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_divider,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_divider
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_href,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_href,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_href,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_href,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_href,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_metadata,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_metadata,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_metadata,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_metadata,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_metadata,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_metadata,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_metadata,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_metadata,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_pill,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_pill,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_pill,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_pill,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_pill,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_pill,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_pill,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_pill,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start3_title,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start3_title,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start3_title,
		"en-US": en_US.academy_pages_home_start_loggedOut_start3_title,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start3_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start3_title,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start3_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start3_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_description,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_description,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_description,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_description,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_description,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_description,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_description,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_description,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_divider = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_divider,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_divider,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_divider,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_divider,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_divider,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_divider,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_divider,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_divider,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_divider
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_href,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_href,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_href,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_href,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_href,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_href,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_href,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_href,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_metadata,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_metadata,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_metadata,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_metadata,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_metadata,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_metadata,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_metadata,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_metadata,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_pill,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_pill,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_pill,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_pill,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_pill,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_pill,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_pill,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_pill,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_start_loggedOut_start4_title,
		"en-AU": en_AU.academy_pages_home_start_loggedOut_start4_title,
		"en-GB": en_GB.academy_pages_home_start_loggedOut_start4_title,
		"en-US": en_US.academy_pages_home_start_loggedOut_start4_title,
		"es-ES": es_ES.academy_pages_home_start_loggedOut_start4_title,
		"fr-FR": fr_FR.academy_pages_home_start_loggedOut_start4_title,
		"it-IT": it_IT.academy_pages_home_start_loggedOut_start4_title,
		"ko-KR": ko_KR.academy_pages_home_start_loggedOut_start4_title,
		"pt-BR": pt_BR.academy_pages_home_start_loggedOut_start4_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_title,
		"en-AU": en_AU.academy_pages_home_liveTraining_title,
		"en-GB": en_GB.academy_pages_home_liveTraining_title,
		"en-US": en_US.academy_pages_home_liveTraining_title,
		"es-ES": es_ES.academy_pages_home_liveTraining_title,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_title,
		"it-IT": it_IT.academy_pages_home_liveTraining_title,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_title,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_subhead,
		"en-AU": en_AU.academy_pages_home_liveTraining_subhead,
		"en-GB": en_GB.academy_pages_home_liveTraining_subhead,
		"en-US": en_US.academy_pages_home_liveTraining_subhead,
		"es-ES": es_ES.academy_pages_home_liveTraining_subhead,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_subhead,
		"it-IT": it_IT.academy_pages_home_liveTraining_subhead,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_subhead,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_button_label,
		"en-AU": en_AU.academy_pages_home_liveTraining_button_label,
		"en-GB": en_GB.academy_pages_home_liveTraining_button_label,
		"en-US": en_US.academy_pages_home_liveTraining_button_label,
		"es-ES": es_ES.academy_pages_home_liveTraining_button_label,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_button_label,
		"it-IT": it_IT.academy_pages_home_liveTraining_button_label,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_button_label,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_button_href,
		"en-AU": en_AU.academy_pages_home_liveTraining_button_href,
		"en-GB": en_GB.academy_pages_home_liveTraining_button_href,
		"en-US": en_US.academy_pages_home_liveTraining_button_href,
		"es-ES": es_ES.academy_pages_home_liveTraining_button_href,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_button_href,
		"it-IT": it_IT.academy_pages_home_liveTraining_button_href,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_button_href,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training1_description,
		"en-AU": en_AU.academy_pages_home_liveTraining_training1_description,
		"en-GB": en_GB.academy_pages_home_liveTraining_training1_description,
		"en-US": en_US.academy_pages_home_liveTraining_training1_description,
		"es-ES": es_ES.academy_pages_home_liveTraining_training1_description,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training1_description,
		"it-IT": it_IT.academy_pages_home_liveTraining_training1_description,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training1_description,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training1_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training1_href,
		"en-AU": en_AU.academy_pages_home_liveTraining_training1_href,
		"en-GB": en_GB.academy_pages_home_liveTraining_training1_href,
		"en-US": en_US.academy_pages_home_liveTraining_training1_href,
		"es-ES": es_ES.academy_pages_home_liveTraining_training1_href,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training1_href,
		"it-IT": it_IT.academy_pages_home_liveTraining_training1_href,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training1_href,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training1_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training1_metadata,
		"en-AU": en_AU.academy_pages_home_liveTraining_training1_metadata,
		"en-GB": en_GB.academy_pages_home_liveTraining_training1_metadata,
		"en-US": en_US.academy_pages_home_liveTraining_training1_metadata,
		"es-ES": es_ES.academy_pages_home_liveTraining_training1_metadata,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training1_metadata,
		"it-IT": it_IT.academy_pages_home_liveTraining_training1_metadata,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training1_metadata,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training1_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training1_pill,
		"en-AU": en_AU.academy_pages_home_liveTraining_training1_pill,
		"en-GB": en_GB.academy_pages_home_liveTraining_training1_pill,
		"en-US": en_US.academy_pages_home_liveTraining_training1_pill,
		"es-ES": es_ES.academy_pages_home_liveTraining_training1_pill,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training1_pill,
		"it-IT": it_IT.academy_pages_home_liveTraining_training1_pill,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training1_pill,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training1_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training1_title,
		"en-AU": en_AU.academy_pages_home_liveTraining_training1_title,
		"en-GB": en_GB.academy_pages_home_liveTraining_training1_title,
		"en-US": en_US.academy_pages_home_liveTraining_training1_title,
		"es-ES": es_ES.academy_pages_home_liveTraining_training1_title,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training1_title,
		"it-IT": it_IT.academy_pages_home_liveTraining_training1_title,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training1_title,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training2_description,
		"en-AU": en_AU.academy_pages_home_liveTraining_training2_description,
		"en-GB": en_GB.academy_pages_home_liveTraining_training2_description,
		"en-US": en_US.academy_pages_home_liveTraining_training2_description,
		"es-ES": es_ES.academy_pages_home_liveTraining_training2_description,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training2_description,
		"it-IT": it_IT.academy_pages_home_liveTraining_training2_description,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training2_description,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training2_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training2_href,
		"en-AU": en_AU.academy_pages_home_liveTraining_training2_href,
		"en-GB": en_GB.academy_pages_home_liveTraining_training2_href,
		"en-US": en_US.academy_pages_home_liveTraining_training2_href,
		"es-ES": es_ES.academy_pages_home_liveTraining_training2_href,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training2_href,
		"it-IT": it_IT.academy_pages_home_liveTraining_training2_href,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training2_href,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training2_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training2_metadata,
		"en-AU": en_AU.academy_pages_home_liveTraining_training2_metadata,
		"en-GB": en_GB.academy_pages_home_liveTraining_training2_metadata,
		"en-US": en_US.academy_pages_home_liveTraining_training2_metadata,
		"es-ES": es_ES.academy_pages_home_liveTraining_training2_metadata,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training2_metadata,
		"it-IT": it_IT.academy_pages_home_liveTraining_training2_metadata,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training2_metadata,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training2_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training2_pill,
		"en-AU": en_AU.academy_pages_home_liveTraining_training2_pill,
		"en-GB": en_GB.academy_pages_home_liveTraining_training2_pill,
		"en-US": en_US.academy_pages_home_liveTraining_training2_pill,
		"es-ES": es_ES.academy_pages_home_liveTraining_training2_pill,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training2_pill,
		"it-IT": it_IT.academy_pages_home_liveTraining_training2_pill,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training2_pill,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training2_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training2_title,
		"en-AU": en_AU.academy_pages_home_liveTraining_training2_title,
		"en-GB": en_GB.academy_pages_home_liveTraining_training2_title,
		"en-US": en_US.academy_pages_home_liveTraining_training2_title,
		"es-ES": es_ES.academy_pages_home_liveTraining_training2_title,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training2_title,
		"it-IT": it_IT.academy_pages_home_liveTraining_training2_title,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training2_title,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training3_description,
		"en-AU": en_AU.academy_pages_home_liveTraining_training3_description,
		"en-GB": en_GB.academy_pages_home_liveTraining_training3_description,
		"en-US": en_US.academy_pages_home_liveTraining_training3_description,
		"es-ES": es_ES.academy_pages_home_liveTraining_training3_description,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training3_description,
		"it-IT": it_IT.academy_pages_home_liveTraining_training3_description,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training3_description,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training3_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training3_href,
		"en-AU": en_AU.academy_pages_home_liveTraining_training3_href,
		"en-GB": en_GB.academy_pages_home_liveTraining_training3_href,
		"en-US": en_US.academy_pages_home_liveTraining_training3_href,
		"es-ES": es_ES.academy_pages_home_liveTraining_training3_href,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training3_href,
		"it-IT": it_IT.academy_pages_home_liveTraining_training3_href,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training3_href,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training3_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training3_metadata,
		"en-AU": en_AU.academy_pages_home_liveTraining_training3_metadata,
		"en-GB": en_GB.academy_pages_home_liveTraining_training3_metadata,
		"en-US": en_US.academy_pages_home_liveTraining_training3_metadata,
		"es-ES": es_ES.academy_pages_home_liveTraining_training3_metadata,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training3_metadata,
		"it-IT": it_IT.academy_pages_home_liveTraining_training3_metadata,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training3_metadata,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training3_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training3_pill,
		"en-AU": en_AU.academy_pages_home_liveTraining_training3_pill,
		"en-GB": en_GB.academy_pages_home_liveTraining_training3_pill,
		"en-US": en_US.academy_pages_home_liveTraining_training3_pill,
		"es-ES": es_ES.academy_pages_home_liveTraining_training3_pill,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training3_pill,
		"it-IT": it_IT.academy_pages_home_liveTraining_training3_pill,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training3_pill,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training3_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training3_title,
		"en-AU": en_AU.academy_pages_home_liveTraining_training3_title,
		"en-GB": en_GB.academy_pages_home_liveTraining_training3_title,
		"en-US": en_US.academy_pages_home_liveTraining_training3_title,
		"es-ES": es_ES.academy_pages_home_liveTraining_training3_title,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training3_title,
		"it-IT": it_IT.academy_pages_home_liveTraining_training3_title,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training3_title,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training4_description,
		"en-AU": en_AU.academy_pages_home_liveTraining_training4_description,
		"en-GB": en_GB.academy_pages_home_liveTraining_training4_description,
		"en-US": en_US.academy_pages_home_liveTraining_training4_description,
		"es-ES": es_ES.academy_pages_home_liveTraining_training4_description,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training4_description,
		"it-IT": it_IT.academy_pages_home_liveTraining_training4_description,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training4_description,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training4_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training4_href,
		"en-AU": en_AU.academy_pages_home_liveTraining_training4_href,
		"en-GB": en_GB.academy_pages_home_liveTraining_training4_href,
		"en-US": en_US.academy_pages_home_liveTraining_training4_href,
		"es-ES": es_ES.academy_pages_home_liveTraining_training4_href,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training4_href,
		"it-IT": it_IT.academy_pages_home_liveTraining_training4_href,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training4_href,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training4_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training4_metadata,
		"en-AU": en_AU.academy_pages_home_liveTraining_training4_metadata,
		"en-GB": en_GB.academy_pages_home_liveTraining_training4_metadata,
		"en-US": en_US.academy_pages_home_liveTraining_training4_metadata,
		"es-ES": es_ES.academy_pages_home_liveTraining_training4_metadata,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training4_metadata,
		"it-IT": it_IT.academy_pages_home_liveTraining_training4_metadata,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training4_metadata,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training4_metadata
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training4_pill,
		"en-AU": en_AU.academy_pages_home_liveTraining_training4_pill,
		"en-GB": en_GB.academy_pages_home_liveTraining_training4_pill,
		"en-US": en_US.academy_pages_home_liveTraining_training4_pill,
		"es-ES": es_ES.academy_pages_home_liveTraining_training4_pill,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training4_pill,
		"it-IT": it_IT.academy_pages_home_liveTraining_training4_pill,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training4_pill,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training4_pill
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_liveTraining_training4_title,
		"en-AU": en_AU.academy_pages_home_liveTraining_training4_title,
		"en-GB": en_GB.academy_pages_home_liveTraining_training4_title,
		"en-US": en_US.academy_pages_home_liveTraining_training4_title,
		"es-ES": es_ES.academy_pages_home_liveTraining_training4_title,
		"fr-FR": fr_FR.academy_pages_home_liveTraining_training4_title,
		"it-IT": it_IT.academy_pages_home_liveTraining_training4_title,
		"ko-KR": ko_KR.academy_pages_home_liveTraining_training4_title,
		"pt-BR": pt_BR.academy_pages_home_liveTraining_training4_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_headline,
		"en-AU": en_AU.academy_pages_home_testimonials_headline,
		"en-GB": en_GB.academy_pages_home_testimonials_headline,
		"en-US": en_US.academy_pages_home_testimonials_headline,
		"es-ES": es_ES.academy_pages_home_testimonials_headline,
		"fr-FR": fr_FR.academy_pages_home_testimonials_headline,
		"it-IT": it_IT.academy_pages_home_testimonials_headline,
		"ko-KR": ko_KR.academy_pages_home_testimonials_headline,
		"pt-BR": pt_BR.academy_pages_home_testimonials_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote1_text,
		"en-AU": en_AU.academy_pages_home_testimonials_quote1_text,
		"en-GB": en_GB.academy_pages_home_testimonials_quote1_text,
		"en-US": en_US.academy_pages_home_testimonials_quote1_text,
		"es-ES": es_ES.academy_pages_home_testimonials_quote1_text,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote1_text,
		"it-IT": it_IT.academy_pages_home_testimonials_quote1_text,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote1_text,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote1_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote1_button_label,
		"en-AU": en_AU.academy_pages_home_testimonials_quote1_button_label,
		"en-GB": en_GB.academy_pages_home_testimonials_quote1_button_label,
		"en-US": en_US.academy_pages_home_testimonials_quote1_button_label,
		"es-ES": es_ES.academy_pages_home_testimonials_quote1_button_label,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote1_button_label,
		"it-IT": it_IT.academy_pages_home_testimonials_quote1_button_label,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote1_button_label,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote1_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote1_button_href,
		"en-AU": en_AU.academy_pages_home_testimonials_quote1_button_href,
		"en-GB": en_GB.academy_pages_home_testimonials_quote1_button_href,
		"en-US": en_US.academy_pages_home_testimonials_quote1_button_href,
		"es-ES": es_ES.academy_pages_home_testimonials_quote1_button_href,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote1_button_href,
		"it-IT": it_IT.academy_pages_home_testimonials_quote1_button_href,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote1_button_href,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote1_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_size = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote1_size,
		"en-AU": en_AU.academy_pages_home_testimonials_quote1_size,
		"en-GB": en_GB.academy_pages_home_testimonials_quote1_size,
		"en-US": en_US.academy_pages_home_testimonials_quote1_size,
		"es-ES": es_ES.academy_pages_home_testimonials_quote1_size,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote1_size,
		"it-IT": it_IT.academy_pages_home_testimonials_quote1_size,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote1_size,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote1_size
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote2_text,
		"en-AU": en_AU.academy_pages_home_testimonials_quote2_text,
		"en-GB": en_GB.academy_pages_home_testimonials_quote2_text,
		"en-US": en_US.academy_pages_home_testimonials_quote2_text,
		"es-ES": es_ES.academy_pages_home_testimonials_quote2_text,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote2_text,
		"it-IT": it_IT.academy_pages_home_testimonials_quote2_text,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote2_text,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote2_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote2_button_label,
		"en-AU": en_AU.academy_pages_home_testimonials_quote2_button_label,
		"en-GB": en_GB.academy_pages_home_testimonials_quote2_button_label,
		"en-US": en_US.academy_pages_home_testimonials_quote2_button_label,
		"es-ES": es_ES.academy_pages_home_testimonials_quote2_button_label,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote2_button_label,
		"it-IT": it_IT.academy_pages_home_testimonials_quote2_button_label,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote2_button_label,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote2_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote2_button_href,
		"en-AU": en_AU.academy_pages_home_testimonials_quote2_button_href,
		"en-GB": en_GB.academy_pages_home_testimonials_quote2_button_href,
		"en-US": en_US.academy_pages_home_testimonials_quote2_button_href,
		"es-ES": es_ES.academy_pages_home_testimonials_quote2_button_href,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote2_button_href,
		"it-IT": it_IT.academy_pages_home_testimonials_quote2_button_href,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote2_button_href,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote2_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_size = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote2_size,
		"en-AU": en_AU.academy_pages_home_testimonials_quote2_size,
		"en-GB": en_GB.academy_pages_home_testimonials_quote2_size,
		"en-US": en_US.academy_pages_home_testimonials_quote2_size,
		"es-ES": es_ES.academy_pages_home_testimonials_quote2_size,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote2_size,
		"it-IT": it_IT.academy_pages_home_testimonials_quote2_size,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote2_size,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote2_size
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote3_text,
		"en-AU": en_AU.academy_pages_home_testimonials_quote3_text,
		"en-GB": en_GB.academy_pages_home_testimonials_quote3_text,
		"en-US": en_US.academy_pages_home_testimonials_quote3_text,
		"es-ES": es_ES.academy_pages_home_testimonials_quote3_text,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote3_text,
		"it-IT": it_IT.academy_pages_home_testimonials_quote3_text,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote3_text,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote3_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote3_button_label,
		"en-AU": en_AU.academy_pages_home_testimonials_quote3_button_label,
		"en-GB": en_GB.academy_pages_home_testimonials_quote3_button_label,
		"en-US": en_US.academy_pages_home_testimonials_quote3_button_label,
		"es-ES": es_ES.academy_pages_home_testimonials_quote3_button_label,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote3_button_label,
		"it-IT": it_IT.academy_pages_home_testimonials_quote3_button_label,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote3_button_label,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote3_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote3_button_href,
		"en-AU": en_AU.academy_pages_home_testimonials_quote3_button_href,
		"en-GB": en_GB.academy_pages_home_testimonials_quote3_button_href,
		"en-US": en_US.academy_pages_home_testimonials_quote3_button_href,
		"es-ES": es_ES.academy_pages_home_testimonials_quote3_button_href,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote3_button_href,
		"it-IT": it_IT.academy_pages_home_testimonials_quote3_button_href,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote3_button_href,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote3_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_size = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote3_size,
		"en-AU": en_AU.academy_pages_home_testimonials_quote3_size,
		"en-GB": en_GB.academy_pages_home_testimonials_quote3_size,
		"en-US": en_US.academy_pages_home_testimonials_quote3_size,
		"es-ES": es_ES.academy_pages_home_testimonials_quote3_size,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote3_size,
		"it-IT": it_IT.academy_pages_home_testimonials_quote3_size,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote3_size,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote3_size
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote4_text,
		"en-AU": en_AU.academy_pages_home_testimonials_quote4_text,
		"en-GB": en_GB.academy_pages_home_testimonials_quote4_text,
		"en-US": en_US.academy_pages_home_testimonials_quote4_text,
		"es-ES": es_ES.academy_pages_home_testimonials_quote4_text,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote4_text,
		"it-IT": it_IT.academy_pages_home_testimonials_quote4_text,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote4_text,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote4_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote4_button_label,
		"en-AU": en_AU.academy_pages_home_testimonials_quote4_button_label,
		"en-GB": en_GB.academy_pages_home_testimonials_quote4_button_label,
		"en-US": en_US.academy_pages_home_testimonials_quote4_button_label,
		"es-ES": es_ES.academy_pages_home_testimonials_quote4_button_label,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote4_button_label,
		"it-IT": it_IT.academy_pages_home_testimonials_quote4_button_label,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote4_button_label,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote4_button_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote4_button_href,
		"en-AU": en_AU.academy_pages_home_testimonials_quote4_button_href,
		"en-GB": en_GB.academy_pages_home_testimonials_quote4_button_href,
		"en-US": en_US.academy_pages_home_testimonials_quote4_button_href,
		"es-ES": es_ES.academy_pages_home_testimonials_quote4_button_href,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote4_button_href,
		"it-IT": it_IT.academy_pages_home_testimonials_quote4_button_href,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote4_button_href,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote4_button_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_size = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_home_testimonials_quote4_size,
		"en-AU": en_AU.academy_pages_home_testimonials_quote4_size,
		"en-GB": en_GB.academy_pages_home_testimonials_quote4_size,
		"en-US": en_US.academy_pages_home_testimonials_quote4_size,
		"es-ES": es_ES.academy_pages_home_testimonials_quote4_size,
		"fr-FR": fr_FR.academy_pages_home_testimonials_quote4_size,
		"it-IT": it_IT.academy_pages_home_testimonials_quote4_size,
		"ko-KR": ko_KR.academy_pages_home_testimonials_quote4_size,
		"pt-BR": pt_BR.academy_pages_home_testimonials_quote4_size
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.breadcrumbs_home,
		"en-AU": en_AU.breadcrumbs_home,
		"en-GB": en_GB.breadcrumbs_home,
		"en-US": en_US.breadcrumbs_home,
		"es-ES": es_ES.breadcrumbs_home,
		"fr-FR": fr_FR.breadcrumbs_home,
		"it-IT": it_IT.breadcrumbs_home,
		"ko-KR": ko_KR.breadcrumbs_home,
		"pt-BR": pt_BR.breadcrumbs_home
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.breadcrumbs_searchAll,
		"en-AU": en_AU.breadcrumbs_searchAll,
		"en-GB": en_GB.breadcrumbs_searchAll,
		"en-US": en_US.breadcrumbs_searchAll,
		"es-ES": es_ES.breadcrumbs_searchAll,
		"fr-FR": fr_FR.breadcrumbs_searchAll,
		"it-IT": it_IT.breadcrumbs_searchAll,
		"ko-KR": ko_KR.breadcrumbs_searchAll,
		"pt-BR": pt_BR.breadcrumbs_searchAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.breadcrumbs_blog,
		"en-AU": en_AU.breadcrumbs_blog,
		"en-GB": en_GB.breadcrumbs_blog,
		"en-US": en_US.breadcrumbs_blog,
		"es-ES": es_ES.breadcrumbs_blog,
		"fr-FR": fr_FR.breadcrumbs_blog,
		"it-IT": it_IT.breadcrumbs_blog,
		"ko-KR": ko_KR.breadcrumbs_blog,
		"pt-BR": pt_BR.breadcrumbs_blog
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.breadcrumbs_sitemap,
		"en-AU": en_AU.breadcrumbs_sitemap,
		"en-GB": en_GB.breadcrumbs_sitemap,
		"en-US": en_US.breadcrumbs_sitemap,
		"es-ES": es_ES.breadcrumbs_sitemap,
		"fr-FR": fr_FR.breadcrumbs_sitemap,
		"it-IT": it_IT.breadcrumbs_sitemap,
		"ko-KR": ko_KR.breadcrumbs_sitemap,
		"pt-BR": pt_BR.breadcrumbs_sitemap
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_bfcmHero_eyebrow,
		"en-AU": en_AU.organisms_bfcmHero_eyebrow,
		"en-GB": en_GB.organisms_bfcmHero_eyebrow,
		"en-US": en_US.organisms_bfcmHero_eyebrow,
		"es-ES": es_ES.organisms_bfcmHero_eyebrow,
		"fr-FR": fr_FR.organisms_bfcmHero_eyebrow,
		"it-IT": it_IT.organisms_bfcmHero_eyebrow,
		"ko-KR": ko_KR.organisms_bfcmHero_eyebrow,
		"pt-BR": pt_BR.organisms_bfcmHero_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_bfcmHero_headlineFilter_thisBfcm,
		"en-AU": en_AU.organisms_bfcmHero_headlineFilter_thisBfcm,
		"en-GB": en_GB.organisms_bfcmHero_headlineFilter_thisBfcm,
		"en-US": en_US.organisms_bfcmHero_headlineFilter_thisBfcm,
		"es-ES": es_ES.organisms_bfcmHero_headlineFilter_thisBfcm,
		"fr-FR": fr_FR.organisms_bfcmHero_headlineFilter_thisBfcm,
		"it-IT": it_IT.organisms_bfcmHero_headlineFilter_thisBfcm,
		"ko-KR": ko_KR.organisms_bfcmHero_headlineFilter_thisBfcm,
		"pt-BR": pt_BR.organisms_bfcmHero_headlineFilter_thisBfcm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_primaryButton = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_singleLineForm_primaryButton,
		"en-AU": en_AU.atoms_singleLineForm_primaryButton,
		"en-GB": en_GB.atoms_singleLineForm_primaryButton,
		"en-US": en_US.atoms_singleLineForm_primaryButton,
		"es-ES": es_ES.atoms_singleLineForm_primaryButton,
		"fr-FR": fr_FR.atoms_singleLineForm_primaryButton,
		"it-IT": it_IT.atoms_singleLineForm_primaryButton,
		"ko-KR": ko_KR.atoms_singleLineForm_primaryButton,
		"pt-BR": pt_BR.atoms_singleLineForm_primaryButton
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_placeholderText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_singleLineForm_placeholderText,
		"en-AU": en_AU.atoms_singleLineForm_placeholderText,
		"en-GB": en_GB.atoms_singleLineForm_placeholderText,
		"en-US": en_US.atoms_singleLineForm_placeholderText,
		"es-ES": es_ES.atoms_singleLineForm_placeholderText,
		"fr-FR": fr_FR.atoms_singleLineForm_placeholderText,
		"it-IT": it_IT.atoms_singleLineForm_placeholderText,
		"ko-KR": ko_KR.atoms_singleLineForm_placeholderText,
		"pt-BR": pt_BR.atoms_singleLineForm_placeholderText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_error = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.atoms_singleLineForm_error,
		"en-AU": en_AU.atoms_singleLineForm_error,
		"en-GB": en_GB.atoms_singleLineForm_error,
		"en-US": en_US.atoms_singleLineForm_error,
		"es-ES": es_ES.atoms_singleLineForm_error,
		"fr-FR": fr_FR.atoms_singleLineForm_error,
		"it-IT": it_IT.atoms_singleLineForm_error,
		"ko-KR": ko_KR.atoms_singleLineForm_error,
		"pt-BR": pt_BR.atoms_singleLineForm_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_logOut_href,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_logOut_href,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_logOut_href,
		"en-US": en_US.navigation_ecosystem_ctas_academy_logOut_href,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_logOut_href,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_logOut_href,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_logOut_href,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_logOut_href,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_logOut_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_myCredentials_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_myCredentials_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_myCredentials_label,
		"en-US": en_US.navigation_ecosystem_ctas_academy_myCredentials_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_myCredentials_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_myCredentials_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_myCredentials_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_myCredentials_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_myCredentials_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_myCredentials_href,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_myCredentials_href,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_myCredentials_href,
		"en-US": en_US.navigation_ecosystem_ctas_academy_myCredentials_href,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_myCredentials_href,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_myCredentials_href,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_myCredentials_href,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_myCredentials_href,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_myCredentials_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"en-US": en_US.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_ecosystem_ctas_academy_signIn_href,
		"en-AU": en_AU.navigation_ecosystem_ctas_academy_signIn_href,
		"en-GB": en_GB.navigation_ecosystem_ctas_academy_signIn_href,
		"en-US": en_US.navigation_ecosystem_ctas_academy_signIn_href,
		"es-ES": es_ES.navigation_ecosystem_ctas_academy_signIn_href,
		"fr-FR": fr_FR.navigation_ecosystem_ctas_academy_signIn_href,
		"it-IT": it_IT.navigation_ecosystem_ctas_academy_signIn_href,
		"ko-KR": ko_KR.navigation_ecosystem_ctas_academy_signIn_href,
		"pt-BR": pt_BR.navigation_ecosystem_ctas_academy_signIn_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_support_href,
		"en-AU": en_AU.navigation_platformActions_support_href,
		"en-GB": en_GB.navigation_platformActions_support_href,
		"en-US": en_US.navigation_platformActions_support_href,
		"es-ES": es_ES.navigation_platformActions_support_href,
		"fr-FR": fr_FR.navigation_platformActions_support_href,
		"it-IT": it_IT.navigation_platformActions_support_href,
		"ko-KR": ko_KR.navigation_platformActions_support_href,
		"pt-BR": pt_BR.navigation_platformActions_support_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.navigation_platformActions_support_label,
		"en-AU": en_AU.navigation_platformActions_support_label,
		"en-GB": en_GB.navigation_platformActions_support_label,
		"en-US": en_US.navigation_platformActions_support_label,
		"es-ES": es_ES.navigation_platformActions_support_label,
		"fr-FR": fr_FR.navigation_platformActions_support_label,
		"it-IT": it_IT.navigation_platformActions_support_label,
		"ko-KR": ko_KR.navigation_platformActions_support_label,
		"pt-BR": pt_BR.navigation_platformActions_support_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_overview = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_articleTableContents_overview,
		"en-AU": en_AU.organisms_articleTableContents_overview,
		"en-GB": en_GB.organisms_articleTableContents_overview,
		"en-US": en_US.organisms_articleTableContents_overview,
		"es-ES": es_ES.organisms_articleTableContents_overview,
		"fr-FR": fr_FR.organisms_articleTableContents_overview,
		"it-IT": it_IT.organisms_articleTableContents_overview,
		"ko-KR": ko_KR.organisms_articleTableContents_overview,
		"pt-BR": pt_BR.organisms_articleTableContents_overview
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_bfcmHero_headline,
		"en-AU": en_AU.organisms_bfcmHero_headline,
		"en-GB": en_GB.organisms_bfcmHero_headline,
		"en-US": en_US.organisms_bfcmHero_headline,
		"es-ES": es_ES.organisms_bfcmHero_headline,
		"fr-FR": fr_FR.organisms_bfcmHero_headline,
		"it-IT": it_IT.organisms_bfcmHero_headline,
		"ko-KR": ko_KR.organisms_bfcmHero_headline,
		"pt-BR": pt_BR.organisms_bfcmHero_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_bfcmHero_headlineFilter_iAm,
		"en-AU": en_AU.organisms_bfcmHero_headlineFilter_iAm,
		"en-GB": en_GB.organisms_bfcmHero_headlineFilter_iAm,
		"en-US": en_US.organisms_bfcmHero_headlineFilter_iAm,
		"es-ES": es_ES.organisms_bfcmHero_headlineFilter_iAm,
		"fr-FR": fr_FR.organisms_bfcmHero_headlineFilter_iAm,
		"it-IT": it_IT.organisms_bfcmHero_headlineFilter_iAm,
		"ko-KR": ko_KR.organisms_bfcmHero_headlineFilter_iAm,
		"pt-BR": pt_BR.organisms_bfcmHero_headlineFilter_iAm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_bfcmHero_headlineFilter_iWantTo,
		"en-AU": en_AU.organisms_bfcmHero_headlineFilter_iWantTo,
		"en-GB": en_GB.organisms_bfcmHero_headlineFilter_iWantTo,
		"en-US": en_US.organisms_bfcmHero_headlineFilter_iWantTo,
		"es-ES": es_ES.organisms_bfcmHero_headlineFilter_iWantTo,
		"fr-FR": fr_FR.organisms_bfcmHero_headlineFilter_iWantTo,
		"it-IT": it_IT.organisms_bfcmHero_headlineFilter_iWantTo,
		"ko-KR": ko_KR.organisms_bfcmHero_headlineFilter_iWantTo,
		"pt-BR": pt_BR.organisms_bfcmHero_headlineFilter_iWantTo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewAll = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogCards_viewAll,
		"en-AU": en_AU.organisms_blogCards_viewAll,
		"en-GB": en_GB.organisms_blogCards_viewAll,
		"en-US": en_US.organisms_blogCards_viewAll,
		"es-ES": es_ES.organisms_blogCards_viewAll,
		"fr-FR": fr_FR.organisms_blogCards_viewAll,
		"it-IT": it_IT.organisms_blogCards_viewAll,
		"ko-KR": ko_KR.organisms_blogCards_viewAll,
		"pt-BR": pt_BR.organisms_blogCards_viewAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogSearchHero_placeholder,
		"en-AU": en_AU.organisms_blogSearchHero_placeholder,
		"en-GB": en_GB.organisms_blogSearchHero_placeholder,
		"en-US": en_US.organisms_blogSearchHero_placeholder,
		"es-ES": es_ES.organisms_blogSearchHero_placeholder,
		"fr-FR": fr_FR.organisms_blogSearchHero_placeholder,
		"it-IT": it_IT.organisms_blogSearchHero_placeholder,
		"ko-KR": ko_KR.organisms_blogSearchHero_placeholder,
		"pt-BR": pt_BR.organisms_blogSearchHero_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_customSearchHeadline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_blogSearchHero_customSearchHeadline,
		"en-AU": en_AU.organisms_blogSearchHero_customSearchHeadline,
		"en-GB": en_GB.organisms_blogSearchHero_customSearchHeadline,
		"en-US": en_US.organisms_blogSearchHero_customSearchHeadline,
		"es-ES": es_ES.organisms_blogSearchHero_customSearchHeadline,
		"fr-FR": fr_FR.organisms_blogSearchHero_customSearchHeadline,
		"it-IT": it_IT.organisms_blogSearchHero_customSearchHeadline,
		"ko-KR": ko_KR.organisms_blogSearchHero_customSearchHeadline,
		"pt-BR": pt_BR.organisms_blogSearchHero_customSearchHeadline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_submit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_submit,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_submit,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_submit,
		"en-US": en_US.organisms_emailSubjectLineGenerator_submit,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_submit,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_submit,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_submit,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_submit,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_submit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_loading = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_loading,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_loading,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_loading,
		"en-US": en_US.organisms_emailSubjectLineGenerator_loading,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_loading,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_loading,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_loading,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_loading,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_loading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_examplePrompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_examplePrompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_examplePrompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_examplePrompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_examplePrompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_examplePrompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_examplePrompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_examplePrompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_examplePrompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_examplePrompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"en-US": en_US.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productLaunch = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType_productLaunch,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType_productLaunch
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productPromotion = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType_productPromotion,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType_productPromotion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productUpdate = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType_productUpdate,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType_productUpdate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_storewideSale = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType_storewideSale,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType_storewideSale
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_announcement = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"en-AU": en_AU.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"en-GB": en_GB.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"en-US": en_US.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"es-ES": es_ES.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"fr-FR": fr_FR.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"it-IT": it_IT.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"ko-KR": ko_KR.organisms_emailSubjectLineGenerator_campaignType_announcement,
		"pt-BR": pt_BR.organisms_emailSubjectLineGenerator_campaignType_announcement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"en-US": en_US.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_issueType_setting_up_new_device
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_info,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_info,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_info,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_info,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_info,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_info,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_info,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_info,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_info
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_reason,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_reason
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_profile_names,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_profile_names
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_other_emails,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_other_emails
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"en-AU": en_AU.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"en-GB": en_GB.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"en-US": en_US.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"es-ES": es_ES.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"fr-FR": fr_FR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"it-IT": it_IT.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"ko-KR": ko_KR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder,
		"pt-BR": pt_BR.organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card1_icon_iconName,
		"en-AU": en_AU.organisms_moreCards_card1_icon_iconName,
		"en-GB": en_GB.organisms_moreCards_card1_icon_iconName,
		"en-US": en_US.organisms_moreCards_card1_icon_iconName,
		"es-ES": es_ES.organisms_moreCards_card1_icon_iconName,
		"fr-FR": fr_FR.organisms_moreCards_card1_icon_iconName,
		"it-IT": it_IT.organisms_moreCards_card1_icon_iconName,
		"ko-KR": ko_KR.organisms_moreCards_card1_icon_iconName,
		"pt-BR": pt_BR.organisms_moreCards_card1_icon_iconName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card2_icon_iconName,
		"en-AU": en_AU.organisms_moreCards_card2_icon_iconName,
		"en-GB": en_GB.organisms_moreCards_card2_icon_iconName,
		"en-US": en_US.organisms_moreCards_card2_icon_iconName,
		"es-ES": es_ES.organisms_moreCards_card2_icon_iconName,
		"fr-FR": fr_FR.organisms_moreCards_card2_icon_iconName,
		"it-IT": it_IT.organisms_moreCards_card2_icon_iconName,
		"ko-KR": ko_KR.organisms_moreCards_card2_icon_iconName,
		"pt-BR": pt_BR.organisms_moreCards_card2_icon_iconName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_icon_iconName,
		"en-AU": en_AU.organisms_moreCards_card3_icon_iconName,
		"en-GB": en_GB.organisms_moreCards_card3_icon_iconName,
		"en-US": en_US.organisms_moreCards_card3_icon_iconName,
		"es-ES": es_ES.organisms_moreCards_card3_icon_iconName,
		"fr-FR": fr_FR.organisms_moreCards_card3_icon_iconName,
		"it-IT": it_IT.organisms_moreCards_card3_icon_iconName,
		"ko-KR": ko_KR.organisms_moreCards_card3_icon_iconName,
		"pt-BR": pt_BR.organisms_moreCards_card3_icon_iconName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ accessSupport: NonNullable<unknown>, emailSupport: NonNullable<unknown>, emailSupportAccountTypes: NonNullable<unknown>, emailSupportAvailability: NonNullable<unknown>, chatVirtualAssistance: NonNullable<unknown>, chatVirtualAssistanceAvailability: NonNullable<unknown> }} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_template = (params , options = {}) => {
	return {
		"de-DE": de_DE.organisms_moreCards_card3_richText_template,
		"en-AU": en_AU.organisms_moreCards_card3_richText_template,
		"en-GB": en_GB.organisms_moreCards_card3_richText_template,
		"en-US": en_US.organisms_moreCards_card3_richText_template,
		"es-ES": es_ES.organisms_moreCards_card3_richText_template,
		"fr-FR": fr_FR.organisms_moreCards_card3_richText_template,
		"it-IT": it_IT.organisms_moreCards_card3_richText_template,
		"ko-KR": ko_KR.organisms_moreCards_card3_richText_template,
		"pt-BR": pt_BR.organisms_moreCards_card3_richText_template
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigationCategorySelection_viewAllButton_text,
		"en-AU": en_AU.organisms_navigationCategorySelection_viewAllButton_text,
		"en-GB": en_GB.organisms_navigationCategorySelection_viewAllButton_text,
		"en-US": en_US.organisms_navigationCategorySelection_viewAllButton_text,
		"es-ES": es_ES.organisms_navigationCategorySelection_viewAllButton_text,
		"fr-FR": fr_FR.organisms_navigationCategorySelection_viewAllButton_text,
		"it-IT": it_IT.organisms_navigationCategorySelection_viewAllButton_text,
		"ko-KR": ko_KR.organisms_navigationCategorySelection_viewAllButton_text,
		"pt-BR": pt_BR.organisms_navigationCategorySelection_viewAllButton_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_navigationCategorySelection_viewLessButton_text,
		"en-AU": en_AU.organisms_navigationCategorySelection_viewLessButton_text,
		"en-GB": en_GB.organisms_navigationCategorySelection_viewLessButton_text,
		"en-US": en_US.organisms_navigationCategorySelection_viewLessButton_text,
		"es-ES": es_ES.organisms_navigationCategorySelection_viewLessButton_text,
		"fr-FR": fr_FR.organisms_navigationCategorySelection_viewLessButton_text,
		"it-IT": it_IT.organisms_navigationCategorySelection_viewLessButton_text,
		"ko-KR": ko_KR.organisms_navigationCategorySelection_viewLessButton_text,
		"pt-BR": pt_BR.organisms_navigationCategorySelection_viewLessButton_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_read_more = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_post_filter_read_more,
		"en-AU": en_AU.organisms_post_filter_read_more,
		"en-GB": en_GB.organisms_post_filter_read_more,
		"en-US": en_US.organisms_post_filter_read_more,
		"es-ES": es_ES.organisms_post_filter_read_more,
		"fr-FR": fr_FR.organisms_post_filter_read_more,
		"it-IT": it_IT.organisms_post_filter_read_more,
		"ko-KR": ko_KR.organisms_post_filter_read_more,
		"pt-BR": pt_BR.organisms_post_filter_read_more
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_per_month = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_per_month,
		"en-AU": en_AU.organisms_pricing_per_month,
		"en-GB": en_GB.organisms_pricing_per_month,
		"en-US": en_US.organisms_pricing_per_month,
		"es-ES": es_ES.organisms_pricing_per_month,
		"fr-FR": fr_FR.organisms_pricing_per_month,
		"it-IT": it_IT.organisms_pricing_per_month,
		"ko-KR": ko_KR.organisms_pricing_per_month,
		"pt-BR": pt_BR.organisms_pricing_per_month
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactSales = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contactSales,
		"en-AU": en_AU.organisms_pricing_contactSales,
		"en-GB": en_GB.organisms_pricing_contactSales,
		"en-US": en_US.organisms_pricing_contactSales,
		"es-ES": es_ES.organisms_pricing_contactSales,
		"fr-FR": fr_FR.organisms_pricing_contactSales,
		"it-IT": it_IT.organisms_pricing_contactSales,
		"ko-KR": ko_KR.organisms_pricing_contactSales,
		"pt-BR": pt_BR.organisms_pricing_contactSales
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_name = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailPlusSms_name,
		"en-AU": en_AU.organisms_pricing_plans_emailPlusSms_name,
		"en-GB": en_GB.organisms_pricing_plans_emailPlusSms_name,
		"en-US": en_US.organisms_pricing_plans_emailPlusSms_name,
		"es-ES": es_ES.organisms_pricing_plans_emailPlusSms_name,
		"fr-FR": fr_FR.organisms_pricing_plans_emailPlusSms_name,
		"it-IT": it_IT.organisms_pricing_plans_emailPlusSms_name,
		"ko-KR": ko_KR.organisms_pricing_plans_emailPlusSms_name,
		"pt-BR": pt_BR.organisms_pricing_plans_emailPlusSms_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_recommended = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailPlusSms_recommended,
		"en-AU": en_AU.organisms_pricing_plans_emailPlusSms_recommended,
		"en-GB": en_GB.organisms_pricing_plans_emailPlusSms_recommended,
		"en-US": en_US.organisms_pricing_plans_emailPlusSms_recommended,
		"es-ES": es_ES.organisms_pricing_plans_emailPlusSms_recommended,
		"fr-FR": fr_FR.organisms_pricing_plans_emailPlusSms_recommended,
		"it-IT": it_IT.organisms_pricing_plans_emailPlusSms_recommended,
		"ko-KR": ko_KR.organisms_pricing_plans_emailPlusSms_recommended,
		"pt-BR": pt_BR.organisms_pricing_plans_emailPlusSms_recommended
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_smsSubText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailPlusSms_smsSubText,
		"en-AU": en_AU.organisms_pricing_plans_emailPlusSms_smsSubText,
		"en-GB": en_GB.organisms_pricing_plans_emailPlusSms_smsSubText,
		"en-US": en_US.organisms_pricing_plans_emailPlusSms_smsSubText,
		"es-ES": es_ES.organisms_pricing_plans_emailPlusSms_smsSubText,
		"fr-FR": fr_FR.organisms_pricing_plans_emailPlusSms_smsSubText,
		"it-IT": it_IT.organisms_pricing_plans_emailPlusSms_smsSubText,
		"ko-KR": ko_KR.organisms_pricing_plans_emailPlusSms_smsSubText,
		"pt-BR": pt_BR.organisms_pricing_plans_emailPlusSms_smsSubText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_mmsSubText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"en-AU": en_AU.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"en-GB": en_GB.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"en-US": en_US.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"es-ES": es_ES.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"fr-FR": fr_FR.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"it-IT": it_IT.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"ko-KR": ko_KR.organisms_pricing_plans_emailPlusSms_mmsSubText,
		"pt-BR": pt_BR.organisms_pricing_plans_emailPlusSms_mmsSubText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_per_month = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_email_per_month,
		"en-AU": en_AU.organisms_pricing_plans_email_per_month,
		"en-GB": en_GB.organisms_pricing_plans_email_per_month,
		"en-US": en_US.organisms_pricing_plans_email_per_month,
		"es-ES": es_ES.organisms_pricing_plans_email_per_month,
		"fr-FR": fr_FR.organisms_pricing_plans_email_per_month,
		"it-IT": it_IT.organisms_pricing_plans_email_per_month,
		"ko-KR": ko_KR.organisms_pricing_plans_email_per_month,
		"pt-BR": pt_BR.organisms_pricing_plans_email_per_month
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_emails_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_email_emails_label,
		"en-AU": en_AU.organisms_pricing_plans_email_emails_label,
		"en-GB": en_GB.organisms_pricing_plans_email_emails_label,
		"en-US": en_US.organisms_pricing_plans_email_emails_label,
		"es-ES": es_ES.organisms_pricing_plans_email_emails_label,
		"fr-FR": fr_FR.organisms_pricing_plans_email_emails_label,
		"it-IT": it_IT.organisms_pricing_plans_email_emails_label,
		"ko-KR": ko_KR.organisms_pricing_plans_email_emails_label,
		"pt-BR": pt_BR.organisms_pricing_plans_email_emails_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_top = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_free_subtext_top,
		"en-AU": en_AU.organisms_pricing_plans_free_subtext_top,
		"en-GB": en_GB.organisms_pricing_plans_free_subtext_top,
		"en-US": en_US.organisms_pricing_plans_free_subtext_top,
		"es-ES": es_ES.organisms_pricing_plans_free_subtext_top,
		"fr-FR": fr_FR.organisms_pricing_plans_free_subtext_top,
		"it-IT": it_IT.organisms_pricing_plans_free_subtext_top,
		"ko-KR": ko_KR.organisms_pricing_plans_free_subtext_top,
		"pt-BR": pt_BR.organisms_pricing_plans_free_subtext_top
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_bottom = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_free_subtext_bottom,
		"en-AU": en_AU.organisms_pricing_plans_free_subtext_bottom,
		"en-GB": en_GB.organisms_pricing_plans_free_subtext_bottom,
		"en-US": en_US.organisms_pricing_plans_free_subtext_bottom,
		"es-ES": es_ES.organisms_pricing_plans_free_subtext_bottom,
		"fr-FR": fr_FR.organisms_pricing_plans_free_subtext_bottom,
		"it-IT": it_IT.organisms_pricing_plans_free_subtext_bottom,
		"ko-KR": ko_KR.organisms_pricing_plans_free_subtext_bottom,
		"pt-BR": pt_BR.organisms_pricing_plans_free_subtext_bottom
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_expandable_button = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_expandable_button,
		"en-AU": en_AU.organisms_pricing_plans_expandable_button,
		"en-GB": en_GB.organisms_pricing_plans_expandable_button,
		"en-US": en_US.organisms_pricing_plans_expandable_button,
		"es-ES": es_ES.organisms_pricing_plans_expandable_button,
		"fr-FR": fr_FR.organisms_pricing_plans_expandable_button,
		"it-IT": it_IT.organisms_pricing_plans_expandable_button,
		"ko-KR": ko_KR.organisms_pricing_plans_expandable_button,
		"pt-BR": pt_BR.organisms_pricing_plans_expandable_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_collapsible_button = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_collapsible_button,
		"en-AU": en_AU.organisms_pricing_plans_collapsible_button,
		"en-GB": en_GB.organisms_pricing_plans_collapsible_button,
		"en-US": en_US.organisms_pricing_plans_collapsible_button,
		"es-ES": es_ES.organisms_pricing_plans_collapsible_button,
		"fr-FR": fr_FR.organisms_pricing_plans_collapsible_button,
		"it-IT": it_IT.organisms_pricing_plans_collapsible_button,
		"ko-KR": ko_KR.organisms_pricing_plans_collapsible_button,
		"pt-BR": pt_BR.organisms_pricing_plans_collapsible_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_above250kContacts = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_paidCardContent_above250kContacts,
		"en-AU": en_AU.organisms_pricing_plans_paidCardContent_above250kContacts,
		"en-GB": en_GB.organisms_pricing_plans_paidCardContent_above250kContacts,
		"en-US": en_US.organisms_pricing_plans_paidCardContent_above250kContacts,
		"es-ES": es_ES.organisms_pricing_plans_paidCardContent_above250kContacts,
		"fr-FR": fr_FR.organisms_pricing_plans_paidCardContent_above250kContacts,
		"it-IT": it_IT.organisms_pricing_plans_paidCardContent_above250kContacts,
		"ko-KR": ko_KR.organisms_pricing_plans_paidCardContent_above250kContacts,
		"pt-BR": pt_BR.organisms_pricing_plans_paidCardContent_above250kContacts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_below250Contacts = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_paidCardContent_below250Contacts,
		"en-AU": en_AU.organisms_pricing_plans_paidCardContent_below250Contacts,
		"en-GB": en_GB.organisms_pricing_plans_paidCardContent_below250Contacts,
		"en-US": en_US.organisms_pricing_plans_paidCardContent_below250Contacts,
		"es-ES": es_ES.organisms_pricing_plans_paidCardContent_below250Contacts,
		"fr-FR": fr_FR.organisms_pricing_plans_paidCardContent_below250Contacts,
		"it-IT": it_IT.organisms_pricing_plans_paidCardContent_below250Contacts,
		"ko-KR": ko_KR.organisms_pricing_plans_paidCardContent_below250Contacts,
		"pt-BR": pt_BR.organisms_pricing_plans_paidCardContent_below250Contacts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_platform_headline,
		"en-AU": en_AU.organisms_pricing_plans_platform_headline,
		"en-GB": en_GB.organisms_pricing_plans_platform_headline,
		"en-US": en_US.organisms_pricing_plans_platform_headline,
		"es-ES": es_ES.organisms_pricing_plans_platform_headline,
		"fr-FR": fr_FR.organisms_pricing_plans_platform_headline,
		"it-IT": it_IT.organisms_pricing_plans_platform_headline,
		"ko-KR": ko_KR.organisms_pricing_plans_platform_headline,
		"pt-BR": pt_BR.organisms_pricing_plans_platform_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_cdp_subTextInfoHeader = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"en-AU": en_AU.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"en-GB": en_GB.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"en-US": en_US.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"es-ES": es_ES.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"fr-FR": fr_FR.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"it-IT": it_IT.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"ko-KR": ko_KR.organisms_pricing_plans_platform_cdp_subTextInfoHeader,
		"pt-BR": pt_BR.organisms_pricing_plans_platform_cdp_subTextInfoHeader
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_cdp_subTextInfo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_platform_cdp_subTextInfo,
		"en-AU": en_AU.organisms_pricing_plans_platform_cdp_subTextInfo,
		"en-GB": en_GB.organisms_pricing_plans_platform_cdp_subTextInfo,
		"en-US": en_US.organisms_pricing_plans_platform_cdp_subTextInfo,
		"es-ES": es_ES.organisms_pricing_plans_platform_cdp_subTextInfo,
		"fr-FR": fr_FR.organisms_pricing_plans_platform_cdp_subTextInfo,
		"it-IT": it_IT.organisms_pricing_plans_platform_cdp_subTextInfo,
		"ko-KR": ko_KR.organisms_pricing_plans_platform_cdp_subTextInfo,
		"pt-BR": pt_BR.organisms_pricing_plans_platform_cdp_subTextInfo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_cdp_subText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_platform_cdp_subText,
		"en-AU": en_AU.organisms_pricing_plans_platform_cdp_subText,
		"en-GB": en_GB.organisms_pricing_plans_platform_cdp_subText,
		"en-US": en_US.organisms_pricing_plans_platform_cdp_subText,
		"es-ES": es_ES.organisms_pricing_plans_platform_cdp_subText,
		"fr-FR": fr_FR.organisms_pricing_plans_platform_cdp_subText,
		"it-IT": it_IT.organisms_pricing_plans_platform_cdp_subText,
		"ko-KR": ko_KR.organisms_pricing_plans_platform_cdp_subText,
		"pt-BR": pt_BR.organisms_pricing_plans_platform_cdp_subText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contacts_slider_headline,
		"en-AU": en_AU.organisms_pricing_contacts_slider_headline,
		"en-GB": en_GB.organisms_pricing_contacts_slider_headline,
		"en-US": en_US.organisms_pricing_contacts_slider_headline,
		"es-ES": es_ES.organisms_pricing_contacts_slider_headline,
		"fr-FR": fr_FR.organisms_pricing_contacts_slider_headline,
		"it-IT": it_IT.organisms_pricing_contacts_slider_headline,
		"ko-KR": ko_KR.organisms_pricing_contacts_slider_headline,
		"pt-BR": pt_BR.organisms_pricing_contacts_slider_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contacts_slider_subText,
		"en-AU": en_AU.organisms_pricing_contacts_slider_subText,
		"en-GB": en_GB.organisms_pricing_contacts_slider_subText,
		"en-US": en_US.organisms_pricing_contacts_slider_subText,
		"es-ES": es_ES.organisms_pricing_contacts_slider_subText,
		"fr-FR": fr_FR.organisms_pricing_contacts_slider_subText,
		"it-IT": it_IT.organisms_pricing_contacts_slider_subText,
		"ko-KR": ko_KR.organisms_pricing_contacts_slider_subText,
		"pt-BR": pt_BR.organisms_pricing_contacts_slider_subText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subTextInfo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_contacts_slider_subTextInfo,
		"en-AU": en_AU.organisms_pricing_contacts_slider_subTextInfo,
		"en-GB": en_GB.organisms_pricing_contacts_slider_subTextInfo,
		"en-US": en_US.organisms_pricing_contacts_slider_subTextInfo,
		"es-ES": es_ES.organisms_pricing_contacts_slider_subTextInfo,
		"fr-FR": fr_FR.organisms_pricing_contacts_slider_subTextInfo,
		"it-IT": it_IT.organisms_pricing_contacts_slider_subTextInfo,
		"ko-KR": ko_KR.organisms_pricing_contacts_slider_subTextInfo,
		"pt-BR": pt_BR.organisms_pricing_contacts_slider_subTextInfo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_credits_slider_headline,
		"en-AU": en_AU.organisms_pricing_credits_slider_headline,
		"en-GB": en_GB.organisms_pricing_credits_slider_headline,
		"en-US": en_US.organisms_pricing_credits_slider_headline,
		"es-ES": es_ES.organisms_pricing_credits_slider_headline,
		"fr-FR": fr_FR.organisms_pricing_credits_slider_headline,
		"it-IT": it_IT.organisms_pricing_credits_slider_headline,
		"ko-KR": ko_KR.organisms_pricing_credits_slider_headline,
		"pt-BR": pt_BR.organisms_pricing_credits_slider_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_credits_slider_subText,
		"en-AU": en_AU.organisms_pricing_credits_slider_subText,
		"en-GB": en_GB.organisms_pricing_credits_slider_subText,
		"en-US": en_US.organisms_pricing_credits_slider_subText,
		"es-ES": es_ES.organisms_pricing_credits_slider_subText,
		"fr-FR": fr_FR.organisms_pricing_credits_slider_subText,
		"it-IT": it_IT.organisms_pricing_credits_slider_subText,
		"ko-KR": ko_KR.organisms_pricing_credits_slider_subText,
		"pt-BR": pt_BR.organisms_pricing_credits_slider_subText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subTextInfo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_credits_slider_subTextInfo,
		"en-AU": en_AU.organisms_pricing_credits_slider_subTextInfo,
		"en-GB": en_GB.organisms_pricing_credits_slider_subTextInfo,
		"en-US": en_US.organisms_pricing_credits_slider_subTextInfo,
		"es-ES": es_ES.organisms_pricing_credits_slider_subTextInfo,
		"fr-FR": fr_FR.organisms_pricing_credits_slider_subTextInfo,
		"it-IT": it_IT.organisms_pricing_credits_slider_subTextInfo,
		"ko-KR": ko_KR.organisms_pricing_credits_slider_subTextInfo,
		"pt-BR": pt_BR.organisms_pricing_credits_slider_subTextInfo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_PT = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_locales_PT,
		"en-AU": en_AU.organisms_pricing_calculator_locales_PT,
		"en-GB": en_GB.organisms_pricing_calculator_locales_PT,
		"en-US": en_US.organisms_pricing_calculator_locales_PT,
		"es-ES": es_ES.organisms_pricing_calculator_locales_PT,
		"fr-FR": fr_FR.organisms_pricing_calculator_locales_PT,
		"it-IT": it_IT.organisms_pricing_calculator_locales_PT,
		"ko-KR": ko_KR.organisms_pricing_calculator_locales_PT,
		"pt-BR": pt_BR.organisms_pricing_calculator_locales_PT
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_headline,
		"en-AU": en_AU.organisms_pricing_calculator_headline,
		"en-GB": en_GB.organisms_pricing_calculator_headline,
		"en-US": en_US.organisms_pricing_calculator_headline,
		"es-ES": es_ES.organisms_pricing_calculator_headline,
		"fr-FR": fr_FR.organisms_pricing_calculator_headline,
		"it-IT": it_IT.organisms_pricing_calculator_headline,
		"ko-KR": ko_KR.organisms_pricing_calculator_headline,
		"pt-BR": pt_BR.organisms_pricing_calculator_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_service_type = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_service_type,
		"en-AU": en_AU.organisms_pricing_calculator_service_type,
		"en-GB": en_GB.organisms_pricing_calculator_service_type,
		"en-US": en_US.organisms_pricing_calculator_service_type,
		"es-ES": es_ES.organisms_pricing_calculator_service_type,
		"fr-FR": fr_FR.organisms_pricing_calculator_service_type,
		"it-IT": it_IT.organisms_pricing_calculator_service_type,
		"ko-KR": ko_KR.organisms_pricing_calculator_service_type,
		"pt-BR": pt_BR.organisms_pricing_calculator_service_type
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_destination = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_destination,
		"en-AU": en_AU.organisms_pricing_calculator_destination,
		"en-GB": en_GB.organisms_pricing_calculator_destination,
		"en-US": en_US.organisms_pricing_calculator_destination,
		"es-ES": es_ES.organisms_pricing_calculator_destination,
		"fr-FR": fr_FR.organisms_pricing_calculator_destination,
		"it-IT": it_IT.organisms_pricing_calculator_destination,
		"ko-KR": ko_KR.organisms_pricing_calculator_destination,
		"pt-BR": pt_BR.organisms_pricing_calculator_destination
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms_limit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_sms_limit,
		"en-AU": en_AU.organisms_pricing_calculator_sms_limit,
		"en-GB": en_GB.organisms_pricing_calculator_sms_limit,
		"en-US": en_US.organisms_pricing_calculator_sms_limit,
		"es-ES": es_ES.organisms_pricing_calculator_sms_limit,
		"fr-FR": fr_FR.organisms_pricing_calculator_sms_limit,
		"it-IT": it_IT.organisms_pricing_calculator_sms_limit,
		"ko-KR": ko_KR.organisms_pricing_calculator_sms_limit,
		"pt-BR": pt_BR.organisms_pricing_calculator_sms_limit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms_limit = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_mms_limit,
		"en-AU": en_AU.organisms_pricing_calculator_mms_limit,
		"en-GB": en_GB.organisms_pricing_calculator_mms_limit,
		"en-US": en_US.organisms_pricing_calculator_mms_limit,
		"es-ES": es_ES.organisms_pricing_calculator_mms_limit,
		"fr-FR": fr_FR.organisms_pricing_calculator_mms_limit,
		"it-IT": it_IT.organisms_pricing_calculator_mms_limit,
		"ko-KR": ko_KR.organisms_pricing_calculator_mms_limit,
		"pt-BR": pt_BR.organisms_pricing_calculator_mms_limit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePerSend = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_calculator_pricePerSend,
		"en-AU": en_AU.organisms_pricing_calculator_pricePerSend,
		"en-GB": en_GB.organisms_pricing_calculator_pricePerSend,
		"en-US": en_US.organisms_pricing_calculator_pricePerSend,
		"es-ES": es_ES.organisms_pricing_calculator_pricePerSend,
		"fr-FR": fr_FR.organisms_pricing_calculator_pricePerSend,
		"it-IT": it_IT.organisms_pricing_calculator_pricePerSend,
		"ko-KR": ko_KR.organisms_pricing_calculator_pricePerSend,
		"pt-BR": pt_BR.organisms_pricing_calculator_pricePerSend
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_post = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_post,
		"en-AU": en_AU.organisms_searchBar_placeholder_post,
		"en-GB": en_GB.organisms_searchBar_placeholder_post,
		"en-US": en_US.organisms_searchBar_placeholder_post,
		"es-ES": es_ES.organisms_searchBar_placeholder_post,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_post,
		"it-IT": it_IT.organisms_searchBar_placeholder_post,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_post,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_post
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_page,
		"en-US": en_US.organisms_searchBar_placeholder_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_case_study = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_case_study,
		"en-AU": en_AU.organisms_searchBar_placeholder_case_study,
		"en-GB": en_GB.organisms_searchBar_placeholder_case_study,
		"en-US": en_US.organisms_searchBar_placeholder_case_study,
		"es-ES": es_ES.organisms_searchBar_placeholder_case_study,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_case_study,
		"it-IT": it_IT.organisms_searchBar_placeholder_case_study,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_case_study,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_case_study
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_compare_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_compare_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_compare_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_compare_page,
		"en-US": en_US.organisms_searchBar_placeholder_compare_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_compare_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_compare_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_compare_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_compare_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_compare_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_marketing_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_marketing_resource,
		"en-AU": en_AU.organisms_searchBar_placeholder_marketing_resource,
		"en-GB": en_GB.organisms_searchBar_placeholder_marketing_resource,
		"en-US": en_US.organisms_searchBar_placeholder_marketing_resource,
		"es-ES": es_ES.organisms_searchBar_placeholder_marketing_resource,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_marketing_resource,
		"it-IT": it_IT.organisms_searchBar_placeholder_marketing_resource,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_marketing_resource,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_marketing_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_newsroom_article = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_newsroom_article,
		"en-AU": en_AU.organisms_searchBar_placeholder_newsroom_article,
		"en-GB": en_GB.organisms_searchBar_placeholder_newsroom_article,
		"en-US": en_US.organisms_searchBar_placeholder_newsroom_article,
		"es-ES": es_ES.organisms_searchBar_placeholder_newsroom_article,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_newsroom_article,
		"it-IT": it_IT.organisms_searchBar_placeholder_newsroom_article,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_newsroom_article,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_newsroom_article
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_partner_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_partner_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_partner_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_partner_page,
		"en-US": en_US.organisms_searchBar_placeholder_partner_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_partner_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_partner_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_partner_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_partner_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_partner_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_podcast_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_podcast_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_podcast_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_podcast_page,
		"en-US": en_US.organisms_searchBar_placeholder_podcast_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_podcast_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_podcast_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_podcast_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_podcast_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_podcast_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_product_update = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_product_update,
		"en-AU": en_AU.organisms_searchBar_placeholder_product_update,
		"en-GB": en_GB.organisms_searchBar_placeholder_product_update,
		"en-US": en_US.organisms_searchBar_placeholder_product_update,
		"es-ES": es_ES.organisms_searchBar_placeholder_product_update,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_product_update,
		"it-IT": it_IT.organisms_searchBar_placeholder_product_update,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_product_update,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_product_update
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_solutions_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_solutions_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_solutions_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_solutions_page,
		"en-US": en_US.organisms_searchBar_placeholder_solutions_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_solutions_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_solutions_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_solutions_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_solutions_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_solutions_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_success_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_searchBar_placeholder_success_page,
		"en-AU": en_AU.organisms_searchBar_placeholder_success_page,
		"en-GB": en_GB.organisms_searchBar_placeholder_success_page,
		"en-US": en_US.organisms_searchBar_placeholder_success_page,
		"es-ES": es_ES.organisms_searchBar_placeholder_success_page,
		"fr-FR": fr_FR.organisms_searchBar_placeholder_success_page,
		"it-IT": it_IT.organisms_searchBar_placeholder_success_page,
		"ko-KR": ko_KR.organisms_searchBar_placeholder_success_page,
		"pt-BR": pt_BR.organisms_searchBar_placeholder_success_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_post,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_post,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_post,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_post,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_post,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_post,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_post,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_post,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_post
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_case_study,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_case_study,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_case_study,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_case_study,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_case_study,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_case_study,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_case_study,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_case_study,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_case_study
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_product_update,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_product_update,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_product_update,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_product_update,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_product_update,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_product_update,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_product_update,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_product_update,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_product_update
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_marketing_resource,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_marketing_resource
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_newsroom_article,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_newsroom_article
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_podcast_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_podcast_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_compare_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_compare_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_compare_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_compare_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_compare_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_compare_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_compare_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_compare_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_compare_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_partner_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_partner_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_partner_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_partner_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_partner_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_partner_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_partner_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_partner_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_partner_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_solutions_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_solutions_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_postType_success_page,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_postType_success_page,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_postType_success_page,
		"en-US": en_US.pages_search_refinements_klaviyoHome_postType_success_page,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_postType_success_page,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_postType_success_page,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_postType_success_page,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_postType_success_page,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_postType_success_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.pages_search_refinements_klaviyoHome_category,
		"en-AU": en_AU.pages_search_refinements_klaviyoHome_category,
		"en-GB": en_GB.pages_search_refinements_klaviyoHome_category,
		"en-US": en_US.pages_search_refinements_klaviyoHome_category,
		"es-ES": es_ES.pages_search_refinements_klaviyoHome_category,
		"fr-FR": fr_FR.pages_search_refinements_klaviyoHome_category,
		"it-IT": it_IT.pages_search_refinements_klaviyoHome_category,
		"ko-KR": ko_KR.pages_search_refinements_klaviyoHome_category,
		"pt-BR": pt_BR.pages_search_refinements_klaviyoHome_category
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_headline,
		"en-AU": en_AU.academy_pages_bestPractices_headline,
		"en-GB": en_GB.academy_pages_bestPractices_headline,
		"en-US": en_US.academy_pages_bestPractices_headline,
		"es-ES": es_ES.academy_pages_bestPractices_headline,
		"fr-FR": fr_FR.academy_pages_bestPractices_headline,
		"it-IT": it_IT.academy_pages_bestPractices_headline,
		"ko-KR": ko_KR.academy_pages_bestPractices_headline,
		"pt-BR": pt_BR.academy_pages_bestPractices_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_subhead,
		"en-AU": en_AU.academy_pages_bestPractices_subhead,
		"en-GB": en_GB.academy_pages_bestPractices_subhead,
		"en-US": en_US.academy_pages_bestPractices_subhead,
		"es-ES": es_ES.academy_pages_bestPractices_subhead,
		"fr-FR": fr_FR.academy_pages_bestPractices_subhead,
		"it-IT": it_IT.academy_pages_bestPractices_subhead,
		"ko-KR": ko_KR.academy_pages_bestPractices_subhead,
		"pt-BR": pt_BR.academy_pages_bestPractices_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_headline,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_headline,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_headline,
		"en-US": en_US.academy_pages_bestPractices_tabs_headline,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_headline,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_headline,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_headline,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_headline,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab1_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab1_label,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab1_label,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab1_label,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab1_label,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab1_label,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab1_label,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab1_label,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab1_label,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab1_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab1_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab1_subhead,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab1_subhead,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab1_subhead,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab1_subhead,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab1_subhead,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab1_subhead,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab1_subhead,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab1_subhead,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab1_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab2_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab2_label,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab2_label,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab2_label,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab2_label,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab2_label,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab2_label,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab2_label,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab2_label,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab2_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab2_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab2_subhead,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab2_subhead,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab2_subhead,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab2_subhead,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab2_subhead,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab2_subhead,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab2_subhead,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab2_subhead,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab2_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab3_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab3_label,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab3_label,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab3_label,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab3_label,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab3_label,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab3_label,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab3_label,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab3_label,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab3_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab3_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab3_subhead,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab3_subhead,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab3_subhead,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab3_subhead,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab3_subhead,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab3_subhead,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab3_subhead,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab3_subhead,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab3_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab4_label = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab4_label,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab4_label,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab4_label,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab4_label,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab4_label,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab4_label,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab4_label,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab4_label,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab4_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_bestPractices_tabs_tab4_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_bestPractices_tabs_tab4_subhead,
		"en-AU": en_AU.academy_pages_bestPractices_tabs_tab4_subhead,
		"en-GB": en_GB.academy_pages_bestPractices_tabs_tab4_subhead,
		"en-US": en_US.academy_pages_bestPractices_tabs_tab4_subhead,
		"es-ES": es_ES.academy_pages_bestPractices_tabs_tab4_subhead,
		"fr-FR": fr_FR.academy_pages_bestPractices_tabs_tab4_subhead,
		"it-IT": it_IT.academy_pages_bestPractices_tabs_tab4_subhead,
		"ko-KR": ko_KR.academy_pages_bestPractices_tabs_tab4_subhead,
		"pt-BR": pt_BR.academy_pages_bestPractices_tabs_tab4_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_headlineText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_headlineText,
		"en-AU": en_AU.roiCalculator_results_headlineText,
		"en-GB": en_GB.roiCalculator_results_headlineText,
		"en-US": en_US.roiCalculator_results_headlineText,
		"es-ES": es_ES.roiCalculator_results_headlineText,
		"fr-FR": fr_FR.roiCalculator_results_headlineText,
		"it-IT": it_IT.roiCalculator_results_headlineText,
		"ko-KR": ko_KR.roiCalculator_results_headlineText,
		"pt-BR": pt_BR.roiCalculator_results_headlineText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_revenuePerYear = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_revenuePerYear,
		"en-AU": en_AU.roiCalculator_results_revenuePerYear,
		"en-GB": en_GB.roiCalculator_results_revenuePerYear,
		"en-US": en_US.roiCalculator_results_revenuePerYear,
		"es-ES": es_ES.roiCalculator_results_revenuePerYear,
		"fr-FR": fr_FR.roiCalculator_results_revenuePerYear,
		"it-IT": it_IT.roiCalculator_results_revenuePerYear,
		"ko-KR": ko_KR.roiCalculator_results_revenuePerYear,
		"pt-BR": pt_BR.roiCalculator_results_revenuePerYear
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_subHeadlineText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_subHeadlineText,
		"en-AU": en_AU.roiCalculator_results_subHeadlineText,
		"en-GB": en_GB.roiCalculator_results_subHeadlineText,
		"en-US": en_US.roiCalculator_results_subHeadlineText,
		"es-ES": es_ES.roiCalculator_results_subHeadlineText,
		"fr-FR": fr_FR.roiCalculator_results_subHeadlineText,
		"it-IT": it_IT.roiCalculator_results_subHeadlineText,
		"ko-KR": ko_KR.roiCalculator_results_subHeadlineText,
		"pt-BR": pt_BR.roiCalculator_results_subHeadlineText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_newSubscribers = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_newSubscribers,
		"en-AU": en_AU.roiCalculator_results_newSubscribers,
		"en-GB": en_GB.roiCalculator_results_newSubscribers,
		"en-US": en_US.roiCalculator_results_newSubscribers,
		"es-ES": es_ES.roiCalculator_results_newSubscribers,
		"fr-FR": fr_FR.roiCalculator_results_newSubscribers,
		"it-IT": it_IT.roiCalculator_results_newSubscribers,
		"ko-KR": ko_KR.roiCalculator_results_newSubscribers,
		"pt-BR": pt_BR.roiCalculator_results_newSubscribers
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_campaigns = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_campaigns,
		"en-AU": en_AU.roiCalculator_results_campaigns,
		"en-GB": en_GB.roiCalculator_results_campaigns,
		"en-US": en_US.roiCalculator_results_campaigns,
		"es-ES": es_ES.roiCalculator_results_campaigns,
		"fr-FR": fr_FR.roiCalculator_results_campaigns,
		"it-IT": it_IT.roiCalculator_results_campaigns,
		"ko-KR": ko_KR.roiCalculator_results_campaigns,
		"pt-BR": pt_BR.roiCalculator_results_campaigns
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_automatedFlows = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_automatedFlows,
		"en-AU": en_AU.roiCalculator_results_automatedFlows,
		"en-GB": en_GB.roiCalculator_results_automatedFlows,
		"en-US": en_US.roiCalculator_results_automatedFlows,
		"es-ES": es_ES.roiCalculator_results_automatedFlows,
		"fr-FR": fr_FR.roiCalculator_results_automatedFlows,
		"it-IT": it_IT.roiCalculator_results_automatedFlows,
		"ko-KR": ko_KR.roiCalculator_results_automatedFlows,
		"pt-BR": pt_BR.roiCalculator_results_automatedFlows
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_signupText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_signupText,
		"en-AU": en_AU.roiCalculator_results_signupText,
		"en-GB": en_GB.roiCalculator_results_signupText,
		"en-US": en_US.roiCalculator_results_signupText,
		"es-ES": es_ES.roiCalculator_results_signupText,
		"fr-FR": fr_FR.roiCalculator_results_signupText,
		"it-IT": it_IT.roiCalculator_results_signupText,
		"ko-KR": ko_KR.roiCalculator_results_signupText,
		"pt-BR": pt_BR.roiCalculator_results_signupText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_getStartedButton = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_getStartedButton,
		"en-AU": en_AU.roiCalculator_results_getStartedButton,
		"en-GB": en_GB.roiCalculator_results_getStartedButton,
		"en-US": en_US.roiCalculator_results_getStartedButton,
		"es-ES": es_ES.roiCalculator_results_getStartedButton,
		"fr-FR": fr_FR.roiCalculator_results_getStartedButton,
		"it-IT": it_IT.roiCalculator_results_getStartedButton,
		"ko-KR": ko_KR.roiCalculator_results_getStartedButton,
		"pt-BR": pt_BR.roiCalculator_results_getStartedButton
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_talkToSales = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_talkToSales,
		"en-AU": en_AU.roiCalculator_results_talkToSales,
		"en-GB": en_GB.roiCalculator_results_talkToSales,
		"en-US": en_US.roiCalculator_results_talkToSales,
		"es-ES": es_ES.roiCalculator_results_talkToSales,
		"fr-FR": fr_FR.roiCalculator_results_talkToSales,
		"it-IT": it_IT.roiCalculator_results_talkToSales,
		"ko-KR": ko_KR.roiCalculator_results_talkToSales,
		"pt-BR": pt_BR.roiCalculator_results_talkToSales
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_invalidRoi = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_invalidRoi,
		"en-AU": en_AU.roiCalculator_results_invalidRoi,
		"en-GB": en_GB.roiCalculator_results_invalidRoi,
		"en-US": en_US.roiCalculator_results_invalidRoi,
		"es-ES": es_ES.roiCalculator_results_invalidRoi,
		"fr-FR": fr_FR.roiCalculator_results_invalidRoi,
		"it-IT": it_IT.roiCalculator_results_invalidRoi,
		"ko-KR": ko_KR.roiCalculator_results_invalidRoi,
		"pt-BR": pt_BR.roiCalculator_results_invalidRoi
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_freeTier = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_results_freeTier,
		"en-AU": en_AU.roiCalculator_results_freeTier,
		"en-GB": en_GB.roiCalculator_results_freeTier,
		"en-US": en_US.roiCalculator_results_freeTier,
		"es-ES": es_ES.roiCalculator_results_freeTier,
		"fr-FR": fr_FR.roiCalculator_results_freeTier,
		"it-IT": it_IT.roiCalculator_results_freeTier,
		"ko-KR": ko_KR.roiCalculator_results_freeTier,
		"pt-BR": pt_BR.roiCalculator_results_freeTier
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_brandText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_brandText,
		"en-AU": en_AU.roiCalculator_form_brandText,
		"en-GB": en_GB.roiCalculator_form_brandText,
		"en-US": en_US.roiCalculator_form_brandText,
		"es-ES": es_ES.roiCalculator_form_brandText,
		"fr-FR": fr_FR.roiCalculator_form_brandText,
		"it-IT": it_IT.roiCalculator_form_brandText,
		"ko-KR": ko_KR.roiCalculator_form_brandText,
		"pt-BR": pt_BR.roiCalculator_form_brandText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_fieldsRequired = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_fieldsRequired,
		"en-AU": en_AU.roiCalculator_form_fieldsRequired,
		"en-GB": en_GB.roiCalculator_form_fieldsRequired,
		"en-US": en_US.roiCalculator_form_fieldsRequired,
		"es-ES": es_ES.roiCalculator_form_fieldsRequired,
		"fr-FR": fr_FR.roiCalculator_form_fieldsRequired,
		"it-IT": it_IT.roiCalculator_form_fieldsRequired,
		"ko-KR": ko_KR.roiCalculator_form_fieldsRequired,
		"pt-BR": pt_BR.roiCalculator_form_fieldsRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_channelsUsed = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_channelsUsed,
		"en-AU": en_AU.roiCalculator_form_channelsUsed,
		"en-GB": en_GB.roiCalculator_form_channelsUsed,
		"en-US": en_US.roiCalculator_form_channelsUsed,
		"es-ES": es_ES.roiCalculator_form_channelsUsed,
		"fr-FR": fr_FR.roiCalculator_form_channelsUsed,
		"it-IT": it_IT.roiCalculator_form_channelsUsed,
		"ko-KR": ko_KR.roiCalculator_form_channelsUsed,
		"pt-BR": pt_BR.roiCalculator_form_channelsUsed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmail = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_toggleEmail,
		"en-AU": en_AU.roiCalculator_form_toggleEmail,
		"en-GB": en_GB.roiCalculator_form_toggleEmail,
		"en-US": en_US.roiCalculator_form_toggleEmail,
		"es-ES": es_ES.roiCalculator_form_toggleEmail,
		"fr-FR": fr_FR.roiCalculator_form_toggleEmail,
		"it-IT": it_IT.roiCalculator_form_toggleEmail,
		"ko-KR": ko_KR.roiCalculator_form_toggleEmail,
		"pt-BR": pt_BR.roiCalculator_form_toggleEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmailAndSms = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_toggleEmailAndSms,
		"en-AU": en_AU.roiCalculator_form_toggleEmailAndSms,
		"en-GB": en_GB.roiCalculator_form_toggleEmailAndSms,
		"en-US": en_US.roiCalculator_form_toggleEmailAndSms,
		"es-ES": es_ES.roiCalculator_form_toggleEmailAndSms,
		"fr-FR": fr_FR.roiCalculator_form_toggleEmailAndSms,
		"it-IT": it_IT.roiCalculator_form_toggleEmailAndSms,
		"ko-KR": ko_KR.roiCalculator_form_toggleEmailAndSms,
		"pt-BR": pt_BR.roiCalculator_form_toggleEmailAndSms
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputActiveProfiles = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputActiveProfiles,
		"en-AU": en_AU.roiCalculator_form_inputActiveProfiles,
		"en-GB": en_GB.roiCalculator_form_inputActiveProfiles,
		"en-US": en_US.roiCalculator_form_inputActiveProfiles,
		"es-ES": es_ES.roiCalculator_form_inputActiveProfiles,
		"fr-FR": fr_FR.roiCalculator_form_inputActiveProfiles,
		"it-IT": it_IT.roiCalculator_form_inputActiveProfiles,
		"ko-KR": ko_KR.roiCalculator_form_inputActiveProfiles,
		"pt-BR": pt_BR.roiCalculator_form_inputActiveProfiles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterActiveProfiles = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterActiveProfiles,
		"en-AU": en_AU.roiCalculator_form_inputEnterActiveProfiles,
		"en-GB": en_GB.roiCalculator_form_inputEnterActiveProfiles,
		"en-US": en_US.roiCalculator_form_inputEnterActiveProfiles,
		"es-ES": es_ES.roiCalculator_form_inputEnterActiveProfiles,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterActiveProfiles,
		"it-IT": it_IT.roiCalculator_form_inputEnterActiveProfiles,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterActiveProfiles,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterActiveProfiles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputMonthlyWebVisitors = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputMonthlyWebVisitors,
		"en-AU": en_AU.roiCalculator_form_inputMonthlyWebVisitors,
		"en-GB": en_GB.roiCalculator_form_inputMonthlyWebVisitors,
		"en-US": en_US.roiCalculator_form_inputMonthlyWebVisitors,
		"es-ES": es_ES.roiCalculator_form_inputMonthlyWebVisitors,
		"fr-FR": fr_FR.roiCalculator_form_inputMonthlyWebVisitors,
		"it-IT": it_IT.roiCalculator_form_inputMonthlyWebVisitors,
		"ko-KR": ko_KR.roiCalculator_form_inputMonthlyWebVisitors,
		"pt-BR": pt_BR.roiCalculator_form_inputMonthlyWebVisitors
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterMonthlyWebVisitors = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"en-AU": en_AU.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"en-GB": en_GB.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"en-US": en_US.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"es-ES": es_ES.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"it-IT": it_IT.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterMonthlyWebVisitors,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterMonthlyWebVisitors
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputAverageOrderValue = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputAverageOrderValue,
		"en-AU": en_AU.roiCalculator_form_inputAverageOrderValue,
		"en-GB": en_GB.roiCalculator_form_inputAverageOrderValue,
		"en-US": en_US.roiCalculator_form_inputAverageOrderValue,
		"es-ES": es_ES.roiCalculator_form_inputAverageOrderValue,
		"fr-FR": fr_FR.roiCalculator_form_inputAverageOrderValue,
		"it-IT": it_IT.roiCalculator_form_inputAverageOrderValue,
		"ko-KR": ko_KR.roiCalculator_form_inputAverageOrderValue,
		"pt-BR": pt_BR.roiCalculator_form_inputAverageOrderValue
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterAverageOrderValue = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterAverageOrderValue,
		"en-AU": en_AU.roiCalculator_form_inputEnterAverageOrderValue,
		"en-GB": en_GB.roiCalculator_form_inputEnterAverageOrderValue,
		"en-US": en_US.roiCalculator_form_inputEnterAverageOrderValue,
		"es-ES": es_ES.roiCalculator_form_inputEnterAverageOrderValue,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterAverageOrderValue,
		"it-IT": it_IT.roiCalculator_form_inputEnterAverageOrderValue,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterAverageOrderValue,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterAverageOrderValue
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputOrdersPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputOrdersPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputOrdersPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputOrdersPerMonth,
		"en-US": en_US.roiCalculator_form_inputOrdersPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputOrdersPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputOrdersPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputOrdersPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputOrdersPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputOrdersPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterOrdersPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterOrdersPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputEnterOrdersPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputEnterOrdersPerMonth,
		"en-US": en_US.roiCalculator_form_inputEnterOrdersPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputEnterOrdersPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterOrdersPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputEnterOrdersPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterOrdersPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterOrdersPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputCampaignsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputCampaignsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputCampaignsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputCampaignsPerMonth,
		"en-US": en_US.roiCalculator_form_inputCampaignsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputCampaignsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputCampaignsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputCampaignsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputCampaignsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputCampaignsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterCampaignsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterCampaignsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputEnterCampaignsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputEnterCampaignsPerMonth,
		"en-US": en_US.roiCalculator_form_inputEnterCampaignsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputEnterCampaignsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterCampaignsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputEnterCampaignsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterCampaignsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterCampaignsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputFlowsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputFlowsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputFlowsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputFlowsPerMonth,
		"en-US": en_US.roiCalculator_form_inputFlowsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputFlowsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputFlowsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputFlowsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputFlowsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputFlowsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterFlowsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterFlowsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputEnterFlowsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputEnterFlowsPerMonth,
		"en-US": en_US.roiCalculator_form_inputEnterFlowsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputEnterFlowsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterFlowsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputEnterFlowsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterFlowsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterFlowsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputSmsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputSmsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputSmsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputSmsPerMonth,
		"en-US": en_US.roiCalculator_form_inputSmsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputSmsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputSmsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputSmsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputSmsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputSmsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterSmsPerMonth = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputEnterSmsPerMonth,
		"en-AU": en_AU.roiCalculator_form_inputEnterSmsPerMonth,
		"en-GB": en_GB.roiCalculator_form_inputEnterSmsPerMonth,
		"en-US": en_US.roiCalculator_form_inputEnterSmsPerMonth,
		"es-ES": es_ES.roiCalculator_form_inputEnterSmsPerMonth,
		"fr-FR": fr_FR.roiCalculator_form_inputEnterSmsPerMonth,
		"it-IT": it_IT.roiCalculator_form_inputEnterSmsPerMonth,
		"ko-KR": ko_KR.roiCalculator_form_inputEnterSmsPerMonth,
		"pt-BR": pt_BR.roiCalculator_form_inputEnterSmsPerMonth
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_roiButton = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_roiButton,
		"en-AU": en_AU.roiCalculator_form_roiButton,
		"en-GB": en_GB.roiCalculator_form_roiButton,
		"en-US": en_US.roiCalculator_form_roiButton,
		"es-ES": es_ES.roiCalculator_form_roiButton,
		"fr-FR": fr_FR.roiCalculator_form_roiButton,
		"it-IT": it_IT.roiCalculator_form_roiButton,
		"ko-KR": ko_KR.roiCalculator_form_roiButton,
		"pt-BR": pt_BR.roiCalculator_form_roiButton
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputPrefix = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.roiCalculator_form_inputPrefix,
		"en-AU": en_AU.roiCalculator_form_inputPrefix,
		"en-GB": en_GB.roiCalculator_form_inputPrefix,
		"en-US": en_US.roiCalculator_form_inputPrefix,
		"es-ES": es_ES.roiCalculator_form_inputPrefix,
		"fr-FR": fr_FR.roiCalculator_form_inputPrefix,
		"it-IT": it_IT.roiCalculator_form_inputPrefix,
		"ko-KR": ko_KR.roiCalculator_form_inputPrefix,
		"pt-BR": pt_BR.roiCalculator_form_inputPrefix
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_hero_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_hero_headline,
		"en-AU": en_AU.academy_pages_cred_landing_hero_headline,
		"en-GB": en_GB.academy_pages_cred_landing_hero_headline,
		"en-US": en_US.academy_pages_cred_landing_hero_headline,
		"es-ES": es_ES.academy_pages_cred_landing_hero_headline,
		"fr-FR": fr_FR.academy_pages_cred_landing_hero_headline,
		"it-IT": it_IT.academy_pages_cred_landing_hero_headline,
		"ko-KR": ko_KR.academy_pages_cred_landing_hero_headline,
		"pt-BR": pt_BR.academy_pages_cred_landing_hero_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_hero_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_hero_subhead,
		"en-AU": en_AU.academy_pages_cred_landing_hero_subhead,
		"en-GB": en_GB.academy_pages_cred_landing_hero_subhead,
		"en-US": en_US.academy_pages_cred_landing_hero_subhead,
		"es-ES": es_ES.academy_pages_cred_landing_hero_subhead,
		"fr-FR": fr_FR.academy_pages_cred_landing_hero_subhead,
		"it-IT": it_IT.academy_pages_cred_landing_hero_subhead,
		"ko-KR": ko_KR.academy_pages_cred_landing_hero_subhead,
		"pt-BR": pt_BR.academy_pages_cred_landing_hero_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_header = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_header,
		"en-AU": en_AU.academy_pages_cred_landing_cta_header,
		"en-GB": en_GB.academy_pages_cred_landing_cta_header,
		"en-US": en_US.academy_pages_cred_landing_cta_header,
		"es-ES": es_ES.academy_pages_cred_landing_cta_header,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_header,
		"it-IT": it_IT.academy_pages_cred_landing_cta_header,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_header,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_header
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card1_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card1_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card1_title,
		"en-US": en_US.academy_pages_cred_landing_cta_card1_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card1_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card1_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card1_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card1_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card1_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card1_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card1_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card1_body,
		"en-US": en_US.academy_pages_cred_landing_cta_card1_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card1_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card1_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card1_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card1_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card1_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card2_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card2_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card2_title,
		"en-US": en_US.academy_pages_cred_landing_cta_card2_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card2_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card2_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card2_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card2_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card2_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card2_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card2_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card2_body,
		"en-US": en_US.academy_pages_cred_landing_cta_card2_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card2_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card2_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card2_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card2_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card2_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card3_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card3_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card3_title,
		"en-US": en_US.academy_pages_cred_landing_cta_card3_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card3_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card3_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card3_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card3_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta_card3_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta_card3_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta_card3_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta_card3_body,
		"en-US": en_US.academy_pages_cred_landing_cta_card3_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta_card3_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta_card3_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta_card3_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta_card3_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta_card3_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cred_cards_button_text_collapse = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"en-AU": en_AU.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"en-GB": en_GB.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"en-US": en_US.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"es-ES": es_ES.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"fr-FR": fr_FR.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"it-IT": it_IT.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"ko-KR": ko_KR.academy_pages_cred_landing_cred_cards_button_text_collapse,
		"pt-BR": pt_BR.academy_pages_cred_landing_cred_cards_button_text_collapse
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cred_cards_button_text_expand = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cred_cards_button_text_expand,
		"en-AU": en_AU.academy_pages_cred_landing_cred_cards_button_text_expand,
		"en-GB": en_GB.academy_pages_cred_landing_cred_cards_button_text_expand,
		"en-US": en_US.academy_pages_cred_landing_cred_cards_button_text_expand,
		"es-ES": es_ES.academy_pages_cred_landing_cred_cards_button_text_expand,
		"fr-FR": fr_FR.academy_pages_cred_landing_cred_cards_button_text_expand,
		"it-IT": it_IT.academy_pages_cred_landing_cred_cards_button_text_expand,
		"ko-KR": ko_KR.academy_pages_cred_landing_cred_cards_button_text_expand,
		"pt-BR": pt_BR.academy_pages_cred_landing_cred_cards_button_text_expand
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cred_cards_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cred_cards_title,
		"en-AU": en_AU.academy_pages_cred_landing_cred_cards_title,
		"en-GB": en_GB.academy_pages_cred_landing_cred_cards_title,
		"en-US": en_US.academy_pages_cred_landing_cred_cards_title,
		"es-ES": es_ES.academy_pages_cred_landing_cred_cards_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cred_cards_title,
		"it-IT": it_IT.academy_pages_cred_landing_cred_cards_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cred_cards_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cred_cards_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cred_cards_subtitle = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cred_cards_subtitle,
		"en-AU": en_AU.academy_pages_cred_landing_cred_cards_subtitle,
		"en-GB": en_GB.academy_pages_cred_landing_cred_cards_subtitle,
		"en-US": en_US.academy_pages_cred_landing_cred_cards_subtitle,
		"es-ES": es_ES.academy_pages_cred_landing_cred_cards_subtitle,
		"fr-FR": fr_FR.academy_pages_cred_landing_cred_cards_subtitle,
		"it-IT": it_IT.academy_pages_cred_landing_cred_cards_subtitle,
		"ko-KR": ko_KR.academy_pages_cred_landing_cred_cards_subtitle,
		"pt-BR": pt_BR.academy_pages_cred_landing_cred_cards_subtitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_title,
		"en-US": en_US.academy_pages_cred_landing_cta2_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card1_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card1_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card1_title,
		"en-US": en_US.academy_pages_cred_landing_cta2_card1_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card1_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card1_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card1_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card1_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card1_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card1_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card1_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card1_body,
		"en-US": en_US.academy_pages_cred_landing_cta2_card1_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card1_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card1_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card1_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card1_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card1_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card2_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card2_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card2_title,
		"en-US": en_US.academy_pages_cred_landing_cta2_card2_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card2_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card2_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card2_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card2_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card2_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card2_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card2_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card2_body,
		"en-US": en_US.academy_pages_cred_landing_cta2_card2_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card2_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card2_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card2_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card2_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card2_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card3_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card3_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card3_title,
		"en-US": en_US.academy_pages_cred_landing_cta2_card3_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card3_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card3_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card3_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card3_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card3_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card3_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card3_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card3_body,
		"en-US": en_US.academy_pages_cred_landing_cta2_card3_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card3_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card3_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card3_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card3_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card3_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card4_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card4_title,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card4_title,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card4_title,
		"en-US": en_US.academy_pages_cred_landing_cta2_card4_title,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card4_title,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card4_title,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card4_title,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card4_title,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card4_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_cta2_card4_body = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_cta2_card4_body,
		"en-AU": en_AU.academy_pages_cred_landing_cta2_card4_body,
		"en-GB": en_GB.academy_pages_cred_landing_cta2_card4_body,
		"en-US": en_US.academy_pages_cred_landing_cta2_card4_body,
		"es-ES": es_ES.academy_pages_cred_landing_cta2_card4_body,
		"fr-FR": fr_FR.academy_pages_cred_landing_cta2_card4_body,
		"it-IT": it_IT.academy_pages_cred_landing_cta2_card4_body,
		"ko-KR": ko_KR.academy_pages_cred_landing_cta2_card4_body,
		"pt-BR": pt_BR.academy_pages_cred_landing_cta2_card4_body
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_landing_34 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_landing_34,
		"en-AU": en_AU.academy_pages_cred_landing_34,
		"en-GB": en_GB.academy_pages_cred_landing_34,
		"en-US": en_US.academy_pages_cred_landing_34,
		"es-ES": es_ES.academy_pages_cred_landing_34,
		"fr-FR": fr_FR.academy_pages_cred_landing_34,
		"it-IT": it_IT.academy_pages_cred_landing_34,
		"ko-KR": ko_KR.academy_pages_cred_landing_34,
		"pt-BR": pt_BR.academy_pages_cred_landing_34
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_headline,
		"en-AU": en_AU.academy_pages_cred_faq_headline,
		"en-GB": en_GB.academy_pages_cred_faq_headline,
		"en-US": en_US.academy_pages_cred_faq_headline,
		"es-ES": es_ES.academy_pages_cred_faq_headline,
		"fr-FR": fr_FR.academy_pages_cred_faq_headline,
		"it-IT": it_IT.academy_pages_cred_faq_headline,
		"ko-KR": ko_KR.academy_pages_cred_faq_headline,
		"pt-BR": pt_BR.academy_pages_cred_faq_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_subhead = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_subhead,
		"en-AU": en_AU.academy_pages_cred_faq_subhead,
		"en-GB": en_GB.academy_pages_cred_faq_subhead,
		"en-US": en_US.academy_pages_cred_faq_subhead,
		"es-ES": es_ES.academy_pages_cred_faq_subhead,
		"fr-FR": fr_FR.academy_pages_cred_faq_subhead,
		"it-IT": it_IT.academy_pages_cred_faq_subhead,
		"ko-KR": ko_KR.academy_pages_cred_faq_subhead,
		"pt-BR": pt_BR.academy_pages_cred_faq_subhead
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row0_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row0_title,
		"en-AU": en_AU.academy_pages_cred_faq_row0_title,
		"en-GB": en_GB.academy_pages_cred_faq_row0_title,
		"en-US": en_US.academy_pages_cred_faq_row0_title,
		"es-ES": es_ES.academy_pages_cred_faq_row0_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row0_title,
		"it-IT": it_IT.academy_pages_cred_faq_row0_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row0_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row0_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row0_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row0_content,
		"en-AU": en_AU.academy_pages_cred_faq_row0_content,
		"en-GB": en_GB.academy_pages_cred_faq_row0_content,
		"en-US": en_US.academy_pages_cred_faq_row0_content,
		"es-ES": es_ES.academy_pages_cred_faq_row0_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row0_content,
		"it-IT": it_IT.academy_pages_cred_faq_row0_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row0_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row0_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row1_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row1_title,
		"en-AU": en_AU.academy_pages_cred_faq_row1_title,
		"en-GB": en_GB.academy_pages_cred_faq_row1_title,
		"en-US": en_US.academy_pages_cred_faq_row1_title,
		"es-ES": es_ES.academy_pages_cred_faq_row1_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row1_title,
		"it-IT": it_IT.academy_pages_cred_faq_row1_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row1_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row1_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row1_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row1_content,
		"en-AU": en_AU.academy_pages_cred_faq_row1_content,
		"en-GB": en_GB.academy_pages_cred_faq_row1_content,
		"en-US": en_US.academy_pages_cred_faq_row1_content,
		"es-ES": es_ES.academy_pages_cred_faq_row1_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row1_content,
		"it-IT": it_IT.academy_pages_cred_faq_row1_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row1_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row1_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row2_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row2_title,
		"en-AU": en_AU.academy_pages_cred_faq_row2_title,
		"en-GB": en_GB.academy_pages_cred_faq_row2_title,
		"en-US": en_US.academy_pages_cred_faq_row2_title,
		"es-ES": es_ES.academy_pages_cred_faq_row2_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row2_title,
		"it-IT": it_IT.academy_pages_cred_faq_row2_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row2_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row2_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row2_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row2_content,
		"en-AU": en_AU.academy_pages_cred_faq_row2_content,
		"en-GB": en_GB.academy_pages_cred_faq_row2_content,
		"en-US": en_US.academy_pages_cred_faq_row2_content,
		"es-ES": es_ES.academy_pages_cred_faq_row2_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row2_content,
		"it-IT": it_IT.academy_pages_cred_faq_row2_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row2_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row2_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row3_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row3_title,
		"en-AU": en_AU.academy_pages_cred_faq_row3_title,
		"en-GB": en_GB.academy_pages_cred_faq_row3_title,
		"en-US": en_US.academy_pages_cred_faq_row3_title,
		"es-ES": es_ES.academy_pages_cred_faq_row3_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row3_title,
		"it-IT": it_IT.academy_pages_cred_faq_row3_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row3_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row3_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row3_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row3_content,
		"en-AU": en_AU.academy_pages_cred_faq_row3_content,
		"en-GB": en_GB.academy_pages_cred_faq_row3_content,
		"en-US": en_US.academy_pages_cred_faq_row3_content,
		"es-ES": es_ES.academy_pages_cred_faq_row3_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row3_content,
		"it-IT": it_IT.academy_pages_cred_faq_row3_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row3_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row3_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row4_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row4_title,
		"en-AU": en_AU.academy_pages_cred_faq_row4_title,
		"en-GB": en_GB.academy_pages_cred_faq_row4_title,
		"en-US": en_US.academy_pages_cred_faq_row4_title,
		"es-ES": es_ES.academy_pages_cred_faq_row4_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row4_title,
		"it-IT": it_IT.academy_pages_cred_faq_row4_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row4_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row4_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row4_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row4_content,
		"en-AU": en_AU.academy_pages_cred_faq_row4_content,
		"en-GB": en_GB.academy_pages_cred_faq_row4_content,
		"en-US": en_US.academy_pages_cred_faq_row4_content,
		"es-ES": es_ES.academy_pages_cred_faq_row4_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row4_content,
		"it-IT": it_IT.academy_pages_cred_faq_row4_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row4_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row4_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row5_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row5_title,
		"en-AU": en_AU.academy_pages_cred_faq_row5_title,
		"en-GB": en_GB.academy_pages_cred_faq_row5_title,
		"en-US": en_US.academy_pages_cred_faq_row5_title,
		"es-ES": es_ES.academy_pages_cred_faq_row5_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row5_title,
		"it-IT": it_IT.academy_pages_cred_faq_row5_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row5_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row5_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row5_content = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row5_content,
		"en-AU": en_AU.academy_pages_cred_faq_row5_content,
		"en-GB": en_GB.academy_pages_cred_faq_row5_content,
		"en-US": en_US.academy_pages_cred_faq_row5_content,
		"es-ES": es_ES.academy_pages_cred_faq_row5_content,
		"fr-FR": fr_FR.academy_pages_cred_faq_row5_content,
		"it-IT": it_IT.academy_pages_cred_faq_row5_content,
		"ko-KR": ko_KR.academy_pages_cred_faq_row5_content,
		"pt-BR": pt_BR.academy_pages_cred_faq_row5_content
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_title,
		"en-AU": en_AU.academy_pages_cred_faq_row6_title,
		"en-GB": en_GB.academy_pages_cred_faq_row6_title,
		"en-US": en_US.academy_pages_cred_faq_row6_title,
		"es-ES": es_ES.academy_pages_cred_faq_row6_title,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_title,
		"it-IT": it_IT.academy_pages_cred_faq_row6_title,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_title,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_0 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_0,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_0,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_0,
		"en-US": en_US.academy_pages_cred_faq_row6_page_0,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_0,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_0,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_0,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_0,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_0
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_1,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_1,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_1,
		"en-US": en_US.academy_pages_cred_faq_row6_page_1,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_1,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_1,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_1,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_1,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_2,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_2,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_2,
		"en-US": en_US.academy_pages_cred_faq_row6_page_2,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_2,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_2,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_2,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_2,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_3,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_3,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_3,
		"en-US": en_US.academy_pages_cred_faq_row6_page_3,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_3,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_3,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_3,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_3,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_4 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_4,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_4,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_4,
		"en-US": en_US.academy_pages_cred_faq_row6_page_4,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_4,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_4,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_4,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_4,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_4
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_5 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_5,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_5,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_5,
		"en-US": en_US.academy_pages_cred_faq_row6_page_5,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_5,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_5,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_5,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_5,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_5
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_page_6 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_page_6,
		"en-AU": en_AU.academy_pages_cred_faq_row6_page_6,
		"en-GB": en_GB.academy_pages_cred_faq_row6_page_6,
		"en-US": en_US.academy_pages_cred_faq_row6_page_6,
		"es-ES": es_ES.academy_pages_cred_faq_row6_page_6,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_page_6,
		"it-IT": it_IT.academy_pages_cred_faq_row6_page_6,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_page_6,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_page_6
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_content_wallet_0 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_content_wallet_0,
		"en-AU": en_AU.academy_pages_cred_faq_row6_content_wallet_0,
		"en-GB": en_GB.academy_pages_cred_faq_row6_content_wallet_0,
		"en-US": en_US.academy_pages_cred_faq_row6_content_wallet_0,
		"es-ES": es_ES.academy_pages_cred_faq_row6_content_wallet_0,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_content_wallet_0,
		"it-IT": it_IT.academy_pages_cred_faq_row6_content_wallet_0,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_content_wallet_0,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_content_wallet_0
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_content_wallet_1 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_content_wallet_1,
		"en-AU": en_AU.academy_pages_cred_faq_row6_content_wallet_1,
		"en-GB": en_GB.academy_pages_cred_faq_row6_content_wallet_1,
		"en-US": en_US.academy_pages_cred_faq_row6_content_wallet_1,
		"es-ES": es_ES.academy_pages_cred_faq_row6_content_wallet_1,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_content_wallet_1,
		"it-IT": it_IT.academy_pages_cred_faq_row6_content_wallet_1,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_content_wallet_1,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_content_wallet_1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_content_wallet_2 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_content_wallet_2,
		"en-AU": en_AU.academy_pages_cred_faq_row6_content_wallet_2,
		"en-GB": en_GB.academy_pages_cred_faq_row6_content_wallet_2,
		"en-US": en_US.academy_pages_cred_faq_row6_content_wallet_2,
		"es-ES": es_ES.academy_pages_cred_faq_row6_content_wallet_2,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_content_wallet_2,
		"it-IT": it_IT.academy_pages_cred_faq_row6_content_wallet_2,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_content_wallet_2,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_content_wallet_2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_faq_row6_content_wallet_3 = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_faq_row6_content_wallet_3,
		"en-AU": en_AU.academy_pages_cred_faq_row6_content_wallet_3,
		"en-GB": en_GB.academy_pages_cred_faq_row6_content_wallet_3,
		"en-US": en_US.academy_pages_cred_faq_row6_content_wallet_3,
		"es-ES": es_ES.academy_pages_cred_faq_row6_content_wallet_3,
		"fr-FR": fr_FR.academy_pages_cred_faq_row6_content_wallet_3,
		"it-IT": it_IT.academy_pages_cred_faq_row6_content_wallet_3,
		"ko-KR": ko_KR.academy_pages_cred_faq_row6_content_wallet_3,
		"pt-BR": pt_BR.academy_pages_cred_faq_row6_content_wallet_3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row1_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row1_headline,
		"en-AU": en_AU.academy_pages_cred_testimonials_row1_headline,
		"en-GB": en_GB.academy_pages_cred_testimonials_row1_headline,
		"en-US": en_US.academy_pages_cred_testimonials_row1_headline,
		"es-ES": es_ES.academy_pages_cred_testimonials_row1_headline,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row1_headline,
		"it-IT": it_IT.academy_pages_cred_testimonials_row1_headline,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row1_headline,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row1_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row1_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row1_eyebrow,
		"en-AU": en_AU.academy_pages_cred_testimonials_row1_eyebrow,
		"en-GB": en_GB.academy_pages_cred_testimonials_row1_eyebrow,
		"en-US": en_US.academy_pages_cred_testimonials_row1_eyebrow,
		"es-ES": es_ES.academy_pages_cred_testimonials_row1_eyebrow,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row1_eyebrow,
		"it-IT": it_IT.academy_pages_cred_testimonials_row1_eyebrow,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row1_eyebrow,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row1_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row2_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row2_headline,
		"en-AU": en_AU.academy_pages_cred_testimonials_row2_headline,
		"en-GB": en_GB.academy_pages_cred_testimonials_row2_headline,
		"en-US": en_US.academy_pages_cred_testimonials_row2_headline,
		"es-ES": es_ES.academy_pages_cred_testimonials_row2_headline,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row2_headline,
		"it-IT": it_IT.academy_pages_cred_testimonials_row2_headline,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row2_headline,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row2_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row2_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row2_eyebrow,
		"en-AU": en_AU.academy_pages_cred_testimonials_row2_eyebrow,
		"en-GB": en_GB.academy_pages_cred_testimonials_row2_eyebrow,
		"en-US": en_US.academy_pages_cred_testimonials_row2_eyebrow,
		"es-ES": es_ES.academy_pages_cred_testimonials_row2_eyebrow,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row2_eyebrow,
		"it-IT": it_IT.academy_pages_cred_testimonials_row2_eyebrow,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row2_eyebrow,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row2_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row3_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row3_headline,
		"en-AU": en_AU.academy_pages_cred_testimonials_row3_headline,
		"en-GB": en_GB.academy_pages_cred_testimonials_row3_headline,
		"en-US": en_US.academy_pages_cred_testimonials_row3_headline,
		"es-ES": es_ES.academy_pages_cred_testimonials_row3_headline,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row3_headline,
		"it-IT": it_IT.academy_pages_cred_testimonials_row3_headline,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row3_headline,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row3_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_testimonials_row3_eyebrow = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_testimonials_row3_eyebrow,
		"en-AU": en_AU.academy_pages_cred_testimonials_row3_eyebrow,
		"en-GB": en_GB.academy_pages_cred_testimonials_row3_eyebrow,
		"en-US": en_US.academy_pages_cred_testimonials_row3_eyebrow,
		"es-ES": es_ES.academy_pages_cred_testimonials_row3_eyebrow,
		"fr-FR": fr_FR.academy_pages_cred_testimonials_row3_eyebrow,
		"it-IT": it_IT.academy_pages_cred_testimonials_row3_eyebrow,
		"ko-KR": ko_KR.academy_pages_cred_testimonials_row3_eyebrow,
		"pt-BR": pt_BR.academy_pages_cred_testimonials_row3_eyebrow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_product_certificate_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_product_certificate_title,
		"en-AU": en_AU.academy_pages_cred_card_product_certificate_title,
		"en-GB": en_GB.academy_pages_cred_card_product_certificate_title,
		"en-US": en_US.academy_pages_cred_card_product_certificate_title,
		"es-ES": es_ES.academy_pages_cred_card_product_certificate_title,
		"fr-FR": fr_FR.academy_pages_cred_card_product_certificate_title,
		"it-IT": it_IT.academy_pages_cred_card_product_certificate_title,
		"ko-KR": ko_KR.academy_pages_cred_card_product_certificate_title,
		"pt-BR": pt_BR.academy_pages_cred_card_product_certificate_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_product_certificate_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_product_certificate_description,
		"en-AU": en_AU.academy_pages_cred_card_product_certificate_description,
		"en-GB": en_GB.academy_pages_cred_card_product_certificate_description,
		"en-US": en_US.academy_pages_cred_card_product_certificate_description,
		"es-ES": es_ES.academy_pages_cred_card_product_certificate_description,
		"fr-FR": fr_FR.academy_pages_cred_card_product_certificate_description,
		"it-IT": it_IT.academy_pages_cred_card_product_certificate_description,
		"ko-KR": ko_KR.academy_pages_cred_card_product_certificate_description,
		"pt-BR": pt_BR.academy_pages_cred_card_product_certificate_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_product_certificate_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_product_certificate_link,
		"en-AU": en_AU.academy_pages_cred_card_product_certificate_link,
		"en-GB": en_GB.academy_pages_cred_card_product_certificate_link,
		"en-US": en_US.academy_pages_cred_card_product_certificate_link,
		"es-ES": es_ES.academy_pages_cred_card_product_certificate_link,
		"fr-FR": fr_FR.academy_pages_cred_card_product_certificate_link,
		"it-IT": it_IT.academy_pages_cred_card_product_certificate_link,
		"ko-KR": ko_KR.academy_pages_cred_card_product_certificate_link,
		"pt-BR": pt_BR.academy_pages_cred_card_product_certificate_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_deliverability_certificate_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_deliverability_certificate_title,
		"en-AU": en_AU.academy_pages_cred_card_deliverability_certificate_title,
		"en-GB": en_GB.academy_pages_cred_card_deliverability_certificate_title,
		"en-US": en_US.academy_pages_cred_card_deliverability_certificate_title,
		"es-ES": es_ES.academy_pages_cred_card_deliverability_certificate_title,
		"fr-FR": fr_FR.academy_pages_cred_card_deliverability_certificate_title,
		"it-IT": it_IT.academy_pages_cred_card_deliverability_certificate_title,
		"ko-KR": ko_KR.academy_pages_cred_card_deliverability_certificate_title,
		"pt-BR": pt_BR.academy_pages_cred_card_deliverability_certificate_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_deliverability_certificate_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_deliverability_certificate_description,
		"en-AU": en_AU.academy_pages_cred_card_deliverability_certificate_description,
		"en-GB": en_GB.academy_pages_cred_card_deliverability_certificate_description,
		"en-US": en_US.academy_pages_cred_card_deliverability_certificate_description,
		"es-ES": es_ES.academy_pages_cred_card_deliverability_certificate_description,
		"fr-FR": fr_FR.academy_pages_cred_card_deliverability_certificate_description,
		"it-IT": it_IT.academy_pages_cred_card_deliverability_certificate_description,
		"ko-KR": ko_KR.academy_pages_cred_card_deliverability_certificate_description,
		"pt-BR": pt_BR.academy_pages_cred_card_deliverability_certificate_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_deliverability_certificate_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_deliverability_certificate_link,
		"en-AU": en_AU.academy_pages_cred_card_deliverability_certificate_link,
		"en-GB": en_GB.academy_pages_cred_card_deliverability_certificate_link,
		"en-US": en_US.academy_pages_cred_card_deliverability_certificate_link,
		"es-ES": es_ES.academy_pages_cred_card_deliverability_certificate_link,
		"fr-FR": fr_FR.academy_pages_cred_card_deliverability_certificate_link,
		"it-IT": it_IT.academy_pages_cred_card_deliverability_certificate_link,
		"ko-KR": ko_KR.academy_pages_cred_card_deliverability_certificate_link,
		"pt-BR": pt_BR.academy_pages_cred_card_deliverability_certificate_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_title,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_title,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_title,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_title,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_title,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_title,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_title,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_title,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_description,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_description,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_description,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_description,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_description,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_description,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_description,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_description,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_link,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_link,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_link,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_link,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_link,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_link,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_link,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_link,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_french_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_french_title,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_french_title,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_french_title,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_french_title,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_french_title,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_french_title,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_french_title,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_french_title,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_french_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_french_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_french_description,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_french_description,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_french_description,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_french_description,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_french_description,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_french_description,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_french_description,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_french_description,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_french_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_developer_certificate_french_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_developer_certificate_french_link,
		"en-AU": en_AU.academy_pages_cred_card_developer_certificate_french_link,
		"en-GB": en_GB.academy_pages_cred_card_developer_certificate_french_link,
		"en-US": en_US.academy_pages_cred_card_developer_certificate_french_link,
		"es-ES": es_ES.academy_pages_cred_card_developer_certificate_french_link,
		"fr-FR": fr_FR.academy_pages_cred_card_developer_certificate_french_link,
		"it-IT": it_IT.academy_pages_cred_card_developer_certificate_french_link,
		"ko-KR": ko_KR.academy_pages_cred_card_developer_certificate_french_link,
		"pt-BR": pt_BR.academy_pages_cred_card_developer_certificate_french_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_omnichannel_strategy_certificate_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"en-AU": en_AU.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"en-GB": en_GB.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"en-US": en_US.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"es-ES": es_ES.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"fr-FR": fr_FR.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"it-IT": it_IT.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"ko-KR": ko_KR.academy_pages_cred_card_omnichannel_strategy_certificate_title,
		"pt-BR": pt_BR.academy_pages_cred_card_omnichannel_strategy_certificate_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_omnichannel_strategy_certificate_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"en-AU": en_AU.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"en-GB": en_GB.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"en-US": en_US.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"es-ES": es_ES.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"fr-FR": fr_FR.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"it-IT": it_IT.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"ko-KR": ko_KR.academy_pages_cred_card_omnichannel_strategy_certificate_description,
		"pt-BR": pt_BR.academy_pages_cred_card_omnichannel_strategy_certificate_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_omnichannel_strategy_certificate_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"en-AU": en_AU.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"en-GB": en_GB.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"en-US": en_US.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"es-ES": es_ES.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"fr-FR": fr_FR.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"it-IT": it_IT.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"ko-KR": ko_KR.academy_pages_cred_card_omnichannel_strategy_certificate_link,
		"pt-BR": pt_BR.academy_pages_cred_card_omnichannel_strategy_certificate_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_sales_certificate_title = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_sales_certificate_title,
		"en-AU": en_AU.academy_pages_cred_card_sales_certificate_title,
		"en-GB": en_GB.academy_pages_cred_card_sales_certificate_title,
		"en-US": en_US.academy_pages_cred_card_sales_certificate_title,
		"es-ES": es_ES.academy_pages_cred_card_sales_certificate_title,
		"fr-FR": fr_FR.academy_pages_cred_card_sales_certificate_title,
		"it-IT": it_IT.academy_pages_cred_card_sales_certificate_title,
		"ko-KR": ko_KR.academy_pages_cred_card_sales_certificate_title,
		"pt-BR": pt_BR.academy_pages_cred_card_sales_certificate_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_sales_certificate_description = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_sales_certificate_description,
		"en-AU": en_AU.academy_pages_cred_card_sales_certificate_description,
		"en-GB": en_GB.academy_pages_cred_card_sales_certificate_description,
		"en-US": en_US.academy_pages_cred_card_sales_certificate_description,
		"es-ES": es_ES.academy_pages_cred_card_sales_certificate_description,
		"fr-FR": fr_FR.academy_pages_cred_card_sales_certificate_description,
		"it-IT": it_IT.academy_pages_cred_card_sales_certificate_description,
		"ko-KR": ko_KR.academy_pages_cred_card_sales_certificate_description,
		"pt-BR": pt_BR.academy_pages_cred_card_sales_certificate_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_cred_card_sales_certificate_link = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_pages_cred_card_sales_certificate_link,
		"en-AU": en_AU.academy_pages_cred_card_sales_certificate_link,
		"en-GB": en_GB.academy_pages_cred_card_sales_certificate_link,
		"en-US": en_US.academy_pages_cred_card_sales_certificate_link,
		"es-ES": es_ES.academy_pages_cred_card_sales_certificate_link,
		"fr-FR": fr_FR.academy_pages_cred_card_sales_certificate_link,
		"it-IT": it_IT.academy_pages_cred_card_sales_certificate_link,
		"ko-KR": ko_KR.academy_pages_cred_card_sales_certificate_link,
		"pt-BR": pt_BR.academy_pages_cred_card_sales_certificate_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_partner_tag = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_partner_tag,
		"en-AU": en_AU.academy_partner_tag,
		"en-GB": en_GB.academy_partner_tag,
		"en-US": en_US.academy_partner_tag,
		"es-ES": es_ES.academy_partner_tag,
		"fr-FR": fr_FR.academy_partner_tag,
		"it-IT": it_IT.academy_partner_tag,
		"ko-KR": ko_KR.academy_partner_tag,
		"pt-BR": pt_BR.academy_partner_tag
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItlay_regionName = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_rates_regionItlay_regionName,
		"en-AU": en_AU.organisms_pricing_rates_regionItlay_regionName,
		"en-GB": en_GB.organisms_pricing_rates_regionItlay_regionName,
		"en-US": en_US.organisms_pricing_rates_regionItlay_regionName,
		"es-ES": es_ES.organisms_pricing_rates_regionItlay_regionName,
		"fr-FR": fr_FR.organisms_pricing_rates_regionItlay_regionName,
		"it-IT": it_IT.organisms_pricing_rates_regionItlay_regionName,
		"ko-KR": ko_KR.organisms_pricing_rates_regionItlay_regionName,
		"pt-BR": pt_BR.organisms_pricing_rates_regionItlay_regionName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_marketingCommunicationsConsent = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_marketingCommunicationsConsent,
		"en-AU": en_AU.organisms_forms_legal_marketingCommunicationsConsent,
		"en-GB": en_GB.organisms_forms_legal_marketingCommunicationsConsent,
		"en-US": en_US.organisms_forms_legal_marketingCommunicationsConsent,
		"es-ES": es_ES.organisms_forms_legal_marketingCommunicationsConsent,
		"fr-FR": fr_FR.organisms_forms_legal_marketingCommunicationsConsent,
		"it-IT": it_IT.organisms_forms_legal_marketingCommunicationsConsent,
		"ko-KR": ko_KR.organisms_forms_legal_marketingCommunicationsConsent,
		"pt-BR": pt_BR.organisms_forms_legal_marketingCommunicationsConsent
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeToTermsOfService = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_agreeToTermsOfService,
		"en-AU": en_AU.organisms_forms_legal_agreeToTermsOfService,
		"en-GB": en_GB.organisms_forms_legal_agreeToTermsOfService,
		"en-US": en_US.organisms_forms_legal_agreeToTermsOfService,
		"es-ES": es_ES.organisms_forms_legal_agreeToTermsOfService,
		"fr-FR": fr_FR.organisms_forms_legal_agreeToTermsOfService,
		"it-IT": it_IT.organisms_forms_legal_agreeToTermsOfService,
		"ko-KR": ko_KR.organisms_forms_legal_agreeToTermsOfService,
		"pt-BR": pt_BR.organisms_forms_legal_agreeToTermsOfService
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeTermsLinkText = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_agreeTermsLinkText,
		"en-AU": en_AU.organisms_forms_legal_agreeTermsLinkText,
		"en-GB": en_GB.organisms_forms_legal_agreeTermsLinkText,
		"en-US": en_US.organisms_forms_legal_agreeTermsLinkText,
		"es-ES": es_ES.organisms_forms_legal_agreeTermsLinkText,
		"fr-FR": fr_FR.organisms_forms_legal_agreeTermsLinkText,
		"it-IT": it_IT.organisms_forms_legal_agreeTermsLinkText,
		"ko-KR": ko_KR.organisms_forms_legal_agreeTermsLinkText,
		"pt-BR": pt_BR.organisms_forms_legal_agreeTermsLinkText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_agreeToPartnerCodeOfConduct = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"en-AU": en_AU.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"en-GB": en_GB.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"en-US": en_US.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"es-ES": es_ES.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"fr-FR": fr_FR.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"it-IT": it_IT.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"ko-KR": ko_KR.organisms_forms_legal_agreeToPartnerCodeOfConduct,
		"pt-BR": pt_BR.organisms_forms_legal_agreeToPartnerCodeOfConduct
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_codeOfConduct_href = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_forms_legal_codeOfConduct_href,
		"en-AU": en_AU.organisms_forms_legal_codeOfConduct_href,
		"en-GB": en_GB.organisms_forms_legal_codeOfConduct_href,
		"en-US": en_US.organisms_forms_legal_codeOfConduct_href,
		"es-ES": es_ES.organisms_forms_legal_codeOfConduct_href,
		"fr-FR": fr_FR.organisms_forms_legal_codeOfConduct_href,
		"it-IT": it_IT.organisms_forms_legal_codeOfConduct_href,
		"ko-KR": ko_KR.organisms_forms_legal_codeOfConduct_href,
		"pt-BR": pt_BR.organisms_forms_legal_codeOfConduct_href
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_buttons_getDemo = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"en-AU": en_AU.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"en-GB": en_GB.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"en-US": en_US.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"es-ES": es_ES.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"fr-FR": fr_FR.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"it-IT": it_IT.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"ko-KR": ko_KR.organisms_pricing_plans_maxContacts_buttons_getDemo,
		"pt-BR": pt_BR.organisms_pricing_plans_maxContacts_buttons_getDemo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_richTextBody = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_maxContacts_richTextBody,
		"en-AU": en_AU.organisms_pricing_plans_maxContacts_richTextBody,
		"en-GB": en_GB.organisms_pricing_plans_maxContacts_richTextBody,
		"en-US": en_US.organisms_pricing_plans_maxContacts_richTextBody,
		"es-ES": es_ES.organisms_pricing_plans_maxContacts_richTextBody,
		"fr-FR": fr_FR.organisms_pricing_plans_maxContacts_richTextBody,
		"it-IT": it_IT.organisms_pricing_plans_maxContacts_richTextBody,
		"ko-KR": ko_KR.organisms_pricing_plans_maxContacts_richTextBody,
		"pt-BR": pt_BR.organisms_pricing_plans_maxContacts_richTextBody
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_maxContacts_headline = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.organisms_pricing_plans_maxContacts_headline,
		"en-AU": en_AU.organisms_pricing_plans_maxContacts_headline,
		"en-GB": en_GB.organisms_pricing_plans_maxContacts_headline,
		"en-US": en_US.organisms_pricing_plans_maxContacts_headline,
		"es-ES": es_ES.organisms_pricing_plans_maxContacts_headline,
		"fr-FR": fr_FR.organisms_pricing_plans_maxContacts_headline,
		"it-IT": it_IT.organisms_pricing_plans_maxContacts_headline,
		"ko-KR": ko_KR.organisms_pricing_plans_maxContacts_headline,
		"pt-BR": pt_BR.organisms_pricing_plans_maxContacts_headline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_results = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.helpCenter_templates_search_results,
		"en-AU": en_AU.helpCenter_templates_search_results,
		"en-GB": en_GB.helpCenter_templates_search_results,
		"en-US": en_US.helpCenter_templates_search_results,
		"es-ES": es_ES.helpCenter_templates_search_results,
		"fr-FR": fr_FR.helpCenter_templates_search_results,
		"it-IT": it_IT.helpCenter_templates_search_results,
		"ko-KR": ko_KR.helpCenter_templates_search_results,
		"pt-BR": pt_BR.helpCenter_templates_search_results
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "de-DE" | "en-AU" | "en-GB" | "en-US" | "es-ES" | "fr-FR" | "it-IT" | "ko-KR" | "pt-BR" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registed = (params = {}, options = {}) => {
	return {
		"de-DE": de_DE.academy_courseStatus_registed,
		"en-AU": en_AU.academy_courseStatus_registed,
		"en-GB": en_GB.academy_courseStatus_registed,
		"en-US": en_US.academy_courseStatus_registed,
		"es-ES": es_ES.academy_courseStatus_registed,
		"fr-FR": fr_FR.academy_courseStatus_registed,
		"it-IT": it_IT.academy_courseStatus_registed,
		"ko-KR": ko_KR.academy_courseStatus_registed,
		"pt-BR": pt_BR.academy_courseStatus_registed
	}[options.languageTag ?? languageTag()]()
}

